/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema-types';

import { GraphQLClient, type RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export * from './schema-types';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export type AccordionTierFeatureCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type AccordionTierFeatureCardFragment_asset_fallbackImage = { url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string };

export type AccordionTierFeatureCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AccordionTierFeatureCardFragment_buttons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionTierFeatureCardFragment_buttons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type AccordionTierFeatureCardFragment_buttons =
  | AccordionTierFeatureCardFragment_buttons_CosmosElementButton
  | AccordionTierFeatureCardFragment_buttons_CosmosElementIconButton
;

export type AccordionTierFeatureCardFragment = { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: AccordionTierFeatureCardFragment_title | null, asset?: AccordionTierFeatureCardFragment_asset | null, buttons: Array<AccordionTierFeatureCardFragment_buttons> };

export type AccordionTierCtaCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type AccordionTierCtaCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AccordionTierCtaCardFragment_buttons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionTierCtaCardFragment_buttons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type AccordionTierCtaCardFragment_buttons =
  | AccordionTierCtaCardFragment_buttons_CosmosElementButton
  | AccordionTierCtaCardFragment_buttons_CosmosElementIconButton
;

export type AccordionTierCtaCardFragment = { __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, title?: AccordionTierCtaCardFragment_title | null, asset?: AccordionTierCtaCardFragment_asset | null, buttons: Array<AccordionTierCtaCardFragment_buttons> };

export type AccordionTierCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type AccordionTierCardFragment_items_CosmosElementAccordionTierCtaCard = { __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, title?: AccordionTierCtaCardFragment_title | null, asset?: AccordionTierCtaCardFragment_asset | null, buttons: Array<AccordionTierCtaCardFragment_buttons> };

export type AccordionTierCardFragment_items_CosmosElementAccordionTierFeatureCard = { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: AccordionTierFeatureCardFragment_title | null, asset?: AccordionTierFeatureCardFragment_asset | null, buttons: Array<AccordionTierFeatureCardFragment_buttons> };

export type AccordionTierCardFragment_items =
  | AccordionTierCardFragment_items_CosmosElementAccordionTierCtaCard
  | AccordionTierCardFragment_items_CosmosElementAccordionTierFeatureCard
;

export type AccordionTierCardFragment = { __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: AccordionTierCardFragment_title | null, items: Array<AccordionTierCardFragment_items> };

export type AccordionTierCardsSectionFragment_config_heading_title = { __typename: 'RichText', html: string, text: string };

export type AccordionTierCardsSectionFragment_config_heading_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionTierCardsSectionFragment_config_heading_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionTierCardsSectionFragment_config_heading_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type AccordionTierCardsSectionFragment_config_heading_modButtons =
  | AccordionTierCardsSectionFragment_config_heading_modButtons_CosmosElementButton
  | AccordionTierCardsSectionFragment_config_heading_modButtons_CosmosElementIconButton
;

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title = { __typename: 'RichText', html: string, text: string };

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons =
  | AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons_CosmosElementButton
  | AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons_CosmosElementIconButton
;

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementIconSectionHeading = { __typename: 'CosmosElementIconSectionHeading', icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, titleGradient?: Types.CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_modButtons> };

export type AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type AccordionTierCardsSectionFragment_config_heading =
  | AccordionTierCardsSectionFragment_config_heading_CosmosElementIconSectionHeading
  | AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading
;

export type AccordionTierCardsSectionFragment_config_backgroundImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AccordionTierCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type AccordionTierCardsSectionFragment_items = { __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: AccordionTierCardFragment_title | null, items: Array<AccordionTierCardFragment_items> };

export type AccordionTierCardsSectionFragment = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: AccordionTierCardsSectionFragment_config | null, items: Array<AccordionTierCardsSectionFragment_items> };

export type AriesCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type AriesCardFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AriesCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AriesCardFragment = { id: string, icon?: Types.EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: AriesCardFragment_title | null, buttons: Array<AriesCardFragment_buttons>, asset?: AriesCardFragment_asset | null };

export type AriesCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type AriesCardsSectionFragment_cards = { id: string, icon?: Types.EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: AriesCardFragment_title | null, buttons: Array<AriesCardFragment_buttons>, asset?: AriesCardFragment_asset | null };

export type AriesCardsSectionFragment = { __typename: 'CosmosSectionAriesCards', id: string, config?: AriesCardsSectionFragment_config | null, cards: Array<AriesCardsSectionFragment_cards> };

export type AssetCarouselSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type AssetCarouselSectionFragment_assets = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AssetCarouselSectionFragment = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type AssetGallerySectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type AssetGallerySectionFragment_assets = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AssetGallerySectionFragment = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type CosmosAssetFragment = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosImageFragment = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null };

export type AssetSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type AssetSectionFragment_sectionAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AssetSectionFragment = { __typename: 'CosmosSectionAsset', id: string, size?: Types.CosmosEnumSectionSizes | null, caption?: string | null, config?: AssetSectionFragment_config | null, sectionAsset: AssetSectionFragment_sectionAsset };

export type CosmosButtonFragment = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CosmosIconButtonFragment = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

type CosmosModButton_CosmosElementButton_Fragment = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

type CosmosModButton_CosmosElementIconButton_Fragment = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosModButtonFragment =
  | CosmosModButton_CosmosElementButton_Fragment
  | CosmosModButton_CosmosElementIconButton_Fragment
;

export type CosmosDownloadButtonFragment_mobileDisclaimer = { __typename: 'RichText', html: string, text: string };

export type CosmosDownloadButtonFragment = { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: CosmosDownloadButtonFragment_mobileDisclaimer | null };

export type CosmosRichTextFragment = { __typename: 'RichText', html: string, text: string };

export type CosmosLinkFragment = { label?: string | null, href?: string | null, icon?: Types.CosmosEnumLinkIcons | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosTagFragment = { href?: string | null, label?: string | null };

export type CosmosAvatarFragment_imageAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosAvatarFragment = { href?: string | null, label?: string | null, imageSrc?: string | null, color?: Types.CosmosEnumAvatarColors | null, imageAsset?: CosmosAvatarFragment_imageAsset | null };

export type CosmosVideoEmbedFragment_overlayImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosVideoEmbedFragment = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

export type CosmosGitHubGistFragment = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

export type CosmosCompareFragment_leftImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosCompareFragment_rightImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosCompareFragment = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: CosmosCompareFragment_leftImage | null, rightImage?: CosmosCompareFragment_rightImage | null };

export type CosmosEdsIconLinkFragment = { ariaLabel?: string | null, href?: string | null, icon?: Types.EdsIconsEnum | null };

export type CosmosIconLinkGroupFragment_edsIconLinks = { ariaLabel?: string | null, href?: string | null, icon?: Types.EdsIconsEnum | null };

export type CosmosIconLinkGroupFragment = { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<CosmosIconLinkGroupFragment_edsIconLinks> };

export type CosmosInterviewFragment_questions = { question?: string | null, answer?: string | null };

export type CosmosInterviewFragment = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<CosmosInterviewFragment_questions> };

export type CosmosQuoteFragment = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type CosmosCalloutCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type CosmosCalloutCardFragment_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosCalloutCardFragment = { __typename: 'CosmosElementCalloutCard', icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: CosmosCalloutCardFragment_title | null, buttons: Array<CosmosCalloutCardFragment_buttons> };

export type CosmosTitleAndDescFragment_title = { __typename: 'RichText', html: string, text: string };

export type CosmosTitleAndDescFragment = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type CosmosPluginDownloadDetailFragment = { __typename: 'CosmosElementPluginDownloadDetail', operatingSystem?: Types.CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null };

export type CosmosPluginDownloadFragment_details = { __typename: 'CosmosElementPluginDownloadDetail', operatingSystem?: Types.CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null };

export type CosmosPluginDownloadFragment = { title?: string | null, desc?: string | null, details: Array<CosmosPluginDownloadFragment_details> };

export type WfRefApplicationOwnerFragment = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type BlobTableSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type BlobTableSectionFragment = { __typename: 'CosmosSectionBlobTable', id: string, environmentVariable: string, limit?: number | null, variant?: Types.CosmosEnumBlobTableVariants | null, config?: BlobTableSectionFragment_config | null };

export type BlogCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type BlogCardFragment_category_tag = { __typename: 'WfRefBlogTag', id: string, tagId: string, label: string };

export type BlogCardFragment_category = { __typename: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: BlogCardFragment_category_tag | null };

export type BlogCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type BlogCardFragment_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type BlogCardFragment = { __typename: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: BlogCardFragment_asset | null, category?: BlogCardFragment_category | null, title?: BlogCardFragment_title | null, buttons: Array<BlogCardFragment_buttons> };

export type BlogCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type BlogCardsSectionFragment_cards = { __typename: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: BlogCardFragment_asset | null, category?: BlogCardFragment_category | null, title?: BlogCardFragment_title | null, buttons: Array<BlogCardFragment_buttons> };

export type BlogCardsSectionFragment = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: Types.CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: BlogCardsSectionFragment_config | null, cards: Array<BlogCardsSectionFragment_cards> };

export type CommunitySectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CommunitySectionFragment_forumButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CommunitySectionFragment_resources_cards_link = { label?: string | null, href?: string | null, icon?: Types.CosmosEnumLinkIcons | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CommunitySectionFragment_resources_cards = { title?: string | null, description?: string | null, iconType?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, link?: CommunitySectionFragment_resources_cards_link | null };

export type CommunitySectionFragment_resources = { title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<CommunitySectionFragment_resources_cards> };

export type CommunitySectionFragment = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: Types.CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: CommunitySectionFragment_config | null, forumButton?: CommunitySectionFragment_forumButton | null, resources?: CommunitySectionFragment_resources | null };

export type CommunityResourceFragmentFragment = { title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<CommunitySectionFragment_resources_cards> };

export type CommunityCardFragmentFragment = { title?: string | null, description?: string | null, iconType?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, link?: CommunitySectionFragment_resources_cards_link | null };

export type ComplexCtaCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type ComplexCtaCardFragment_button = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type ComplexCtaCardFragment = { icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: ComplexCtaCardFragment_title | null, button?: ComplexCtaCardFragment_button | null };

export type ComplexCtaCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type ComplexCtaCardsSectionFragment_cards = { icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: ComplexCtaCardFragment_title | null, button?: ComplexCtaCardFragment_button | null };

export type ComplexCtaCardsSectionFragment_bottomDescription = { __typename: 'RichText', html: string, text: string };

export type ComplexCtaCardsSectionFragment = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: Types.CosmosEnumComplexCtaVariant | null, config?: ComplexCtaCardsSectionFragment_config | null, cards: Array<ComplexCtaCardsSectionFragment_cards>, bottomDescription?: ComplexCtaCardsSectionFragment_bottomDescription | null };

export type ContentLargeImageFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type ContentLargeImageFragment_badges = { href?: string | null, label?: string | null };

export type ContentLargeImageFragment_title = { __typename: 'RichText', html: string, text: string };

export type ContentLargeImageFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type ContentLargeImageFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type ContentLargeImageFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type ContentLargeImageFragment_modButtons =
  | ContentLargeImageFragment_modButtons_CosmosElementButton
  | ContentLargeImageFragment_modButtons_CosmosElementIconButton
;

export type ContentLargeImageFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type ContentLargeImageFragment_blurredImage = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string };

export type ContentLargeImageFragment = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type ContentSliderAssetFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type ContentSliderAssetFragment_badges = { href?: string | null, label?: string | null };

export type ContentSliderAssetFragment_title = { __typename: 'RichText', html: string, text: string };

export type ContentSliderAssetFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type ContentSliderAssetFragment_assets = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type ContentSliderAssetFragment = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentSliderAssetFragment_config | null, badges: Array<ContentSliderAssetFragment_badges>, title?: ContentSliderAssetFragment_title | null, buttons: Array<ContentSliderAssetFragment_buttons>, assets: Array<ContentSliderAssetFragment_assets> };

export type CruxLinkFragment = { label?: string | null, href?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type CruxSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CruxSectionFragment_cruxLinks = { label?: string | null, href?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type CruxSectionFragment = { __typename: 'CosmosSectionCrux', id: string, config?: CruxSectionFragment_config | null, cruxLinks: Array<CruxSectionFragment_cruxLinks> };

export type DelphinusCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type DelphinusCardFragment_badge = { label?: string | null, href?: string | null };

export type DelphinusCardFragment_avatar = { href?: string | null, label?: string | null, imageSrc?: string | null, color?: Types.CosmosEnumAvatarColors | null, imageAsset?: CosmosAvatarFragment_imageAsset | null };

export type DelphinusCardFragment = { id: string, preHeading?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: Types.CosmosEnumIconPosition | null, asset?: DelphinusCardFragment_asset | null, badge?: DelphinusCardFragment_badge | null, avatar?: DelphinusCardFragment_avatar | null };

export type DelphinusCardsGridSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type DelphinusCardsGridSectionFragment_grid = { id: string, preHeading?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: Types.CosmosEnumIconPosition | null, asset?: DelphinusCardFragment_asset | null, badge?: DelphinusCardFragment_badge | null, avatar?: DelphinusCardFragment_avatar | null };

export type DelphinusCardsGridSectionFragment = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: DelphinusCardsGridSectionFragment_config | null, grid: Array<DelphinusCardsGridSectionFragment_grid> };

export type DevelopersListSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type DevelopersListSectionFragment_developersTsv = { url: string, mimeType?: string | null };

export type DevelopersListSectionFragment = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: DevelopersListSectionFragment_config | null, developersTsv?: DevelopersListSectionFragment_developersTsv | null };

export type PageDirectoryMetadataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageDirectoryMetadataFragment_metaTags_openGraphImage = { url: string, width?: number | null, height?: number | null };

export type PageDirectoryMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageDirectoryMetadataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageDirectoryMetadataFragment_owner | null, metaTags?: PageDirectoryMetadataFragment_metaTags | null };

export type ServicePartnerDetailFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type ServicePartnerDetailFragment_blurredBackgroundImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type ServicePartnerDetailFragment = { __typename: 'CosmosDetailServicePartner', id: string, config?: ServicePartnerDetailFragment_config | null, blurredBackgroundImage?: ServicePartnerDetailFragment_blurredBackgroundImage | null };

export type PageDirectoryEntitiesFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageDirectoryEntitiesFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_hero =
  | PageDirectoryEntitiesFragment_hero_CosmosHeroAlpha
  | PageDirectoryEntitiesFragment_hero_CosmosHeroArticleImage
  | PageDirectoryEntitiesFragment_hero_CosmosHeroBravo
  | PageDirectoryEntitiesFragment_hero_CosmosHeroGlow
;

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAccordionFeatureCard = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAccordionTierCards = { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAriesCards = { __typename: 'CosmosSectionAriesCards', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAsset = { __typename: 'CosmosSectionAsset', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionBlobTable = { __typename: 'CosmosSectionBlobTable', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionBlogCard = { __typename: 'CosmosSectionBlogCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionCkRichText = { __typename: 'CosmosSectionCkRichText', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionCommunity = { __typename: 'CosmosSectionCommunity', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionComplexCtaCard = { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionContentSliderAsset = { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionCrux = { __typename: 'CosmosSectionCrux', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDelphinusCardsGrid = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDevelopersList = { __typename: 'CosmosSectionDevelopersList', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDownloadCard = { __typename: 'CosmosSectionDownloadCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDownloadable = { __typename: 'CosmosSectionDownloadable', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionEmbed = { __typename: 'CosmosSectionEmbed', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionEventsTable = { __typename: 'CosmosSectionEventsTable', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionFaq = { __typename: 'CosmosSectionFaq', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionFaqSearch = { __typename: 'CosmosSectionFaqSearch', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionFeatureCard = { __typename: 'CosmosSectionFeatureCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionGameDevFeatureCard = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionGeminiCard = { __typename: 'CosmosSectionGeminiCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionHydrusColumnList = { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLatestNews = { __typename: 'CosmosSectionLatestNews', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLearn = { __typename: 'CosmosSectionLearn', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLicensesCollapsed = { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNewsCard = { __typename: 'CosmosSectionNewsCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNewsletterSignup = { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNumberCallout = { __typename: 'CosmosSectionNumberCallout', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionOrionCards = { __typename: 'CosmosSectionOrionCards', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionPluginListTable = { __typename: 'CosmosSectionPluginListTable', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionQuote = { __typename: 'CosmosSectionQuote', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionResellersSearch = { __typename: 'CosmosSectionResellersSearch', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionRichText = { __typename: 'CosmosSectionRichText', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionSlimContactCard = { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionSpeakerCard = { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionTabbedBlogCard = { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionTabbedContentImage = { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionTabbedFullWidthAsset = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionUtCard = { __typename: 'CosmosSectionUtCard', id: string, stage: Types.Stage };

export type PageDirectoryEntitiesFragment_topRefSections_section =
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAccordionFeatureCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAccordionTierCards
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAriesCards
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAsset
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAssetCarousel
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionAssetGallery
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionBlobTable
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionBlogCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionCkRichText
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionCommunity
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionComplexCtaCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionContentLargeImage
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionContentSliderAsset
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionCrux
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDelphinusCardsGrid
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDevelopersList
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDivider
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDownloadCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionDownloadable
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionEmbed
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionEventsTable
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionFaq
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionFaqSearch
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionFeatureCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionGameDevFeatureCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionGeminiCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionHydrusColumnList
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLatestNews
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLearn
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLicensesCollapsed
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLogoList
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionLogoMultiCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNewsCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNewsMediaCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNewsletterSignup
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionNumberCallout
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionOrionCards
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionPluginListTable
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionQuote
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionResellersSearch
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionRichText
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionSimpleCta
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionSlimContactCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionSpeakerCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionTabbedBlogCard
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionTabbedContentImage
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionTabbedFullWidthAsset
  | PageDirectoryEntitiesFragment_topRefSections_section_CosmosSectionUtCard
;

export type PageDirectoryEntitiesFragment_topRefSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type PageDirectoryEntitiesFragment_bottomRefSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type PageDirectoryEntitiesFragment_servicePartnerDetail = { __typename: 'CosmosDetailServicePartner', id: string, config?: ServicePartnerDetailFragment_config | null, blurredBackgroundImage?: ServicePartnerDetailFragment_blurredBackgroundImage | null };

export type PageDirectoryEntitiesFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, variant: Types.CosmosEnumDirectoryVariant, directoryEyebrow?: string | null, directoryTitle?: string | null, directoryDesc?: string | null, searchPlaceholder?: string | null, industryFilterLabel?: string | null, serviceFilterLabel?: string | null, serviceFilterPlaceholder?: string | null, noResultsLabel?: string | null, owner?: PageDirectoryEntitiesFragment_owner | null, hero?: PageDirectoryEntitiesFragment_hero | null, topRefSections: Array<PageDirectoryEntitiesFragment_topRefSections>, bottomRefSections: Array<PageDirectoryEntitiesFragment_bottomRefSections>, servicePartnerDetail?: PageDirectoryEntitiesFragment_servicePartnerDetail | null };

export type DividerSectionFragment = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type DocumentListItemFragment = { icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, title?: string | null, href?: string | null };

export type DocumentListFragment_items = { icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, title?: string | null, href?: string | null };

export type DocumentListFragment = { listId?: string | null, heading?: string | null, items: Array<DocumentListFragment_items> };

export type CosmosCtaRichTextFragment_text = { __typename: 'RichText', html: string, text: string };

export type CosmosCtaRichTextFragment = { text: CosmosCtaRichTextFragment_text };

export type DownloadCardCtaLinkFragment = { label?: string | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null, linkIcon?: Types.CosmosEnumLinkIcons | null };

type DownloadCardCta_CosmosElementButton_Fragment = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

type DownloadCardCta_CosmosElementDownloadButton_Fragment = { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: CosmosDownloadButtonFragment_mobileDisclaimer | null };

type DownloadCardCta_CosmosElementIconButton_Fragment = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

type DownloadCardCta_CosmosElementLink_Fragment = { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null, linkIcon?: Types.CosmosEnumLinkIcons | null };

type DownloadCardCta_CosmosElementRichText_Fragment = { __typename: 'CosmosElementRichText', text: CosmosCtaRichTextFragment_text };

export type DownloadCardCtaFragment =
  | DownloadCardCta_CosmosElementButton_Fragment
  | DownloadCardCta_CosmosElementDownloadButton_Fragment
  | DownloadCardCta_CosmosElementIconButton_Fragment
  | DownloadCardCta_CosmosElementLink_Fragment
  | DownloadCardCta_CosmosElementRichText_Fragment
;

export type DownloadCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type DownloadCardFragment_description = { __typename: 'RichText', html: string, text: string };

export type DownloadCardFragment_cta_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type DownloadCardFragment_cta_CosmosElementDownloadButton = { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: CosmosDownloadButtonFragment_mobileDisclaimer | null };

export type DownloadCardFragment_cta_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type DownloadCardFragment_cta_CosmosElementLink = { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null, linkIcon?: Types.CosmosEnumLinkIcons | null };

export type DownloadCardFragment_cta_CosmosElementRichText = { __typename: 'CosmosElementRichText', text: CosmosCtaRichTextFragment_text };

export type DownloadCardFragment_cta =
  | DownloadCardFragment_cta_CosmosElementButton
  | DownloadCardFragment_cta_CosmosElementDownloadButton
  | DownloadCardFragment_cta_CosmosElementIconButton
  | DownloadCardFragment_cta_CosmosElementLink
  | DownloadCardFragment_cta_CosmosElementRichText
;

export type DownloadCardFragment = { titleIcon?: Types.EdsIconsEnum | null, title: DownloadCardFragment_title, description: DownloadCardFragment_description, cta?: DownloadCardFragment_cta | null };

export type DownloadStepFragment_content = { titleIcon?: Types.EdsIconsEnum | null, title: DownloadCardFragment_title, description: DownloadCardFragment_description, cta?: DownloadCardFragment_cta | null };

export type DownloadStepFragment = { __typename: 'CosmosElementDownloadStep', gradient?: Types.CosmosEnumEdsGradients | null, label?: string | null, content: Array<DownloadStepFragment_content> };

export type DownloadCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type DownloadCardsSectionFragment_steps = { __typename: 'CosmosElementDownloadStep', gradient?: Types.CosmosEnumEdsGradients | null, label?: string | null, content: Array<DownloadStepFragment_content> };

export type DownloadCardsSectionFragment_footer = { titleIcon?: Types.EdsIconsEnum | null, title: DownloadCardFragment_title, description: DownloadCardFragment_description, cta?: DownloadCardFragment_cta | null };

export type DownloadCardsSectionFragment = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

export type DownloadableSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type DownloadableSectionFragment_instructions_section_CosmosSectionDownloadCard = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

export type DownloadableSectionFragment_instructions_section =
  | DownloadableSectionFragment_instructions_section_CosmosSectionDownloadCard
  | Record<PropertyKey, never>
;

export type DownloadableSectionFragment_instructions = { __typename: 'CosmosReferenceSection', id: string, section?: DownloadableSectionFragment_instructions_section | null };

export type DownloadableSectionFragment_executables = { titleIcon?: Types.EdsIconsEnum | null, title: DownloadCardFragment_title, description: DownloadCardFragment_description, cta?: DownloadCardFragment_cta | null };

export type DownloadableSectionFragment_footer = { titleIcon?: Types.EdsIconsEnum | null, title: DownloadCardFragment_title, description: DownloadCardFragment_description, cta?: DownloadCardFragment_cta | null };

export type DownloadableSectionFragment = { __typename: 'CosmosSectionDownloadable', id: string, config?: DownloadableSectionFragment_config | null, instructions?: DownloadableSectionFragment_instructions | null, executables: Array<DownloadableSectionFragment_executables>, footer?: DownloadableSectionFragment_footer | null };

export type EmbedSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type EmbedSectionFragment_embed = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

export type EmbedSectionFragment = { __typename: 'CosmosSectionEmbed', id: string, size?: Types.CosmosEnumSectionSizes | null, config?: EmbedSectionFragment_config | null, embed?: EmbedSectionFragment_embed | null };

export type EventsTableRowFragment_description = { __typename: 'RichText', html: string, text: string };

export type EventsTableRowFragment = { id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any, endTimeAndDate?: any, timeZone?: Types.CosmosEnumTimeZone | null, timeAndDateFormat?: Types.CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: EventsTableRowFragment_description | null };

export type EventsTableSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type EventsTableSectionFragment_blurredImage = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string };

export type EventsTableSectionFragment_events = { id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any, endTimeAndDate?: any, timeZone?: Types.CosmosEnumTimeZone | null, timeAndDateFormat?: Types.CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: EventsTableRowFragment_description | null };

export type EventsTableSectionFragment = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: EventsTableSectionFragment_config | null, blurredImage?: EventsTableSectionFragment_blurredImage | null, events: Array<EventsTableSectionFragment_events> };

export type FaqTabElementFragment_items_question = { __typename: 'RichText', html: string, text: string };

export type FaqTabElementFragment_items_answer = { __typename: 'RichText', html: string, text: string };

export type FaqTabElementFragment_items = { __typename: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: FaqTabElementFragment_items_question | null, answer?: FaqTabElementFragment_items_answer | null };

export type FaqTabElementFragment_refFaqItems = { id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null };

export type FaqTabElementFragment = { __typename: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<FaqTabElementFragment_items>, refFaqItems: Array<FaqTabElementFragment_refFaqItems> };

export type FaqSearchSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type FaqSearchSectionFragment_title = { __typename: 'RichText', html: string, text: string };

export type FaqSearchSectionFragment_faqTabs = { __typename: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<FaqTabElementFragment_items>, refFaqItems: Array<FaqTabElementFragment_refFaqItems> };

export type FaqSearchSectionFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type FaqSearchSectionFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type FaqSearchSectionFragment_modButtons =
  | FaqSearchSectionFragment_modButtons_CosmosElementButton
  | FaqSearchSectionFragment_modButtons_CosmosElementIconButton
;

export type FaqSearchSectionFragment = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSearchSectionFragment_config | null, title?: FaqSearchSectionFragment_title | null, faqTabs: Array<FaqSearchSectionFragment_faqTabs>, modButtons: Array<FaqSearchSectionFragment_modButtons> };

export type FaqItemElementFragment = { __typename: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: FaqTabElementFragment_items_question | null, answer?: FaqTabElementFragment_items_answer | null };

export type RefFaqItemElementFragment = { id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null };

export type FaqSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type FaqSectionFragment_title = { __typename: 'RichText', html: string, text: string };

export type FaqSectionFragment_items = { __typename: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: FaqTabElementFragment_items_question | null, answer?: FaqTabElementFragment_items_answer | null };

export type FaqSectionFragment_refFaqItems = { id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null };

export type FaqSectionFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type FaqSectionFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type FaqSectionFragment_modButtons =
  | FaqSectionFragment_modButtons_CosmosElementButton
  | FaqSectionFragment_modButtons_CosmosElementIconButton
;

export type FaqSectionFragment_faqButtons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type FaqSectionFragment = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSectionFragment_config | null, title?: FaqSectionFragment_title | null, items: Array<FaqSectionFragment_items>, refFaqItems: Array<FaqSectionFragment_refFaqItems>, modButtons: Array<FaqSectionFragment_modButtons>, faqButtons: Array<FaqSectionFragment_faqButtons> };

export type FeatureCardFragment_img = { __typename: 'Asset', url: string, width?: number | null, height?: number | null };

export type FeatureCardFragment = { __typename: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: FeatureCardFragment_img };

export type FeatureCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type FeatureCardsSectionFragment_tags = { href?: string | null, label?: string | null };

export type FeatureCardsSectionFragment_cards = { __typename: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: FeatureCardFragment_img };

export type FeatureCardsSectionFragment = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: FeatureCardsSectionFragment_config | null, tags: Array<FeatureCardsSectionFragment_tags>, cards: Array<FeatureCardsSectionFragment_cards> };

export type AccordionFeatureCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type AccordionFeatureCardFragment_cards_eyebrowBadges = { href?: string | null, label?: string | null };

export type AccordionFeatureCardFragment_cards_title = { __typename: 'RichText', html: string, text: string };

export type AccordionFeatureCardFragment_cards_links = { id: string, href?: string | null, label?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null, icon?: Types.CosmosEnumLinkIcons | null };

export type AccordionFeatureCardFragment_cards_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionFeatureCardFragment_cards_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type AccordionFeatureCardFragment_cards_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type AccordionFeatureCardFragment_cards_modButtons =
  | AccordionFeatureCardFragment_cards_modButtons_CosmosElementButton
  | AccordionFeatureCardFragment_cards_modButtons_CosmosElementIconButton
;

export type AccordionFeatureCardFragment_cards_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type AccordionFeatureCardFragment_cards = { eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<AccordionFeatureCardFragment_cards_eyebrowBadges>, title?: AccordionFeatureCardFragment_cards_title | null, links: Array<AccordionFeatureCardFragment_cards_links>, buttons: Array<AccordionFeatureCardFragment_cards_buttons>, modButtons: Array<AccordionFeatureCardFragment_cards_modButtons>, asset?: AccordionFeatureCardFragment_cards_asset | null };

export type AccordionFeatureCardFragment = { defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: AccordionFeatureCardFragment_title | null, cards: Array<AccordionFeatureCardFragment_cards> };

export type AccordionFeatureCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type AccordionFeatureCardsSectionFragment_items = { defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: AccordionFeatureCardFragment_title | null, cards: Array<AccordionFeatureCardFragment_cards> };

export type AccordionFeatureCardsSectionFragment = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: AccordionFeatureCardsSectionFragment_config | null, items: Array<AccordionFeatureCardsSectionFragment_items> };

export type LinkListItemFragment = { id: string, href?: string | null, label?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null, icon?: Types.CosmosEnumLinkIcons | null };

export type FeaturePanelFragment = { eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<AccordionFeatureCardFragment_cards_eyebrowBadges>, title?: AccordionFeatureCardFragment_cards_title | null, links: Array<AccordionFeatureCardFragment_cards_links>, buttons: Array<AccordionFeatureCardFragment_cards_buttons>, modButtons: Array<AccordionFeatureCardFragment_cards_modButtons>, asset?: AccordionFeatureCardFragment_cards_asset | null };

export type FeaturePanelsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type FeaturePanelsSectionFragment_cards = { eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<AccordionFeatureCardFragment_cards_eyebrowBadges>, title?: AccordionFeatureCardFragment_cards_title | null, links: Array<AccordionFeatureCardFragment_cards_links>, buttons: Array<AccordionFeatureCardFragment_cards_buttons>, modButtons: Array<AccordionFeatureCardFragment_cards_modButtons>, asset?: AccordionFeatureCardFragment_cards_asset | null };

export type FeaturePanelsSectionFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type FeaturePanelsSectionFragment = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: FeaturePanelsSectionFragment_config | null, cards: Array<FeaturePanelsSectionFragment_cards>, buttons: Array<FeaturePanelsSectionFragment_buttons> };

export type GeminiLinkFragment = { id: string, label?: string | null, href?: string | null, endIcon?: Types.CosmosEnumLinkIcons | null, edsIcon?: Types.EdsIconsEnum | null };

export type GeminiCardFragment_heading = { __typename: 'RichText', html: string, text: string };

export type GeminiCardFragment_badge = { label?: string | null, href?: string | null };

export type GeminiCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type GeminiCardFragment_links = { id: string, label?: string | null, href?: string | null, endIcon?: Types.CosmosEnumLinkIcons | null, edsIcon?: Types.EdsIconsEnum | null };

export type GeminiCardFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type GeminiCardFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type GeminiCardFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type GeminiCardFragment_modButtons =
  | GeminiCardFragment_modButtons_CosmosElementButton
  | GeminiCardFragment_modButtons_CosmosElementIconButton
;

export type GeminiCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type GeminiCardFragment = { id: string, eyebrow?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: Types.CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: GeminiCardFragment_heading | null, badge?: GeminiCardFragment_badge | null, title?: GeminiCardFragment_title | null, links: Array<GeminiCardFragment_links>, buttons: Array<GeminiCardFragment_buttons>, modButtons: Array<GeminiCardFragment_modButtons>, asset?: GeminiCardFragment_asset | null };

export type GeminiCardsSectionFragment_logoImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type GeminiCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type GeminiCardsSectionFragment_title = { __typename: 'RichText', html: string, text: string };

export type GeminiCardsSectionFragment_cards = { id: string, eyebrow?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: Types.CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: GeminiCardFragment_heading | null, badge?: GeminiCardFragment_badge | null, title?: GeminiCardFragment_title | null, links: Array<GeminiCardFragment_links>, buttons: Array<GeminiCardFragment_buttons>, modButtons: Array<GeminiCardFragment_modButtons>, asset?: GeminiCardFragment_asset | null };

export type GeminiCardsSectionFragment = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: Types.CosmosEnumGeminiVariants | null, logoImage?: GeminiCardsSectionFragment_logoImage | null, config?: GeminiCardsSectionFragment_config | null, title?: GeminiCardsSectionFragment_title | null, cards: Array<GeminiCardsSectionFragment_cards> };

export type HeroAlphaMainStackFragment_logoImage = { __typename: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null };

export type HeroAlphaMainStackFragment_title = { html: string, text: string };

export type HeroAlphaMainStackFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroAlphaMainStackFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroAlphaMainStackFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type HeroAlphaMainStackFragment_modButtons =
  | HeroAlphaMainStackFragment_modButtons_CosmosElementButton
  | HeroAlphaMainStackFragment_modButtons_CosmosElementIconButton
;

export type HeroAlphaMainStackFragment = { logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type HeroAlphaFragment_blurredImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type HeroAlphaFragment_heroAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type HeroAlphaFragment = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type HeroGlowFragment_blurredImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type HeroGlowFragment_logoImage = { __typename: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null };

export type HeroGlowFragment_title = { __typename: 'RichText', html: string, text: string };

export type HeroGlowFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroGlowFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type HeroGlowFragment_modButtons =
  | HeroGlowFragment_modButtons_CosmosElementButton
  | HeroGlowFragment_modButtons_CosmosElementIconButton
;

export type HeroGlowFragment = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type HeroArticleImageFragment_title = { __typename: 'RichText', html: string, text: string };

export type HeroArticleImageFragment_description = { __typename: 'RichText', html: string, text: string };

export type HeroArticleImageFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroArticleImageFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroArticleImageFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type HeroArticleImageFragment_modButtons =
  | HeroArticleImageFragment_modButtons_CosmosElementButton
  | HeroArticleImageFragment_modButtons_CosmosElementIconButton
;

export type HeroArticleImageFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type HeroArticleImageFragment_backgroundAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type HeroArticleImageFragment = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type HeroBravoFragment_title = { __typename: 'RichText', html: string, text: string };

export type HeroBravoFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroBravoFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type HeroBravoFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type HeroBravoFragment_modButtons =
  | HeroBravoFragment_modButtons_CosmosElementButton
  | HeroBravoFragment_modButtons_CosmosElementIconButton
;

export type HeroBravoFragment_backgroundAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type HeroBravoFragment = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

type PageHeroes_CosmosHeroAlpha_Fragment = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

type PageHeroes_CosmosHeroArticleImage_Fragment = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

type PageHeroes_CosmosHeroBravo_Fragment = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

type PageHeroes_CosmosHeroGlow_Fragment = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type PageHeroesFragment =
  | PageHeroes_CosmosHeroAlpha_Fragment
  | PageHeroes_CosmosHeroArticleImage_Fragment
  | PageHeroes_CosmosHeroBravo_Fragment
  | PageHeroes_CosmosHeroGlow_Fragment
;

export type HydrusLinkFragment = { id: string, icon?: Types.EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null };

export type HydrusColumnFragment_links = { id: string, icon?: Types.EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null };

export type HydrusColumnFragment = { id: string, title?: string | null, titleHref?: string | null, links: Array<HydrusColumnFragment_links> };

export type HydrusColumnListSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type HydrusColumnListSectionFragment_columns = { id: string, title?: string | null, titleHref?: string | null, links: Array<HydrusColumnFragment_links> };

export type HydrusColumnListSectionFragment = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: HydrusColumnListSectionFragment_config | null, columns: Array<HydrusColumnListSectionFragment_columns> };

export type LatestNewsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type LatestNewsSectionFragment_wfRefBlogTags = { __typename: 'WfRefBlogTag', id: string, tagId: string, label: string };

export type LatestNewsSectionFragment_cosmosPageBlogDetails = { slug: string };

export type LatestNewsSectionFragment = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: Types.CosmosEnumLatestNewsVariants | null, config?: LatestNewsSectionFragment_config | null, wfRefBlogTags: Array<LatestNewsSectionFragment_wfRefBlogTags>, cosmosPageBlogDetails: Array<LatestNewsSectionFragment_cosmosPageBlogDetails> };

export type LearnSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type LearnSectionFragment_tabs = { label: string, value: Types.CosmosEnumLearnTabs };

export type LearnSectionFragment_categories_description = { __typename: 'RichText', html: string, text: string };

export type LearnSectionFragment_categories_title = { __typename: 'RichText', html: string, text: string };

export type LearnSectionFragment_categories_remoteLearn = { id: string, learnSearch?: any };

export type LearnSectionFragment_categories_cards_description = { __typename: 'RichText', html: string, text: string };

export type LearnSectionFragment_categories_cards_links = { label?: string | null, href?: string | null, icon?: Types.CosmosEnumLinkIcons | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type LearnSectionFragment_categories_cards_cta = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_title = { __typename: 'RichText', html: string, text: string };

export type LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_source = { author?: string | null, timestamp?: any, ago?: string | null };

export type LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_img = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string };

export type LearnSectionFragment_categories_cards_CosmosElementLearnDocumentationCard = { __typename: 'CosmosElementLearnDocumentationCard', description?: LearnSectionFragment_categories_cards_description | null, links: Array<LearnSectionFragment_categories_cards_links>, cta?: LearnSectionFragment_categories_cards_cta | null };

export type LearnSectionFragment_categories_cards_CosmosElementLearnImageCard = { __typename: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<Types.CosmosEnumLearnTabs>, title?: LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_title | null, source?: LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_source | null, img?: LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_img | null };

export type LearnSectionFragment_categories_cards =
  | LearnSectionFragment_categories_cards_CosmosElementLearnDocumentationCard
  | LearnSectionFragment_categories_cards_CosmosElementLearnImageCard
;

export type LearnSectionFragment_categories_cta = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type LearnSectionFragment_categories_remoteCards = { id: string, industries: Array<Types.CosmosEnumLearnTabs>, type: Types.CosmosEnumLearnPostType, data?: any };

export type LearnSectionFragment_categories = { __typename: 'ElementLearnCategory', categoryType?: Types.EnumLearnCategories | null, desc?: string | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: LearnSectionFragment_categories_description | null, title?: LearnSectionFragment_categories_title | null, remoteLearn?: LearnSectionFragment_categories_remoteLearn | null, cards: Array<LearnSectionFragment_categories_cards>, cta?: LearnSectionFragment_categories_cta | null, remoteCards: Array<LearnSectionFragment_categories_remoteCards> };

export type LearnSectionFragment = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: Types.CosmosEnumApplicationFamily | null, config?: LearnSectionFragment_config | null, tabs: Array<LearnSectionFragment_tabs>, categories: Array<LearnSectionFragment_categories> };

export type ElementLearnCategoryFragment = { __typename: 'ElementLearnCategory', categoryType?: Types.EnumLearnCategories | null, desc?: string | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: LearnSectionFragment_categories_description | null, title?: LearnSectionFragment_categories_title | null, remoteLearn?: LearnSectionFragment_categories_remoteLearn | null, cards: Array<LearnSectionFragment_categories_cards>, cta?: LearnSectionFragment_categories_cta | null, remoteCards: Array<LearnSectionFragment_categories_remoteCards> };

export type CosmosElementLearnDocumentationCardFragment = { __typename: 'CosmosElementLearnDocumentationCard', description?: LearnSectionFragment_categories_cards_description | null, links: Array<LearnSectionFragment_categories_cards_links>, cta?: LearnSectionFragment_categories_cards_cta | null };

export type CosmosElementLearnImageCardSourceFragment = { author?: string | null, timestamp?: any, ago?: string | null };

export type CosmosElementLearnImageCardFragment = { __typename: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<Types.CosmosEnumLearnTabs>, title?: LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_title | null, source?: LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_source | null, img?: LearnSectionFragment_categories_cards_CosmosElementLearnImageCard_img | null };

export type CheckListItemFragment = { label?: string | null, icon?: Types.CosmosEnumCheckListIcons | null };

export type LicenseTopCardFragment_bullets = { __typename: 'RichText', html: string, text: string };

export type LicenseTopCardFragment_checkList = { label?: string | null, icon?: Types.CosmosEnumCheckListIcons | null };

export type LicenseTopCardFragment_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type LicenseTopCardFragment = { __typename: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<LicenseTopCardFragment_bullets>, checkList: Array<LicenseTopCardFragment_checkList>, buttons: Array<LicenseTopCardFragment_buttons> };

export type LicenseCollapsedCardFragment_description = { __typename: 'RichText', html: string, text: string };

export type LicenseCollapsedCardFragment = { icon?: Types.EdsIconsEnum | null, title?: string | null, description?: LicenseCollapsedCardFragment_description | null };

export type LicensesCollapsedSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type LicensesCollapsedSectionFragment_topCard = { __typename: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<LicenseTopCardFragment_bullets>, checkList: Array<LicenseTopCardFragment_checkList>, buttons: Array<LicenseTopCardFragment_buttons> };

export type LicensesCollapsedSectionFragment_collapsedCards = { icon?: Types.EdsIconsEnum | null, title?: string | null, description?: LicenseCollapsedCardFragment_description | null };

export type LicensesCollapsedSectionFragment_collapsedCta = { label?: string | null, href?: string | null, icon?: Types.CosmosEnumLinkIcons | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type LicensesCollapsedSectionFragment = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: LicensesCollapsedSectionFragment_config | null, topCard?: LicensesCollapsedSectionFragment_topCard | null, collapsedCards: Array<LicensesCollapsedSectionFragment_collapsedCards>, collapsedCta?: LicensesCollapsedSectionFragment_collapsedCta | null };

export type LicenseCardTopFragment_description = { __typename: 'RichText', html: string, text: string };

export type LicenseCardTopFragment_example = { __typename: 'RichText', html: string, text: string };

export type LicenseCardTopFragment = { __typename: 'CosmosElementLicenseCardTop', icon?: Types.EdsIconsEnum | null, title?: string | null, description?: LicenseCardTopFragment_description | null, example?: LicenseCardTopFragment_example | null };

export type LicenseCardCoreFragment_description = { __typename: 'RichText', html: string, text: string };

export type LicenseCardCoreFragment_example = { __typename: 'RichText', html: string, text: string };

export type LicenseCardCoreFragment_buttons = { __typename: 'CosmosElementButton', variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null };

export type LicenseCardCoreFragment_countryOverride_description = { __typename: 'RichText', html: string, text: string };

export type LicenseCardCoreFragment_countryOverride_example = { __typename: 'RichText', html: string, text: string };

export type LicenseCardCoreFragment_countryOverride_buttons = { __typename: 'CosmosElementButton', variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null };

export type LicenseCardCoreFragment_countryOverride = { title?: string | null, description?: LicenseCardCoreFragment_countryOverride_description | null, example?: LicenseCardCoreFragment_countryOverride_example | null, buttons: Array<LicenseCardCoreFragment_countryOverride_buttons> };

export type LicenseCardCoreFragment = { __typename: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<Types.CosmosEnumCountryCodes>, description?: LicenseCardCoreFragment_description | null, example?: LicenseCardCoreFragment_example | null, buttons: Array<LicenseCardCoreFragment_buttons>, countryOverride?: LicenseCardCoreFragment_countryOverride | null };

export type LicenseSeatFragment_description = { __typename: 'RichText', html: string, text: string };

export type LicenseSeatFragment_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type LicenseSeatFragment_countryOverride_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type LicenseSeatFragment_countryOverride = { buttons: Array<LicenseSeatFragment_countryOverride_buttons> };

export type LicenseSeatFragment = { __typename: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<Types.CosmosEnumCountryCodes>, description?: LicenseSeatFragment_description | null, buttons: Array<LicenseSeatFragment_buttons>, countryOverride?: LicenseSeatFragment_countryOverride | null };

export type LicenseMainCardFragment_cardTop = { __typename: 'CosmosElementLicenseCardTop', icon?: Types.EdsIconsEnum | null, title?: string | null, description?: LicenseCardTopFragment_description | null, example?: LicenseCardTopFragment_example | null };

export type LicenseMainCardFragment_cardSections = { __typename: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<Types.CosmosEnumCountryCodes>, description?: LicenseCardCoreFragment_description | null, example?: LicenseCardCoreFragment_example | null, buttons: Array<LicenseCardCoreFragment_buttons>, countryOverride?: LicenseCardCoreFragment_countryOverride | null };

export type LicenseMainCardFragment_seats = { __typename: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<Types.CosmosEnumCountryCodes>, description?: LicenseSeatFragment_description | null, buttons: Array<LicenseSeatFragment_buttons>, countryOverride?: LicenseSeatFragment_countryOverride | null };

export type LicenseMainCardFragment = { __typename: 'CosmosElementLicenseMainCard', cardTop?: LicenseMainCardFragment_cardTop | null, cardSections: Array<LicenseMainCardFragment_cardSections>, seats?: LicenseMainCardFragment_seats | null };

export type LogoFragment_image = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null };

export type LogoFragment = { href?: string | null, title: string, landscape: boolean, image: LogoFragment_image };

export type LogoListSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type LogoListSectionFragment_logos = { href?: string | null, title: string, landscape: boolean, image: LogoFragment_image };

export type LogoListSectionFragment = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type LogoMultiCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type LogoMultiCardFragment = { icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: LogoMultiCardFragment_title | null };

export type LogoMultiCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type LogoMultiCardsSectionFragment_title = { __typename: 'RichText', html: string, text: string };

export type LogoMultiCardsSectionFragment_buttons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type LogoMultiCardsSectionFragment_buttons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type LogoMultiCardsSectionFragment_buttons =
  | LogoMultiCardsSectionFragment_buttons_CosmosElementButton
  | LogoMultiCardsSectionFragment_buttons_CosmosElementIconButton
;

export type LogoMultiCardsSectionFragment_links = { label?: string | null, href?: string | null, icon?: Types.CosmosEnumLinkIcons | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type LogoMultiCardsSectionFragment_cards = { icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: LogoMultiCardFragment_title | null };

export type LogoMultiCardsSectionFragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type NewsAuthorTagFragment_image = { __typename: 'Asset', url: string, altText?: string | null };

export type NewsAuthorTagFragment = { __typename: 'CosmosElementImageTag', href?: string | null, label: string, image?: NewsAuthorTagFragment_image | null };

export type NewsCardFragment_image = { __typename: 'Asset', url: string, altText?: string | null };

export type NewsCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type NewsCardFragment_description = { __typename: 'RichText', html: string, text: string };

export type NewsCardFragment_tag = { href?: string | null, label?: string | null };

export type NewsCardFragment_authorTag = { __typename: 'CosmosElementImageTag', href?: string | null, label: string, image?: NewsAuthorTagFragment_image | null };

export type NewsCardFragment = { __typename: 'CosmosElementNewsCard', href?: string | null, image: NewsCardFragment_image, title?: NewsCardFragment_title | null, description?: NewsCardFragment_description | null, tag?: NewsCardFragment_tag | null, authorTag?: NewsCardFragment_authorTag | null };

export type NewsCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type NewsCardsSectionFragment_cards = { __typename: 'CosmosElementNewsCard', href?: string | null, image: NewsCardFragment_image, title?: NewsCardFragment_title | null, description?: NewsCardFragment_description | null, tag?: NewsCardFragment_tag | null, authorTag?: NewsCardFragment_authorTag | null };

export type NewsCardsSectionFragment = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: Types.EnumSmallNewsCardMax | null, config?: NewsCardsSectionFragment_config | null, cards: Array<NewsCardsSectionFragment_cards> };

export type NewsMediaCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type NewsMediaCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type NewsMediaCardFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type NewsMediaCardFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type NewsMediaCardFragment_modButtons =
  | NewsMediaCardFragment_modButtons_CosmosElementButton
  | NewsMediaCardFragment_modButtons_CosmosElementIconButton
;

export type NewsMediaCardFragment = { href?: string | null, desc?: string | null, author?: string | null, asset?: NewsMediaCardFragment_asset | null, title?: NewsMediaCardFragment_title | null, modButtons: Array<NewsMediaCardFragment_modButtons> };

export type NewsMediaCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type NewsMediaCardsSectionFragment_cards = { href?: string | null, desc?: string | null, author?: string | null, asset?: NewsMediaCardFragment_asset | null, title?: NewsMediaCardFragment_title | null, modButtons: Array<NewsMediaCardFragment_modButtons> };

export type NewsMediaCardsSectionFragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type IndustryFragment = { salesForceId: string, dataRouterId?: string | null, label?: string | null };

export type IndustryListFragment_industries = { salesForceId: string, dataRouterId?: string | null, label?: string | null };

export type IndustryListFragment = { industries: Array<IndustryListFragment_industries> };

export type NewsletterSignupFragment_industriesRef = { industries: Array<IndustryListFragment_industries> };

export type NewsletterSignupFragment = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: NewsletterSignupFragment_industriesRef | null };

export type NumberCalloutFragment = { number?: number | null, numberDisplay?: string | null, label?: string | null };

export type NumberCalloutSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type NumberCalloutSectionFragment_title = { __typename: 'RichText', html: string, text: string };

export type NumberCalloutSectionFragment_callouts = { number?: number | null, numberDisplay?: string | null, label?: string | null };

export type NumberCalloutSectionFragment_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type NumberCalloutSectionFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type NumberCalloutSectionFragment = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: Types.CosmosEnumNumberCalloutVariants | null, config?: NumberCalloutSectionFragment_config | null, title?: NumberCalloutSectionFragment_title | null, callouts: Array<NumberCalloutSectionFragment_callouts>, buttons: Array<NumberCalloutSectionFragment_buttons>, asset?: NumberCalloutSectionFragment_asset | null };

export type OrionCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type OrionCardFragment = { __typename: 'CosmosElementOrionCard', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardHref?: string | null, anchorLinkId?: string | null, title?: OrionCardFragment_title | null };

export type OrionCardsSectionFragment_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type OrionCardsSectionFragment_title = { __typename: 'RichText', html: string, text: string };

export type OrionCardsSectionFragment_modButtons_CosmosElementButton = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type OrionCardsSectionFragment_modButtons_CosmosElementIconButton = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type OrionCardsSectionFragment_modButtons =
  | OrionCardsSectionFragment_modButtons_CosmosElementButton
  | OrionCardsSectionFragment_modButtons_CosmosElementIconButton
;

export type OrionCardsSectionFragment_cards = { __typename: 'CosmosElementOrionCard', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardHref?: string | null, anchorLinkId?: string | null, title?: OrionCardFragment_title | null };

export type OrionCardsSectionFragment = { __typename: 'CosmosSectionOrionCards', id: string, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, config?: OrionCardsSectionFragment_config | null, title?: OrionCardsSectionFragment_title | null, modButtons: Array<OrionCardsSectionFragment_modButtons>, cards: Array<OrionCardsSectionFragment_cards> };

export type CosmosPageAgreementCoreFragment = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, blocked: Array<Types.CosmosEnumCountryCodes> };

export type CosmosPageAgreementEntitiesFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

export type CosmosPageAgreementEntitiesFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

export type CosmosPageAgreementEntitiesFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

export type CosmosPageAgreementEntitiesFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

export type CosmosPageAgreementEntitiesFragment_hero =
  | CosmosPageAgreementEntitiesFragment_hero_CosmosHeroAlpha
  | CosmosPageAgreementEntitiesFragment_hero_CosmosHeroArticleImage
  | CosmosPageAgreementEntitiesFragment_hero_CosmosHeroBravo
  | CosmosPageAgreementEntitiesFragment_hero_CosmosHeroGlow
;

export type CosmosPageAgreementEntitiesFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type CosmosPageAgreementEntitiesFragment_agreementDetails = { __typename: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null };

export type CosmosPageAgreementEntitiesFragment = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, blocked: Array<Types.CosmosEnumCountryCodes>, hero?: CosmosPageAgreementEntitiesFragment_hero | null, refSections: Array<CosmosPageAgreementEntitiesFragment_refSections>, agreementDetails?: CosmosPageAgreementEntitiesFragment_agreementDetails | null };

export type PageAgreementMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageAgreementMetadataFragment = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, metaTags?: PageAgreementMetadataFragment_metaTags | null };

export type AgreementDetailsFragment = { __typename: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null };

export type CosmosPageAgreementFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type CosmosPageAgreementFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type CosmosPageAgreementFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type CosmosPageAgreementFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type CosmosPageAgreementFragment_hero =
  | CosmosPageAgreementFragment_hero_CosmosHeroAlpha
  | CosmosPageAgreementFragment_hero_CosmosHeroArticleImage
  | CosmosPageAgreementFragment_hero_CosmosHeroBravo
  | CosmosPageAgreementFragment_hero_CosmosHeroGlow
;

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems_downloads = { __typename: 'CosmosElementPluginDownloadDetail', operatingSystem?: Types.CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems_extraButtons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems = { __typename: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems_downloads>, extraButtons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems_extraButtons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards_location = { __typename: 'Location', latitude: number, longitude: number };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards = { __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<Types.CosmosEnumResellerContinents>, location?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards_location | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2 = { __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<Types.CosmosEnumResellerContinents>, location?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards_location | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3 = { __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<Types.CosmosEnumResellerContinents>, location?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards_location | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4 = { __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<Types.CosmosEnumResellerContinents>, location?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards_location | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content = { __typename: 'RichText', html: string, text: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title = { __typename: 'RichText', html: string, text: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc = { __typename: 'RichText', html: string, text: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards = { slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers = { id: string, icon?: Types.EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers_asset | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_title = { __typename: 'RichText', html: string, text: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_backgroundAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_cards = { __typename: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: BlogCardFragment_asset | null, category?: BlogCardFragment_category | null, title?: BlogCardFragment_title | null, buttons: Array<BlogCardFragment_buttons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_featuredCards = { __typename: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: BlogCardFragment_asset | null, category?: BlogCardFragment_category | null, title?: BlogCardFragment_title | null, buttons: Array<BlogCardFragment_buttons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs = { __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_buttons>, backgroundAsset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_backgroundAsset | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_cards>, featuredCards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_featuredCards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_title = { __typename: 'RichText', html: string, text: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_blurredImage = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs = { __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_buttons>, asset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_asset | null, blurredImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_blurredImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_title = { html: string, text: string };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_buttons = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_heroAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs = { tabLabel?: string | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_buttons>, heroAsset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_heroAsset | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards_cardImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards_logoImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards = { href?: string | null, label?: string | null, cardImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards_cardImage | null, logoImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards_logoImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionAccordionFeatureCard = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: AccordionFeatureCardsSectionFragment_config | null, items: Array<AccordionFeatureCardsSectionFragment_items> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionAccordionTierCards = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: AccordionTierCardsSectionFragment_config | null, items: Array<AccordionTierCardsSectionFragment_items> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionAriesCards = { __typename: 'CosmosSectionAriesCards', id: string, config?: AriesCardsSectionFragment_config | null, cards: Array<AriesCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionAsset = { __typename: 'CosmosSectionAsset', id: string, size?: Types.CosmosEnumSectionSizes | null, caption?: string | null, config?: AssetSectionFragment_config | null, sectionAsset: AssetSectionFragment_sectionAsset };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionBlobTable = { __typename: 'CosmosSectionBlobTable', id: string, environmentVariable: string, limit?: number | null, variant?: Types.CosmosEnumBlobTableVariants | null, config?: BlobTableSectionFragment_config | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionBlogCard = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: Types.CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: BlogCardsSectionFragment_config | null, cards: Array<BlogCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionCommunity = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: Types.CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: CommunitySectionFragment_config | null, forumButton?: CommunitySectionFragment_forumButton | null, resources?: CommunitySectionFragment_resources | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionComplexCtaCard = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: Types.CosmosEnumComplexCtaVariant | null, config?: ComplexCtaCardsSectionFragment_config | null, cards: Array<ComplexCtaCardsSectionFragment_cards>, bottomDescription?: ComplexCtaCardsSectionFragment_bottomDescription | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionContentSliderAsset = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentSliderAssetFragment_config | null, badges: Array<ContentSliderAssetFragment_badges>, title?: ContentSliderAssetFragment_title | null, buttons: Array<ContentSliderAssetFragment_buttons>, assets: Array<ContentSliderAssetFragment_assets> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionCrux = { __typename: 'CosmosSectionCrux', id: string, config?: CruxSectionFragment_config | null, cruxLinks: Array<CruxSectionFragment_cruxLinks> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionDelphinusCardsGrid = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: DelphinusCardsGridSectionFragment_config | null, grid: Array<DelphinusCardsGridSectionFragment_grid> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionDevelopersList = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: DevelopersListSectionFragment_config | null, developersTsv?: DevelopersListSectionFragment_developersTsv | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionDownloadCard = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionDownloadable = { __typename: 'CosmosSectionDownloadable', id: string, config?: DownloadableSectionFragment_config | null, instructions?: DownloadableSectionFragment_instructions | null, executables: Array<DownloadableSectionFragment_executables>, footer?: DownloadableSectionFragment_footer | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionEmbed = { __typename: 'CosmosSectionEmbed', id: string, size?: Types.CosmosEnumSectionSizes | null, config?: EmbedSectionFragment_config | null, embed?: EmbedSectionFragment_embed | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionEventsTable = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: EventsTableSectionFragment_config | null, blurredImage?: EventsTableSectionFragment_blurredImage | null, events: Array<EventsTableSectionFragment_events> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionFaq = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSectionFragment_config | null, title?: FaqSectionFragment_title | null, items: Array<FaqSectionFragment_items>, refFaqItems: Array<FaqSectionFragment_refFaqItems>, modButtons: Array<FaqSectionFragment_modButtons>, faqButtons: Array<FaqSectionFragment_faqButtons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionFaqSearch = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSearchSectionFragment_config | null, title?: FaqSearchSectionFragment_title | null, faqTabs: Array<FaqSearchSectionFragment_faqTabs>, modButtons: Array<FaqSearchSectionFragment_modButtons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionFeatureCard = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: FeatureCardsSectionFragment_config | null, tags: Array<FeatureCardsSectionFragment_tags>, cards: Array<FeatureCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionGameDevFeatureCard = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: FeaturePanelsSectionFragment_config | null, cards: Array<FeaturePanelsSectionFragment_cards>, buttons: Array<FeaturePanelsSectionFragment_buttons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionGeminiCard = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: Types.CosmosEnumGeminiVariants | null, logoImage?: GeminiCardsSectionFragment_logoImage | null, config?: GeminiCardsSectionFragment_config | null, title?: GeminiCardsSectionFragment_title | null, cards: Array<GeminiCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionHydrusColumnList = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: HydrusColumnListSectionFragment_config | null, columns: Array<HydrusColumnListSectionFragment_columns> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionLatestNews = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: Types.CosmosEnumLatestNewsVariants | null, config?: LatestNewsSectionFragment_config | null, wfRefBlogTags: Array<LatestNewsSectionFragment_wfRefBlogTags>, cosmosPageBlogDetails: Array<LatestNewsSectionFragment_cosmosPageBlogDetails> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionLearn = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: Types.CosmosEnumApplicationFamily | null, config?: LearnSectionFragment_config | null, tabs: Array<LearnSectionFragment_tabs>, categories: Array<LearnSectionFragment_categories> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionLicensesCollapsed = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: LicensesCollapsedSectionFragment_config | null, topCard?: LicensesCollapsedSectionFragment_topCard | null, collapsedCards: Array<LicensesCollapsedSectionFragment_collapsedCards>, collapsedCta?: LicensesCollapsedSectionFragment_collapsedCta | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionNewsCard = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: Types.EnumSmallNewsCardMax | null, config?: NewsCardsSectionFragment_config | null, cards: Array<NewsCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionNewsletterSignup = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: NewsletterSignupFragment_industriesRef | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionNumberCallout = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: Types.CosmosEnumNumberCalloutVariants | null, config?: NumberCalloutSectionFragment_config | null, title?: NumberCalloutSectionFragment_title | null, callouts: Array<NumberCalloutSectionFragment_callouts>, buttons: Array<NumberCalloutSectionFragment_buttons>, asset?: NumberCalloutSectionFragment_asset | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionOrionCards = { __typename: 'CosmosSectionOrionCards', id: string, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, config?: OrionCardsSectionFragment_config | null, title?: OrionCardsSectionFragment_title | null, modButtons: Array<OrionCardsSectionFragment_modButtons>, cards: Array<OrionCardsSectionFragment_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable = { __typename: 'CosmosSectionPluginListTable', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config | null, tableItems: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote = { __typename: 'CosmosSectionQuote', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config | null, quotes: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards>, cards2: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2>, cards3: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3>, cards4: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4>, blurredBackgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config | null, content?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config | null, speakers: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard = { __typename: 'CosmosSectionTabbedBlogCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs> };

export type CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard = { __typename: 'CosmosSectionUtCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards> };

export type CosmosPageAgreementFragment_refSections_section =
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionAccordionFeatureCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionAccordionTierCards
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionAriesCards
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionAsset
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionAssetCarousel
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionAssetGallery
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionBlobTable
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionBlogCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionCommunity
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionComplexCtaCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionContentLargeImage
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionContentSliderAsset
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionCrux
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionDelphinusCardsGrid
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionDevelopersList
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionDivider
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionDownloadCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionDownloadable
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionEmbed
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionEventsTable
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionFaq
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionFaqSearch
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionFeatureCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionGameDevFeatureCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionGeminiCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionHydrusColumnList
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionLatestNews
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionLearn
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionLicensesCollapsed
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionLogoList
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionLogoMultiCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionNewsCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionNewsMediaCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionNewsletterSignup
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionNumberCallout
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionOrionCards
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset
  | CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard
;

export type CosmosPageAgreementFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type CosmosPageAgreementFragment_agreementDetails = { __typename: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null };

export type CosmosPageAgreementFragment = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, blocked: Array<Types.CosmosEnumCountryCodes>, hero?: CosmosPageAgreementFragment_hero | null, refSections: Array<CosmosPageAgreementFragment_refSections>, agreementDetails?: CosmosPageAgreementFragment_agreementDetails | null };

export type BlogAuthorTagFragment_image = { __typename: 'Asset', url: string, altText?: string | null };

export type BlogAuthorTagFragment = { __typename: 'CosmosElementImageTag', href?: string | null, label: string, image?: BlogAuthorTagFragment_image | null };

export type BlogConfigFragment_blogLandingCard = { __typename: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: BlogCardFragment_asset | null, category?: BlogCardFragment_category | null, title?: BlogCardFragment_title | null, buttons: Array<BlogCardFragment_buttons> };

export type BlogConfigFragment_authorTag = { __typename: 'CosmosElementImageTag', href?: string | null, label: string, image?: BlogAuthorTagFragment_image | null };

export type BlogConfigFragment_tags = { __typename: 'WfRefBlogTag', id: string, tagId: string, label: string };

export type BlogConfigFragment_categories = { __typename: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: BlogCardFragment_category_tag | null };

export type BlogConfigFragment = { __typename: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any, blogLandingCard?: BlogConfigFragment_blogLandingCard | null, authorTag?: BlogConfigFragment_authorTag | null, tags: Array<BlogConfigFragment_tags>, categories: Array<BlogConfigFragment_categories> };

export type ArticleComponentsFragment_articleComponentAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type ArticleComponentsFragment_CosmosElementButtonList_buttons = { __typename: 'CosmosElementButton', label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type ArticleComponentsFragment_CosmosElementRichText_text = { __typename: 'RichText', html: string, text: string };

export type ArticleComponentsFragment_CosmosElementUserProfile_avatar_imageAsset_fallbackImage = { url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string };

export type ArticleComponentsFragment_CosmosElementUserProfile_avatar_imageAsset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: ArticleComponentsFragment_CosmosElementUserProfile_avatar_imageAsset_fallbackImage | null };

export type ArticleComponentsFragment_CosmosElementUserProfile_avatar = { href?: string | null, label?: string | null, imageSrc?: string | null, color?: Types.CosmosEnumAvatarColors | null, imageAsset?: ArticleComponentsFragment_CosmosElementUserProfile_avatar_imageAsset | null };

export type ArticleComponentsFragment_CosmosElementUserProfile_logoImage = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type ArticleComponentsFragment_CosmosElementUserProfile_button = { __typename: 'CosmosElementIconButton', icon?: Types.CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: Types.CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: Types.CosmosEnumIconPosition | null };

type ArticleComponents_CosmosElementAsset_Fragment = { __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: ArticleComponentsFragment_articleComponentAsset };

type ArticleComponents_CosmosElementButtonList_Fragment = { __typename: 'CosmosElementButtonList', buttons: Array<ArticleComponentsFragment_CosmosElementButtonList_buttons> };

type ArticleComponents_CosmosElementCalloutCard_Fragment = { __typename: 'CosmosElementCalloutCard', icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: CosmosCalloutCardFragment_title | null, buttons: Array<CosmosCalloutCardFragment_buttons> };

type ArticleComponents_CosmosElementCkEditorText_Fragment = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

type ArticleComponents_CosmosElementCompare_Fragment = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: CosmosCompareFragment_leftImage | null, rightImage?: CosmosCompareFragment_rightImage | null };

type ArticleComponents_CosmosElementGithubGist_Fragment = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

type ArticleComponents_CosmosElementIconLinkGroup_Fragment = { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<CosmosIconLinkGroupFragment_edsIconLinks> };

type ArticleComponents_CosmosElementInterview_Fragment = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<CosmosInterviewFragment_questions> };

type ArticleComponents_CosmosElementLicenseContactCard_Fragment = { __typename: 'CosmosElementLicenseContactCard', slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

type ArticleComponents_CosmosElementQuote_Fragment = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

type ArticleComponents_CosmosElementRichText_Fragment = { __typename: 'CosmosElementRichText', text: ArticleComponentsFragment_CosmosElementRichText_text };

type ArticleComponents_CosmosElementSectionHeading_Fragment = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

type ArticleComponents_CosmosElementTitleAndDesc_Fragment = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

type ArticleComponents_CosmosElementUserProfile_Fragment = { __typename: 'CosmosElementUserProfile', variant?: Types.CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: ArticleComponentsFragment_CosmosElementUserProfile_avatar | null, logoImage?: ArticleComponentsFragment_CosmosElementUserProfile_logoImage | null, button?: ArticleComponentsFragment_CosmosElementUserProfile_button | null };

type ArticleComponents_CosmosElementVideoEmbed_Fragment = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

type ArticleComponents_CosmosSectionAssetCarousel_Fragment = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

type ArticleComponents_CosmosSectionAssetGallery_Fragment = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

type ArticleComponents_CosmosSectionContentLargeImage_Fragment = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

type ArticleComponents_CosmosSectionDivider_Fragment = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

type ArticleComponents_CosmosSectionLogoList_Fragment = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

type ArticleComponents_CosmosSectionLogoMultiCard_Fragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

type ArticleComponents_CosmosSectionNewsMediaCard_Fragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

type ArticleComponents_CosmosSectionSimpleCta_Fragment = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type ArticleComponentsFragment =
  | ArticleComponents_CosmosElementAsset_Fragment
  | ArticleComponents_CosmosElementButtonList_Fragment
  | ArticleComponents_CosmosElementCalloutCard_Fragment
  | ArticleComponents_CosmosElementCkEditorText_Fragment
  | ArticleComponents_CosmosElementCompare_Fragment
  | ArticleComponents_CosmosElementGithubGist_Fragment
  | ArticleComponents_CosmosElementIconLinkGroup_Fragment
  | ArticleComponents_CosmosElementInterview_Fragment
  | ArticleComponents_CosmosElementLicenseContactCard_Fragment
  | ArticleComponents_CosmosElementQuote_Fragment
  | ArticleComponents_CosmosElementRichText_Fragment
  | ArticleComponents_CosmosElementSectionHeading_Fragment
  | ArticleComponents_CosmosElementTitleAndDesc_Fragment
  | ArticleComponents_CosmosElementUserProfile_Fragment
  | ArticleComponents_CosmosElementVideoEmbed_Fragment
  | ArticleComponents_CosmosSectionAssetCarousel_Fragment
  | ArticleComponents_CosmosSectionAssetGallery_Fragment
  | ArticleComponents_CosmosSectionContentLargeImage_Fragment
  | ArticleComponents_CosmosSectionDivider_Fragment
  | ArticleComponents_CosmosSectionLogoList_Fragment
  | ArticleComponents_CosmosSectionLogoMultiCard_Fragment
  | ArticleComponents_CosmosSectionNewsMediaCard_Fragment
  | ArticleComponents_CosmosSectionSimpleCta_Fragment
;

export type PageBlogDetailEntitiesFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageBlogDetailEntitiesFragment_blogConfig = { __typename: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any, blogLandingCard?: BlogConfigFragment_blogLandingCard | null, authorTag?: BlogConfigFragment_authorTag | null, tags: Array<BlogConfigFragment_tags>, categories: Array<BlogConfigFragment_categories> };

export type PageBlogDetailEntitiesFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

export type PageBlogDetailEntitiesFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

export type PageBlogDetailEntitiesFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

export type PageBlogDetailEntitiesFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

export type PageBlogDetailEntitiesFragment_hero =
  | PageBlogDetailEntitiesFragment_hero_CosmosHeroAlpha
  | PageBlogDetailEntitiesFragment_hero_CosmosHeroArticleImage
  | PageBlogDetailEntitiesFragment_hero_CosmosHeroBravo
  | PageBlogDetailEntitiesFragment_hero_CosmosHeroGlow
;

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementAsset = { __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: ArticleComponentsFragment_articleComponentAsset };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementButtonList = { __typename: 'CosmosElementButtonList', buttons: Array<ArticleComponentsFragment_CosmosElementButtonList_buttons> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementCalloutCard = { __typename: 'CosmosElementCalloutCard', icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: CosmosCalloutCardFragment_title | null, buttons: Array<CosmosCalloutCardFragment_buttons> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementCkEditorText = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementCompare = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: CosmosCompareFragment_leftImage | null, rightImage?: CosmosCompareFragment_rightImage | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementGithubGist = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementIconLinkGroup = { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<CosmosIconLinkGroupFragment_edsIconLinks> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementInterview = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<CosmosInterviewFragment_questions> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementLicenseContactCard = { __typename: 'CosmosElementLicenseContactCard', slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementQuote = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementRichText = { __typename: 'CosmosElementRichText', text: ArticleComponentsFragment_CosmosElementRichText_text };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementSectionHeading = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementTitleAndDesc = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementUserProfile = { __typename: 'CosmosElementUserProfile', variant?: Types.CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: ArticleComponentsFragment_CosmosElementUserProfile_avatar | null, logoImage?: ArticleComponentsFragment_CosmosElementUserProfile_logoImage | null, button?: ArticleComponentsFragment_CosmosElementUserProfile_button | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosElementVideoEmbed = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type PageBlogDetailEntitiesFragment_articleComponents =
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementAsset
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementButtonList
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementCalloutCard
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementCkEditorText
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementCompare
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementGithubGist
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementIconLinkGroup
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementInterview
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementLicenseContactCard
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementQuote
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementRichText
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementSectionHeading
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementTitleAndDesc
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementUserProfile
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosElementVideoEmbed
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionAssetCarousel
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionAssetGallery
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionContentLargeImage
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionDivider
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionLogoList
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionLogoMultiCard
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionNewsMediaCard
  | PageBlogDetailEntitiesFragment_articleComponents_CosmosSectionSimpleCta
;

export type PageBlogDetailEntitiesFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type PageBlogDetailEntitiesFragment = { __typename: 'CosmosPageBlogDetail', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageBlogDetailEntitiesFragment_owner | null, blogConfig?: PageBlogDetailEntitiesFragment_blogConfig | null, hero?: PageBlogDetailEntitiesFragment_hero | null, articleComponents: Array<PageBlogDetailEntitiesFragment_articleComponents>, refSections: Array<PageBlogDetailEntitiesFragment_refSections> };

export type PageBlogDetailFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageBlogDetailFragment_blogConfig = { __typename: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any, blogLandingCard?: BlogConfigFragment_blogLandingCard | null, authorTag?: BlogConfigFragment_authorTag | null, tags: Array<BlogConfigFragment_tags>, categories: Array<BlogConfigFragment_categories> };

export type PageBlogDetailFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type PageBlogDetailFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type PageBlogDetailFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type PageBlogDetailFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type PageBlogDetailFragment_hero =
  | PageBlogDetailFragment_hero_CosmosHeroAlpha
  | PageBlogDetailFragment_hero_CosmosHeroArticleImage
  | PageBlogDetailFragment_hero_CosmosHeroBravo
  | PageBlogDetailFragment_hero_CosmosHeroGlow
;

export type PageBlogDetailFragment_articleComponents_CosmosElementAsset = { __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: ArticleComponentsFragment_articleComponentAsset };

export type PageBlogDetailFragment_articleComponents_CosmosElementButtonList = { __typename: 'CosmosElementButtonList', buttons: Array<ArticleComponentsFragment_CosmosElementButtonList_buttons> };

export type PageBlogDetailFragment_articleComponents_CosmosElementCalloutCard = { __typename: 'CosmosElementCalloutCard', icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: CosmosCalloutCardFragment_title | null, buttons: Array<CosmosCalloutCardFragment_buttons> };

export type PageBlogDetailFragment_articleComponents_CosmosElementCkEditorText = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type PageBlogDetailFragment_articleComponents_CosmosElementCompare = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: CosmosCompareFragment_leftImage | null, rightImage?: CosmosCompareFragment_rightImage | null };

export type PageBlogDetailFragment_articleComponents_CosmosElementGithubGist = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

export type PageBlogDetailFragment_articleComponents_CosmosElementIconLinkGroup = { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<CosmosIconLinkGroupFragment_edsIconLinks> };

export type PageBlogDetailFragment_articleComponents_CosmosElementInterview = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<CosmosInterviewFragment_questions> };

export type PageBlogDetailFragment_articleComponents_CosmosElementLicenseContactCard = { __typename: 'CosmosElementLicenseContactCard', slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type PageBlogDetailFragment_articleComponents_CosmosElementQuote = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type PageBlogDetailFragment_articleComponents_CosmosElementRichText = { __typename: 'CosmosElementRichText', text: ArticleComponentsFragment_CosmosElementRichText_text };

export type PageBlogDetailFragment_articleComponents_CosmosElementSectionHeading = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type PageBlogDetailFragment_articleComponents_CosmosElementTitleAndDesc = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type PageBlogDetailFragment_articleComponents_CosmosElementUserProfile = { __typename: 'CosmosElementUserProfile', variant?: Types.CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: ArticleComponentsFragment_CosmosElementUserProfile_avatar | null, logoImage?: ArticleComponentsFragment_CosmosElementUserProfile_logoImage | null, button?: ArticleComponentsFragment_CosmosElementUserProfile_button | null };

export type PageBlogDetailFragment_articleComponents_CosmosElementVideoEmbed = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

export type PageBlogDetailFragment_articleComponents_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type PageBlogDetailFragment_articleComponents_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type PageBlogDetailFragment_articleComponents_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type PageBlogDetailFragment_articleComponents_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type PageBlogDetailFragment_articleComponents_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type PageBlogDetailFragment_articleComponents_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type PageBlogDetailFragment_articleComponents_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type PageBlogDetailFragment_articleComponents_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type PageBlogDetailFragment_articleComponents =
  | PageBlogDetailFragment_articleComponents_CosmosElementAsset
  | PageBlogDetailFragment_articleComponents_CosmosElementButtonList
  | PageBlogDetailFragment_articleComponents_CosmosElementCalloutCard
  | PageBlogDetailFragment_articleComponents_CosmosElementCkEditorText
  | PageBlogDetailFragment_articleComponents_CosmosElementCompare
  | PageBlogDetailFragment_articleComponents_CosmosElementGithubGist
  | PageBlogDetailFragment_articleComponents_CosmosElementIconLinkGroup
  | PageBlogDetailFragment_articleComponents_CosmosElementInterview
  | PageBlogDetailFragment_articleComponents_CosmosElementLicenseContactCard
  | PageBlogDetailFragment_articleComponents_CosmosElementQuote
  | PageBlogDetailFragment_articleComponents_CosmosElementRichText
  | PageBlogDetailFragment_articleComponents_CosmosElementSectionHeading
  | PageBlogDetailFragment_articleComponents_CosmosElementTitleAndDesc
  | PageBlogDetailFragment_articleComponents_CosmosElementUserProfile
  | PageBlogDetailFragment_articleComponents_CosmosElementVideoEmbed
  | PageBlogDetailFragment_articleComponents_CosmosSectionAssetCarousel
  | PageBlogDetailFragment_articleComponents_CosmosSectionAssetGallery
  | PageBlogDetailFragment_articleComponents_CosmosSectionContentLargeImage
  | PageBlogDetailFragment_articleComponents_CosmosSectionDivider
  | PageBlogDetailFragment_articleComponents_CosmosSectionLogoList
  | PageBlogDetailFragment_articleComponents_CosmosSectionLogoMultiCard
  | PageBlogDetailFragment_articleComponents_CosmosSectionNewsMediaCard
  | PageBlogDetailFragment_articleComponents_CosmosSectionSimpleCta
;

export type PageBlogDetailFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type PageBlogDetailFragment = { __typename: 'CosmosPageBlogDetail', createdAt?: any, updatedAt?: any, slug: string, owner?: PageBlogDetailFragment_owner | null, blogConfig?: PageBlogDetailFragment_blogConfig | null, hero?: PageBlogDetailFragment_hero | null, articleComponents: Array<PageBlogDetailFragment_articleComponents>, refSections: Array<PageBlogDetailFragment_refSections> };

export type PageBlogDetailMetadataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageBlogDetailMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageBlogDetailMetadataFragment = { __typename: 'CosmosPageBlogDetail', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageBlogDetailMetadataFragment_owner | null, metaTags?: PageBlogDetailMetadataFragment_metaTags | null };

export type PageEulaKeyFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageEulaKeyFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, disclaimer?: string | null, title?: string | null, subtitle?: string | null, eulaKey: string, owner?: PageEulaKeyFragment_owner | null };

export type PageEulaKeyMetadataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageEulaKeyMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageEulaKeyMetadataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageEulaKeyMetadataFragment_owner | null, metaTags?: PageEulaKeyMetadataFragment_metaTags | null };

export type PageFeedFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageFeedFragment_tags = { __typename: 'WfRefBlogTag', id: string, tagId: string, label: string };

export type PageFeedFragment_categories = { __typename: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: BlogCardFragment_category_tag | null };

export type PageFeedFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, searchPlaceholder?: string | null, clearFiltersButtonLabel?: string | null, featuredLabel?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, noResultsDescription?: string | null, owner?: PageFeedFragment_owner | null, tags: Array<PageFeedFragment_tags>, categories: Array<PageFeedFragment_categories> };

export type PageFeedMetadataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageFeedMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageFeedMetadataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageFeedMetadataFragment_owner | null, metaTags?: PageFeedMetadataFragment_metaTags | null };

type CosmosEntity_Asset_Fragment = { __typename: 'Asset', id: string, stage: Types.Stage };

type CosmosEntity_CommunityCard_Fragment = { __typename: 'CommunityCard', id: string, stage: Types.Stage };

type CosmosEntity_CommunityResource_Fragment = { __typename: 'CommunityResource', id: string, stage: Types.Stage };

type CosmosEntity_CosmosConfigBlog_Fragment = { __typename: 'CosmosConfigBlog', id: string, stage: Types.Stage };

type CosmosEntity_CosmosConfigSection_Fragment = { __typename: 'CosmosConfigSection', id: string, stage: Types.Stage };

type CosmosEntity_CosmosDetailServicePartner_Fragment = { __typename: 'CosmosDetailServicePartner', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAccordionFeatureCard_Fragment = { __typename: 'CosmosElementAccordionFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAccordionTierCard_Fragment = { __typename: 'CosmosElementAccordionTierCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAccordionTierCtaCard_Fragment = { __typename: 'CosmosElementAccordionTierCtaCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAccordionTierFeatureCard_Fragment = { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAgreementDetail_Fragment = { __typename: 'CosmosElementAgreementDetail', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAriesCard_Fragment = { __typename: 'CosmosElementAriesCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAsset_Fragment = { __typename: 'CosmosElementAsset', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementAvatar_Fragment = { __typename: 'CosmosElementAvatar', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementBlogCard_Fragment = { __typename: 'CosmosElementBlogCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementButton_Fragment = { __typename: 'CosmosElementButton', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementButtonList_Fragment = { __typename: 'CosmosElementButtonList', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementCalloutCard_Fragment = { __typename: 'CosmosElementCalloutCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementCheckListItem_Fragment = { __typename: 'CosmosElementCheckListItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementCkEditorText_Fragment = { __typename: 'CosmosElementCkEditorText', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementCkEditorTextCollapsible_Fragment = { __typename: 'CosmosElementCkEditorTextCollapsible', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementCompare_Fragment = { __typename: 'CosmosElementCompare', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementComplexCtaCard_Fragment = { __typename: 'CosmosElementComplexCtaCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementCruxLink_Fragment = { __typename: 'CosmosElementCruxLink', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementDelphinusCard_Fragment = { __typename: 'CosmosElementDelphinusCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementDocumentList_Fragment = { __typename: 'CosmosElementDocumentList', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementDocumentListItem_Fragment = { __typename: 'CosmosElementDocumentListItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementDownloadButton_Fragment = { __typename: 'CosmosElementDownloadButton', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementDownloadCard_Fragment = { __typename: 'CosmosElementDownloadCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementDownloadStep_Fragment = { __typename: 'CosmosElementDownloadStep', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementEdsIconLink_Fragment = { __typename: 'CosmosElementEdsIconLink', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementEventsTableRow_Fragment = { __typename: 'CosmosElementEventsTableRow', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementFaqItem_Fragment = { __typename: 'CosmosElementFAQItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementFaqTab_Fragment = { __typename: 'CosmosElementFaqTab', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementFeatureCard_Fragment = { __typename: 'CosmosElementFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementGameDevFeatureCard_Fragment = { __typename: 'CosmosElementGameDevFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementGeminiCard_Fragment = { __typename: 'CosmosElementGeminiCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementGeminiLink_Fragment = { __typename: 'CosmosElementGeminiLink', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementGithubGist_Fragment = { __typename: 'CosmosElementGithubGist', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementHydrusColumn_Fragment = { __typename: 'CosmosElementHydrusColumn', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementHydrusLink_Fragment = { __typename: 'CosmosElementHydrusLink', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementIconButton_Fragment = { __typename: 'CosmosElementIconButton', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementIconLinkGroup_Fragment = { __typename: 'CosmosElementIconLinkGroup', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementIconSectionHeading_Fragment = { __typename: 'CosmosElementIconSectionHeading', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementImageTag_Fragment = { __typename: 'CosmosElementImageTag', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementIndustry_Fragment = { __typename: 'CosmosElementIndustry', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementInterview_Fragment = { __typename: 'CosmosElementInterview', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementInterviewQuestion_Fragment = { __typename: 'CosmosElementInterviewQuestion', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLearnDocumentationCard_Fragment = { __typename: 'CosmosElementLearnDocumentationCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLearnImageCard_Fragment = { __typename: 'CosmosElementLearnImageCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLearnImageCardSource_Fragment = { __typename: 'CosmosElementLearnImageCardSource', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLearnTab_Fragment = { __typename: 'CosmosElementLearnTab', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseCardCore_Fragment = { __typename: 'CosmosElementLicenseCardCore', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseCardTop_Fragment = { __typename: 'CosmosElementLicenseCardTop', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseCollapsedCard_Fragment = { __typename: 'CosmosElementLicenseCollapsedCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseContactCard_Fragment = { __typename: 'CosmosElementLicenseContactCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseMainCard_Fragment = { __typename: 'CosmosElementLicenseMainCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseSeat_Fragment = { __typename: 'CosmosElementLicenseSeat', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLicenseTopCard_Fragment = { __typename: 'CosmosElementLicenseTopCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLink_Fragment = { __typename: 'CosmosElementLink', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLogo_Fragment = { __typename: 'CosmosElementLogo', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementLogoMultiCard_Fragment = { __typename: 'CosmosElementLogoMultiCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementNewsCard_Fragment = { __typename: 'CosmosElementNewsCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementNewsMediaCard_Fragment = { __typename: 'CosmosElementNewsMediaCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementNumberCallout_Fragment = { __typename: 'CosmosElementNumberCallout', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementOrionCard_Fragment = { __typename: 'CosmosElementOrionCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementPluginDownload_Fragment = { __typename: 'CosmosElementPluginDownload', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementPluginDownloadDetail_Fragment = { __typename: 'CosmosElementPluginDownloadDetail', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementPluginListItem_Fragment = { __typename: 'CosmosElementPluginListItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementQuote_Fragment = { __typename: 'CosmosElementQuote', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementResearchCard_Fragment = { __typename: 'CosmosElementResearchCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementResellerCard_Fragment = { __typename: 'CosmosElementResellerCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementRichText_Fragment = { __typename: 'CosmosElementRichText', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementSearchFilter_Fragment = { __typename: 'CosmosElementSearchFilter', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementSectionHeading_Fragment = { __typename: 'CosmosElementSectionHeading', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementSpeakerCard_Fragment = { __typename: 'CosmosElementSpeakerCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementTabbedBlogCardsItem_Fragment = { __typename: 'CosmosElementTabbedBlogCardsItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementTabbedContentImageItem_Fragment = { __typename: 'CosmosElementTabbedContentImageItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementTabbedFullWidthAssetItem_Fragment = { __typename: 'CosmosElementTabbedFullWidthAssetItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementTag_Fragment = { __typename: 'CosmosElementTag', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementTitleAndDesc_Fragment = { __typename: 'CosmosElementTitleAndDesc', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementUserProfile_Fragment = { __typename: 'CosmosElementUserProfile', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementUtCard_Fragment = { __typename: 'CosmosElementUtCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosElementVideoEmbed_Fragment = { __typename: 'CosmosElementVideoEmbed', id: string, stage: Types.Stage };

type CosmosEntity_CosmosFeedBlogCard_Fragment = { __typename: 'CosmosFeedBlogCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosHeroAlpha_Fragment = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

type CosmosEntity_CosmosHeroArticleImage_Fragment = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

type CosmosEntity_CosmosHeroBravo_Fragment = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

type CosmosEntity_CosmosHeroGlow_Fragment = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageAgreement_Fragment = { __typename: 'CosmosPageAgreement', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageBlogDetail_Fragment = { __typename: 'CosmosPageBlogDetail', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageDirectory_Fragment = { __typename: 'CosmosPageDirectory', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageEulaKey_Fragment = { __typename: 'CosmosPageEulaKey', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageFeed_Fragment = { __typename: 'CosmosPageFeed', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageHeroAndSection_Fragment = { __typename: 'CosmosPageHeroAndSection', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageLegalContent_Fragment = { __typename: 'CosmosPageLegalContent', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageLicense_Fragment = { __typename: 'CosmosPageLicense', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPagePluginDetail_Fragment = { __typename: 'CosmosPagePluginDetail', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageRedirect_Fragment = { __typename: 'CosmosPageRedirect', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageResearch_Fragment = { __typename: 'CosmosPageResearch', id: string, stage: Types.Stage };

type CosmosEntity_CosmosPageSearch_Fragment = { __typename: 'CosmosPageSearch', id: string, stage: Types.Stage };

type CosmosEntity_CosmosRefIndustryList_Fragment = { __typename: 'CosmosRefIndustryList', id: string, stage: Types.Stage };

type CosmosEntity_CosmosReferenceFaqItem_Fragment = { __typename: 'CosmosReferenceFAQItem', id: string, stage: Types.Stage };

type CosmosEntity_CosmosReferenceSection_Fragment = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage };

type CosmosEntity_CosmosRemoteLearn_Fragment = { __typename: 'CosmosRemoteLearn', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionAccordionFeatureCard_Fragment = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionAccordionTierCards_Fragment = { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionAriesCards_Fragment = { __typename: 'CosmosSectionAriesCards', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionAsset_Fragment = { __typename: 'CosmosSectionAsset', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionAssetCarousel_Fragment = { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionAssetGallery_Fragment = { __typename: 'CosmosSectionAssetGallery', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionBlobTable_Fragment = { __typename: 'CosmosSectionBlobTable', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionBlogCard_Fragment = { __typename: 'CosmosSectionBlogCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionCkRichText_Fragment = { __typename: 'CosmosSectionCkRichText', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionCommunity_Fragment = { __typename: 'CosmosSectionCommunity', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionComplexCtaCard_Fragment = { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionContentLargeImage_Fragment = { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionContentSliderAsset_Fragment = { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionCrux_Fragment = { __typename: 'CosmosSectionCrux', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionDelphinusCardsGrid_Fragment = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionDevelopersList_Fragment = { __typename: 'CosmosSectionDevelopersList', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionDivider_Fragment = { __typename: 'CosmosSectionDivider', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionDownloadCard_Fragment = { __typename: 'CosmosSectionDownloadCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionDownloadable_Fragment = { __typename: 'CosmosSectionDownloadable', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionEmbed_Fragment = { __typename: 'CosmosSectionEmbed', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionEventsTable_Fragment = { __typename: 'CosmosSectionEventsTable', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionFaq_Fragment = { __typename: 'CosmosSectionFaq', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionFaqSearch_Fragment = { __typename: 'CosmosSectionFaqSearch', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionFeatureCard_Fragment = { __typename: 'CosmosSectionFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionGameDevFeatureCard_Fragment = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionGeminiCard_Fragment = { __typename: 'CosmosSectionGeminiCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionHydrusColumnList_Fragment = { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionLatestNews_Fragment = { __typename: 'CosmosSectionLatestNews', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionLearn_Fragment = { __typename: 'CosmosSectionLearn', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionLicensesCollapsed_Fragment = { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionLogoList_Fragment = { __typename: 'CosmosSectionLogoList', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionLogoMultiCard_Fragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionNewsCard_Fragment = { __typename: 'CosmosSectionNewsCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionNewsMediaCard_Fragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionNewsletterSignup_Fragment = { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionNumberCallout_Fragment = { __typename: 'CosmosSectionNumberCallout', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionOrionCards_Fragment = { __typename: 'CosmosSectionOrionCards', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionPluginListTable_Fragment = { __typename: 'CosmosSectionPluginListTable', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionQuote_Fragment = { __typename: 'CosmosSectionQuote', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionResellersSearch_Fragment = { __typename: 'CosmosSectionResellersSearch', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionRichText_Fragment = { __typename: 'CosmosSectionRichText', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionSimpleCta_Fragment = { __typename: 'CosmosSectionSimpleCta', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionSlimContactCard_Fragment = { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionSpeakerCard_Fragment = { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionTabbedBlogCard_Fragment = { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionTabbedContentImage_Fragment = { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionTabbedFullWidthAsset_Fragment = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSectionUtCard_Fragment = { __typename: 'CosmosSectionUtCard', id: string, stage: Types.Stage };

type CosmosEntity_CosmosSeo_Fragment = { __typename: 'CosmosSeo', id: string, stage: Types.Stage };

type CosmosEntity_ElementLearnCategory_Fragment = { __typename: 'ElementLearnCategory', id: string, stage: Types.Stage };

type CosmosEntity_RemoteLearn_Fragment = { __typename: 'RemoteLearn', id: string, stage: Types.Stage };

type CosmosEntity_ScheduledOperation_Fragment = { __typename: 'ScheduledOperation', id: string, stage: Types.Stage };

type CosmosEntity_ScheduledRelease_Fragment = { __typename: 'ScheduledRelease', id: string, stage: Types.Stage };

type CosmosEntity_User_Fragment = { __typename: 'User', id: string, stage: Types.Stage };

type CosmosEntity_WfRefApplicationOwner_Fragment = { __typename: 'WfRefApplicationOwner', id: string, stage: Types.Stage };

type CosmosEntity_WfRefBlogCategory_Fragment = { __typename: 'WfRefBlogCategory', id: string, stage: Types.Stage };

type CosmosEntity_WfRefBlogTag_Fragment = { __typename: 'WfRefBlogTag', id: string, stage: Types.Stage };

export type CosmosEntityFragment =
  | CosmosEntity_Asset_Fragment
  | CosmosEntity_CommunityCard_Fragment
  | CosmosEntity_CommunityResource_Fragment
  | CosmosEntity_CosmosConfigBlog_Fragment
  | CosmosEntity_CosmosConfigSection_Fragment
  | CosmosEntity_CosmosDetailServicePartner_Fragment
  | CosmosEntity_CosmosElementAccordionFeatureCard_Fragment
  | CosmosEntity_CosmosElementAccordionTierCard_Fragment
  | CosmosEntity_CosmosElementAccordionTierCtaCard_Fragment
  | CosmosEntity_CosmosElementAccordionTierFeatureCard_Fragment
  | CosmosEntity_CosmosElementAgreementDetail_Fragment
  | CosmosEntity_CosmosElementAriesCard_Fragment
  | CosmosEntity_CosmosElementAsset_Fragment
  | CosmosEntity_CosmosElementAvatar_Fragment
  | CosmosEntity_CosmosElementBlogCard_Fragment
  | CosmosEntity_CosmosElementButton_Fragment
  | CosmosEntity_CosmosElementButtonList_Fragment
  | CosmosEntity_CosmosElementCalloutCard_Fragment
  | CosmosEntity_CosmosElementCheckListItem_Fragment
  | CosmosEntity_CosmosElementCkEditorText_Fragment
  | CosmosEntity_CosmosElementCkEditorTextCollapsible_Fragment
  | CosmosEntity_CosmosElementCompare_Fragment
  | CosmosEntity_CosmosElementComplexCtaCard_Fragment
  | CosmosEntity_CosmosElementCruxLink_Fragment
  | CosmosEntity_CosmosElementDelphinusCard_Fragment
  | CosmosEntity_CosmosElementDocumentList_Fragment
  | CosmosEntity_CosmosElementDocumentListItem_Fragment
  | CosmosEntity_CosmosElementDownloadButton_Fragment
  | CosmosEntity_CosmosElementDownloadCard_Fragment
  | CosmosEntity_CosmosElementDownloadStep_Fragment
  | CosmosEntity_CosmosElementEdsIconLink_Fragment
  | CosmosEntity_CosmosElementEventsTableRow_Fragment
  | CosmosEntity_CosmosElementFaqItem_Fragment
  | CosmosEntity_CosmosElementFaqTab_Fragment
  | CosmosEntity_CosmosElementFeatureCard_Fragment
  | CosmosEntity_CosmosElementGameDevFeatureCard_Fragment
  | CosmosEntity_CosmosElementGeminiCard_Fragment
  | CosmosEntity_CosmosElementGeminiLink_Fragment
  | CosmosEntity_CosmosElementGithubGist_Fragment
  | CosmosEntity_CosmosElementHydrusColumn_Fragment
  | CosmosEntity_CosmosElementHydrusLink_Fragment
  | CosmosEntity_CosmosElementIconButton_Fragment
  | CosmosEntity_CosmosElementIconLinkGroup_Fragment
  | CosmosEntity_CosmosElementIconSectionHeading_Fragment
  | CosmosEntity_CosmosElementImageTag_Fragment
  | CosmosEntity_CosmosElementIndustry_Fragment
  | CosmosEntity_CosmosElementInterview_Fragment
  | CosmosEntity_CosmosElementInterviewQuestion_Fragment
  | CosmosEntity_CosmosElementLearnDocumentationCard_Fragment
  | CosmosEntity_CosmosElementLearnImageCard_Fragment
  | CosmosEntity_CosmosElementLearnImageCardSource_Fragment
  | CosmosEntity_CosmosElementLearnTab_Fragment
  | CosmosEntity_CosmosElementLicenseCardCore_Fragment
  | CosmosEntity_CosmosElementLicenseCardTop_Fragment
  | CosmosEntity_CosmosElementLicenseCollapsedCard_Fragment
  | CosmosEntity_CosmosElementLicenseContactCard_Fragment
  | CosmosEntity_CosmosElementLicenseMainCard_Fragment
  | CosmosEntity_CosmosElementLicenseSeat_Fragment
  | CosmosEntity_CosmosElementLicenseTopCard_Fragment
  | CosmosEntity_CosmosElementLink_Fragment
  | CosmosEntity_CosmosElementLogo_Fragment
  | CosmosEntity_CosmosElementLogoMultiCard_Fragment
  | CosmosEntity_CosmosElementNewsCard_Fragment
  | CosmosEntity_CosmosElementNewsMediaCard_Fragment
  | CosmosEntity_CosmosElementNumberCallout_Fragment
  | CosmosEntity_CosmosElementOrionCard_Fragment
  | CosmosEntity_CosmosElementPluginDownload_Fragment
  | CosmosEntity_CosmosElementPluginDownloadDetail_Fragment
  | CosmosEntity_CosmosElementPluginListItem_Fragment
  | CosmosEntity_CosmosElementQuote_Fragment
  | CosmosEntity_CosmosElementResearchCard_Fragment
  | CosmosEntity_CosmosElementResellerCard_Fragment
  | CosmosEntity_CosmosElementRichText_Fragment
  | CosmosEntity_CosmosElementSearchFilter_Fragment
  | CosmosEntity_CosmosElementSectionHeading_Fragment
  | CosmosEntity_CosmosElementSpeakerCard_Fragment
  | CosmosEntity_CosmosElementTabbedBlogCardsItem_Fragment
  | CosmosEntity_CosmosElementTabbedContentImageItem_Fragment
  | CosmosEntity_CosmosElementTabbedFullWidthAssetItem_Fragment
  | CosmosEntity_CosmosElementTag_Fragment
  | CosmosEntity_CosmosElementTitleAndDesc_Fragment
  | CosmosEntity_CosmosElementUserProfile_Fragment
  | CosmosEntity_CosmosElementUtCard_Fragment
  | CosmosEntity_CosmosElementVideoEmbed_Fragment
  | CosmosEntity_CosmosFeedBlogCard_Fragment
  | CosmosEntity_CosmosHeroAlpha_Fragment
  | CosmosEntity_CosmosHeroArticleImage_Fragment
  | CosmosEntity_CosmosHeroBravo_Fragment
  | CosmosEntity_CosmosHeroGlow_Fragment
  | CosmosEntity_CosmosPageAgreement_Fragment
  | CosmosEntity_CosmosPageBlogDetail_Fragment
  | CosmosEntity_CosmosPageDirectory_Fragment
  | CosmosEntity_CosmosPageEulaKey_Fragment
  | CosmosEntity_CosmosPageFeed_Fragment
  | CosmosEntity_CosmosPageHeroAndSection_Fragment
  | CosmosEntity_CosmosPageLegalContent_Fragment
  | CosmosEntity_CosmosPageLicense_Fragment
  | CosmosEntity_CosmosPagePluginDetail_Fragment
  | CosmosEntity_CosmosPageRedirect_Fragment
  | CosmosEntity_CosmosPageResearch_Fragment
  | CosmosEntity_CosmosPageSearch_Fragment
  | CosmosEntity_CosmosRefIndustryList_Fragment
  | CosmosEntity_CosmosReferenceFaqItem_Fragment
  | CosmosEntity_CosmosReferenceSection_Fragment
  | CosmosEntity_CosmosRemoteLearn_Fragment
  | CosmosEntity_CosmosSectionAccordionFeatureCard_Fragment
  | CosmosEntity_CosmosSectionAccordionTierCards_Fragment
  | CosmosEntity_CosmosSectionAriesCards_Fragment
  | CosmosEntity_CosmosSectionAsset_Fragment
  | CosmosEntity_CosmosSectionAssetCarousel_Fragment
  | CosmosEntity_CosmosSectionAssetGallery_Fragment
  | CosmosEntity_CosmosSectionBlobTable_Fragment
  | CosmosEntity_CosmosSectionBlogCard_Fragment
  | CosmosEntity_CosmosSectionCkRichText_Fragment
  | CosmosEntity_CosmosSectionCommunity_Fragment
  | CosmosEntity_CosmosSectionComplexCtaCard_Fragment
  | CosmosEntity_CosmosSectionContentLargeImage_Fragment
  | CosmosEntity_CosmosSectionContentSliderAsset_Fragment
  | CosmosEntity_CosmosSectionCrux_Fragment
  | CosmosEntity_CosmosSectionDelphinusCardsGrid_Fragment
  | CosmosEntity_CosmosSectionDevelopersList_Fragment
  | CosmosEntity_CosmosSectionDivider_Fragment
  | CosmosEntity_CosmosSectionDownloadCard_Fragment
  | CosmosEntity_CosmosSectionDownloadable_Fragment
  | CosmosEntity_CosmosSectionEmbed_Fragment
  | CosmosEntity_CosmosSectionEventsTable_Fragment
  | CosmosEntity_CosmosSectionFaq_Fragment
  | CosmosEntity_CosmosSectionFaqSearch_Fragment
  | CosmosEntity_CosmosSectionFeatureCard_Fragment
  | CosmosEntity_CosmosSectionGameDevFeatureCard_Fragment
  | CosmosEntity_CosmosSectionGeminiCard_Fragment
  | CosmosEntity_CosmosSectionHydrusColumnList_Fragment
  | CosmosEntity_CosmosSectionLatestNews_Fragment
  | CosmosEntity_CosmosSectionLearn_Fragment
  | CosmosEntity_CosmosSectionLicensesCollapsed_Fragment
  | CosmosEntity_CosmosSectionLogoList_Fragment
  | CosmosEntity_CosmosSectionLogoMultiCard_Fragment
  | CosmosEntity_CosmosSectionNewsCard_Fragment
  | CosmosEntity_CosmosSectionNewsMediaCard_Fragment
  | CosmosEntity_CosmosSectionNewsletterSignup_Fragment
  | CosmosEntity_CosmosSectionNumberCallout_Fragment
  | CosmosEntity_CosmosSectionOrionCards_Fragment
  | CosmosEntity_CosmosSectionPluginListTable_Fragment
  | CosmosEntity_CosmosSectionQuote_Fragment
  | CosmosEntity_CosmosSectionResellersSearch_Fragment
  | CosmosEntity_CosmosSectionRichText_Fragment
  | CosmosEntity_CosmosSectionSimpleCta_Fragment
  | CosmosEntity_CosmosSectionSlimContactCard_Fragment
  | CosmosEntity_CosmosSectionSpeakerCard_Fragment
  | CosmosEntity_CosmosSectionTabbedBlogCard_Fragment
  | CosmosEntity_CosmosSectionTabbedContentImage_Fragment
  | CosmosEntity_CosmosSectionTabbedFullWidthAsset_Fragment
  | CosmosEntity_CosmosSectionUtCard_Fragment
  | CosmosEntity_CosmosSeo_Fragment
  | CosmosEntity_ElementLearnCategory_Fragment
  | CosmosEntity_RemoteLearn_Fragment
  | CosmosEntity_ScheduledOperation_Fragment
  | CosmosEntity_ScheduledRelease_Fragment
  | CosmosEntity_User_Fragment
  | CosmosEntity_WfRefApplicationOwner_Fragment
  | CosmosEntity_WfRefBlogCategory_Fragment
  | CosmosEntity_WfRefBlogTag_Fragment
;

export type RefSectionsEntitiesFragment = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type RefSectionsFragment = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type PageHeroAndSectionsEntitiesFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

export type PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

export type PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

export type PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

export type PageHeroAndSectionsEntitiesFragment_hero =
  | PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroAlpha
  | PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroArticleImage
  | PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroBravo
  | PageHeroAndSectionsEntitiesFragment_hero_CosmosHeroGlow
;

export type PageHeroAndSectionsEntitiesFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type PageHeroAndSectionsEntitiesFragment = { __typename: 'CosmosPageHeroAndSection', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageHeroAndSectionsEntitiesFragment_owner | null, hero?: PageHeroAndSectionsEntitiesFragment_hero | null, refSections: Array<PageHeroAndSectionsEntitiesFragment_refSections> };

export type PageHeroAndSectionsFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageHeroAndSectionsFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type PageHeroAndSectionsFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type PageHeroAndSectionsFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type PageHeroAndSectionsFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type PageHeroAndSectionsFragment_hero =
  | PageHeroAndSectionsFragment_hero_CosmosHeroAlpha
  | PageHeroAndSectionsFragment_hero_CosmosHeroArticleImage
  | PageHeroAndSectionsFragment_hero_CosmosHeroBravo
  | PageHeroAndSectionsFragment_hero_CosmosHeroGlow
;

export type PageHeroAndSectionsFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type PageHeroAndSectionsFragment = { __typename: 'CosmosPageHeroAndSection', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageHeroAndSectionsFragment_owner | null, hero?: PageHeroAndSectionsFragment_hero | null, refSections: Array<PageHeroAndSectionsFragment_refSections> };

export type PageHeroAndSectionsMetadataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageHeroAndSectionsMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageHeroAndSectionsMetadataFragment = { __typename: 'CosmosPageHeroAndSection', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageHeroAndSectionsMetadataFragment_owner | null, metaTags?: PageHeroAndSectionsMetadataFragment_metaTags | null };

export type CosmosElementCkEditorTextFragment = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type CosmosElementCkEditorTextCollapsibleFragment = { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null };

type PageLegalContentSections_CosmosElementCkEditorText_Fragment = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

type PageLegalContentSections_CosmosElementCkEditorTextCollapsible_Fragment = { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null };

export type PageLegalContentSectionsFragment =
  | PageLegalContentSections_CosmosElementCkEditorText_Fragment
  | PageLegalContentSections_CosmosElementCkEditorTextCollapsible_Fragment
;

export type PageLegalContentEntitiesFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageLegalContentEntitiesFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

export type PageLegalContentEntitiesFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

export type PageLegalContentEntitiesFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

export type PageLegalContentEntitiesFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

export type PageLegalContentEntitiesFragment_hero =
  | PageLegalContentEntitiesFragment_hero_CosmosHeroAlpha
  | PageLegalContentEntitiesFragment_hero_CosmosHeroArticleImage
  | PageLegalContentEntitiesFragment_hero_CosmosHeroBravo
  | PageLegalContentEntitiesFragment_hero_CosmosHeroGlow
;

export type PageLegalContentEntitiesFragment_sections_CosmosElementCkEditorText = { __typename: 'CosmosElementCkEditorText', id: string, stage: Types.Stage };

export type PageLegalContentEntitiesFragment_sections_CosmosElementCkEditorTextCollapsible = { __typename: 'CosmosElementCkEditorTextCollapsible', id: string, stage: Types.Stage };

export type PageLegalContentEntitiesFragment_sections =
  | PageLegalContentEntitiesFragment_sections_CosmosElementCkEditorText
  | PageLegalContentEntitiesFragment_sections_CosmosElementCkEditorTextCollapsible
;

export type PageLegalContentEntitiesFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageLegalContentEntitiesFragment_owner | null, hero?: PageLegalContentEntitiesFragment_hero | null, sections: Array<PageLegalContentEntitiesFragment_sections> };

export type PageLegalContentFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageLegalContentFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type PageLegalContentFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type PageLegalContentFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type PageLegalContentFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type PageLegalContentFragment_hero =
  | PageLegalContentFragment_hero_CosmosHeroAlpha
  | PageLegalContentFragment_hero_CosmosHeroArticleImage
  | PageLegalContentFragment_hero_CosmosHeroBravo
  | PageLegalContentFragment_hero_CosmosHeroGlow
;

export type PageLegalContentFragment_sections_CosmosElementCkEditorText = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type PageLegalContentFragment_sections_CosmosElementCkEditorTextCollapsible = { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null };

export type PageLegalContentFragment_sections =
  | PageLegalContentFragment_sections_CosmosElementCkEditorText
  | PageLegalContentFragment_sections_CosmosElementCkEditorTextCollapsible
;

export type PageLegalContentFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, owner?: PageLegalContentFragment_owner | null, hero?: PageLegalContentFragment_hero | null, sections: Array<PageLegalContentFragment_sections> };

export type PageLegalContentMetadataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageLegalContentMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageLegalContentMetadataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageLegalContentMetadataFragment_owner | null, metaTags?: PageLegalContentMetadataFragment_metaTags | null };

export type PageLegalContentSlugDataFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type PageLegalContentSlugDataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, locale: Types.Locale, owner?: PageLegalContentSlugDataFragment_owner | null };

export type CosmosPageLicenseCoreFragment_hero = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type CosmosPageLicenseCoreFragment_contentLargeImages = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type CosmosPageLicenseCoreFragment_freeCard = { __typename: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<LicenseTopCardFragment_bullets>, checkList: Array<LicenseTopCardFragment_checkList>, buttons: Array<LicenseTopCardFragment_buttons> };

export type CosmosPageLicenseCoreFragment_mainCards = { __typename: 'CosmosElementLicenseMainCard', cardTop?: LicenseMainCardFragment_cardTop | null, cardSections: Array<LicenseMainCardFragment_cardSections>, seats?: LicenseMainCardFragment_seats | null };

export type CosmosPageLicenseCoreFragment_contactCard = { slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type CosmosPageLicenseCoreFragment_contactCard2 = { slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type CosmosPageLicenseCoreFragment = { id: string, createdAt?: any, updatedAt?: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, hero?: CosmosPageLicenseCoreFragment_hero | null, contentLargeImages: Array<CosmosPageLicenseCoreFragment_contentLargeImages>, freeCard?: CosmosPageLicenseCoreFragment_freeCard | null, mainCards: Array<CosmosPageLicenseCoreFragment_mainCards>, contactCard?: CosmosPageLicenseCoreFragment_contactCard | null, contactCard2?: CosmosPageLicenseCoreFragment_contactCard2 | null };

export type CosmosPageLicenseEntitiesFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type CosmosPageLicenseEntitiesFragment = { id: string, createdAt?: any, updatedAt?: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, refSections: Array<CosmosPageLicenseEntitiesFragment_refSections>, hero?: CosmosPageLicenseCoreFragment_hero | null, contentLargeImages: Array<CosmosPageLicenseCoreFragment_contentLargeImages>, freeCard?: CosmosPageLicenseCoreFragment_freeCard | null, mainCards: Array<CosmosPageLicenseCoreFragment_mainCards>, contactCard?: CosmosPageLicenseCoreFragment_contactCard | null, contactCard2?: CosmosPageLicenseCoreFragment_contactCard2 | null };

export type CosmosPageLicenseFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type CosmosPageLicenseFragment = { id: string, createdAt?: any, updatedAt?: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, refSections: Array<CosmosPageLicenseFragment_refSections>, hero?: CosmosPageLicenseCoreFragment_hero | null, contentLargeImages: Array<CosmosPageLicenseCoreFragment_contentLargeImages>, freeCard?: CosmosPageLicenseCoreFragment_freeCard | null, mainCards: Array<CosmosPageLicenseCoreFragment_mainCards>, contactCard?: CosmosPageLicenseCoreFragment_contactCard | null, contactCard2?: CosmosPageLicenseCoreFragment_contactCard2 | null };

export type CosmosPageLicenseMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type CosmosPageLicenseMetadataFragment = { createdAt?: any, updatedAt?: any, slug?: string | null, id: string, metaTags?: CosmosPageLicenseMetadataFragment_metaTags | null };

export type PagePluginDetailEntitiesFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, stage: Types.Stage };

export type PagePluginDetailEntitiesFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, stage: Types.Stage };

export type PagePluginDetailEntitiesFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, stage: Types.Stage };

export type PagePluginDetailEntitiesFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, stage: Types.Stage };

export type PagePluginDetailEntitiesFragment_hero =
  | PagePluginDetailEntitiesFragment_hero_CosmosHeroAlpha
  | PagePluginDetailEntitiesFragment_hero_CosmosHeroArticleImage
  | PagePluginDetailEntitiesFragment_hero_CosmosHeroBravo
  | PagePluginDetailEntitiesFragment_hero_CosmosHeroGlow
;

export type PagePluginDetailEntitiesFragment_downloads = { title?: string | null, desc?: string | null, details: Array<CosmosPluginDownloadFragment_details> };

export type PagePluginDetailEntitiesFragment_latestCardSections = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementAsset = { __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: ArticleComponentsFragment_articleComponentAsset };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementButtonList = { __typename: 'CosmosElementButtonList', buttons: Array<ArticleComponentsFragment_CosmosElementButtonList_buttons> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementCalloutCard = { __typename: 'CosmosElementCalloutCard', icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: CosmosCalloutCardFragment_title | null, buttons: Array<CosmosCalloutCardFragment_buttons> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementCkEditorText = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementCompare = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: CosmosCompareFragment_leftImage | null, rightImage?: CosmosCompareFragment_rightImage | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementGithubGist = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementInterview = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<CosmosInterviewFragment_questions> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementLicenseContactCard = { __typename: 'CosmosElementLicenseContactCard', slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementQuote = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementRichText = { __typename: 'CosmosElementRichText', text: ArticleComponentsFragment_CosmosElementRichText_text };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementSectionHeading = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementTitleAndDesc = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementUserProfile = { __typename: 'CosmosElementUserProfile', variant?: Types.CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: ArticleComponentsFragment_CosmosElementUserProfile_avatar | null, logoImage?: ArticleComponentsFragment_CosmosElementUserProfile_logoImage | null, button?: ArticleComponentsFragment_CosmosElementUserProfile_button | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosElementVideoEmbed = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type PagePluginDetailEntitiesFragment_articleComponents =
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementAsset
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementButtonList
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementCalloutCard
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementCkEditorText
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementCompare
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementGithubGist
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementInterview
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementLicenseContactCard
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementQuote
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementRichText
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementSectionHeading
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementTitleAndDesc
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementUserProfile
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosElementVideoEmbed
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionAssetCarousel
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionAssetGallery
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionContentLargeImage
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionDivider
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionLogoList
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionLogoMultiCard
  | PagePluginDetailEntitiesFragment_articleComponents_CosmosSectionNewsMediaCard
;

export type PagePluginDetailEntitiesFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, stage: Types.Stage, section?: PageDirectoryEntitiesFragment_topRefSections_section | null };

export type PagePluginDetailEntitiesFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, archivedVersionsTitle?: string | null, hero?: PagePluginDetailEntitiesFragment_hero | null, downloads: Array<PagePluginDetailEntitiesFragment_downloads>, latestCardSections: Array<PagePluginDetailEntitiesFragment_latestCardSections>, articleComponents: Array<PagePluginDetailEntitiesFragment_articleComponents>, refSections: Array<PagePluginDetailEntitiesFragment_refSections> };

export type PagePluginDetailFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type PagePluginDetailFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type PagePluginDetailFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type PagePluginDetailFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type PagePluginDetailFragment_hero =
  | PagePluginDetailFragment_hero_CosmosHeroAlpha
  | PagePluginDetailFragment_hero_CosmosHeroArticleImage
  | PagePluginDetailFragment_hero_CosmosHeroBravo
  | PagePluginDetailFragment_hero_CosmosHeroGlow
;

export type PagePluginDetailFragment_downloads = { title?: string | null, desc?: string | null, details: Array<CosmosPluginDownloadFragment_details> };

export type PagePluginDetailFragment_latestCardSections = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementAsset = { __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: ArticleComponentsFragment_articleComponentAsset };

export type PagePluginDetailFragment_articleComponents_CosmosElementButtonList = { __typename: 'CosmosElementButtonList', buttons: Array<ArticleComponentsFragment_CosmosElementButtonList_buttons> };

export type PagePluginDetailFragment_articleComponents_CosmosElementCalloutCard = { __typename: 'CosmosElementCalloutCard', icon?: Types.EdsIconsEnum | null, desc?: string | null, title?: CosmosCalloutCardFragment_title | null, buttons: Array<CosmosCalloutCardFragment_buttons> };

export type PagePluginDetailFragment_articleComponents_CosmosElementCkEditorText = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementCompare = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: CosmosCompareFragment_leftImage | null, rightImage?: CosmosCompareFragment_rightImage | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementGithubGist = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementInterview = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<CosmosInterviewFragment_questions> };

export type PagePluginDetailFragment_articleComponents_CosmosElementLicenseContactCard = { __typename: 'CosmosElementLicenseContactCard', slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type PagePluginDetailFragment_articleComponents_CosmosElementQuote = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: Types.CosmosEnumEdsGradients | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementRichText = { __typename: 'CosmosElementRichText', text: ArticleComponentsFragment_CosmosElementRichText_text };

export type PagePluginDetailFragment_articleComponents_CosmosElementSectionHeading = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type PagePluginDetailFragment_articleComponents_CosmosElementTitleAndDesc = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: CosmosTitleAndDescFragment_title | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementUserProfile = { __typename: 'CosmosElementUserProfile', variant?: Types.CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: ArticleComponentsFragment_CosmosElementUserProfile_avatar | null, logoImage?: ArticleComponentsFragment_CosmosElementUserProfile_logoImage | null, button?: ArticleComponentsFragment_CosmosElementUserProfile_button | null };

export type PagePluginDetailFragment_articleComponents_CosmosElementVideoEmbed = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: CosmosVideoEmbedFragment_overlayImage | null };

export type PagePluginDetailFragment_articleComponents_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type PagePluginDetailFragment_articleComponents_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type PagePluginDetailFragment_articleComponents_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type PagePluginDetailFragment_articleComponents_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type PagePluginDetailFragment_articleComponents_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type PagePluginDetailFragment_articleComponents_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type PagePluginDetailFragment_articleComponents_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type PagePluginDetailFragment_articleComponents =
  | PagePluginDetailFragment_articleComponents_CosmosElementAsset
  | PagePluginDetailFragment_articleComponents_CosmosElementButtonList
  | PagePluginDetailFragment_articleComponents_CosmosElementCalloutCard
  | PagePluginDetailFragment_articleComponents_CosmosElementCkEditorText
  | PagePluginDetailFragment_articleComponents_CosmosElementCompare
  | PagePluginDetailFragment_articleComponents_CosmosElementGithubGist
  | PagePluginDetailFragment_articleComponents_CosmosElementInterview
  | PagePluginDetailFragment_articleComponents_CosmosElementLicenseContactCard
  | PagePluginDetailFragment_articleComponents_CosmosElementQuote
  | PagePluginDetailFragment_articleComponents_CosmosElementRichText
  | PagePluginDetailFragment_articleComponents_CosmosElementSectionHeading
  | PagePluginDetailFragment_articleComponents_CosmosElementTitleAndDesc
  | PagePluginDetailFragment_articleComponents_CosmosElementUserProfile
  | PagePluginDetailFragment_articleComponents_CosmosElementVideoEmbed
  | PagePluginDetailFragment_articleComponents_CosmosSectionAssetCarousel
  | PagePluginDetailFragment_articleComponents_CosmosSectionAssetGallery
  | PagePluginDetailFragment_articleComponents_CosmosSectionContentLargeImage
  | PagePluginDetailFragment_articleComponents_CosmosSectionDivider
  | PagePluginDetailFragment_articleComponents_CosmosSectionLogoList
  | PagePluginDetailFragment_articleComponents_CosmosSectionLogoMultiCard
  | PagePluginDetailFragment_articleComponents_CosmosSectionNewsMediaCard
;

export type PagePluginDetailFragment_refSections = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type PagePluginDetailFragment = { createdAt?: any, updatedAt?: any, slug: string, archivedVersionsTitle?: string | null, hero?: PagePluginDetailFragment_hero | null, downloads: Array<PagePluginDetailFragment_downloads>, latestCardSections: Array<PagePluginDetailFragment_latestCardSections>, articleComponents: Array<PagePluginDetailFragment_articleComponents>, refSections: Array<PagePluginDetailFragment_refSections> };

export type PagePluginDetailMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PagePluginDetailMetadataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, metaTags?: PagePluginDetailMetadataFragment_metaTags | null };

export type CosmosRedirectPageFragment_owner = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type CosmosRedirectPageFragment = { __typename: 'CosmosPageRedirect', id: string, slug: string, destination: string, permanent?: boolean | null, owner?: CosmosRedirectPageFragment_owner | null };

export type ResearchCardFragment_title = { __typename: 'RichText', html: string, text: string };

export type ResearchCardFragment_asset = { __typename: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: AccordionTierFeatureCardFragment_asset_fallbackImage | null };

export type ResearchCardFragment = { href?: string | null, publicationDate?: any, desc?: string | null, footer?: string | null, title?: ResearchCardFragment_title | null, asset?: ResearchCardFragment_asset | null };

export type PageResearchFragment_hero_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type PageResearchFragment_hero_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type PageResearchFragment_hero_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type PageResearchFragment_hero_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type PageResearchFragment_hero =
  | PageResearchFragment_hero_CosmosHeroAlpha
  | PageResearchFragment_hero_CosmosHeroArticleImage
  | PageResearchFragment_hero_CosmosHeroBravo
  | PageResearchFragment_hero_CosmosHeroGlow
;

export type PageResearchFragment_researchCards = { href?: string | null, publicationDate?: any, desc?: string | null, footer?: string | null, title?: ResearchCardFragment_title | null, asset?: ResearchCardFragment_asset | null };

export type PageResearchFragment_researchCardsSectionConfig = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

export type PageResearchFragment = { createdAt?: any, updatedAt?: any, slug: string, hero?: PageResearchFragment_hero | null, researchCards: Array<PageResearchFragment_researchCards>, researchCardsSectionConfig?: PageResearchFragment_researchCardsSectionConfig | null };

export type PageResearchMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageResearchMetadataFragment = { id: string, createdAt?: any, updatedAt?: any, slug: string, metaTags?: PageResearchMetadataFragment_metaTags | null };

export type SearchFilterFragment = { id: string, label?: string | null, value?: string | null };

export type PageSearchFragment_searchFilters = { id: string, label?: string | null, value?: string | null };

export type PageSearchFragment_suggestedLinks = { id: string, eyebrow?: string | null, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: Types.CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: GeminiCardFragment_heading | null, badge?: GeminiCardFragment_badge | null, title?: GeminiCardFragment_title | null, links: Array<GeminiCardFragment_links>, buttons: Array<GeminiCardFragment_buttons>, modButtons: Array<GeminiCardFragment_modButtons>, asset?: GeminiCardFragment_asset | null };

export type PageSearchFragment = { __typename: 'CosmosPageSearch', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, desc?: string | null, searchPlaceholder?: string | null, clearSearchLabel?: string | null, defaultSearchFilter?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, suggestedLinksLabel?: string | null, searchFilters: Array<PageSearchFragment_searchFilters>, suggestedLinks: Array<PageSearchFragment_suggestedLinks> };

export type PageSearchMetadataFragment_metaTags = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type PageSearchMetadataFragment_searchFilters = { id: string, label?: string | null, value?: string | null };

export type PageSearchMetadataFragment = { __typename: 'CosmosPageSearch', id: string, createdAt?: any, updatedAt?: any, slug: string, defaultSearchFilter?: string | null, metaTags?: PageSearchMetadataFragment_metaTags | null, searchFilters: Array<PageSearchMetadataFragment_searchFilters> };

export type PageSearchFiltersFragment_searchFilters = { id: string, label?: string | null, value?: string | null };

export type PageSearchFiltersFragment = { __typename: 'CosmosPageSearch', id: string, slug: string, defaultSearchFilter?: string | null, searchFilters: Array<PageSearchFiltersFragment_searchFilters> };

export type PluginListItemFragment = { __typename: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems_downloads>, extraButtons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems_extraButtons> };

export type PluginListTableSectionFragment = { __typename: 'CosmosSectionPluginListTable', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config | null, tableItems: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems> };

export type QuoteSectionFragment = { __typename: 'CosmosSectionQuote', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config | null, quotes: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes> };

export type ResellerCardFragment = { __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<Types.CosmosEnumResellerContinents>, location?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards_location | null };

export type ResellersSearchSectionFragment = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards>, cards2: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2>, cards3: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3>, cards4: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4>, blurredBackgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage | null };

export type RichTextSectionFragment = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config | null, content?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons> };

export type CkRichTextSectionFragment = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons> };

export type SectionHeadingFragment = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type IconSectionHeadingFragment = { __typename: 'CosmosElementIconSectionHeading', icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, titleGradient?: Types.CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_modButtons> };

type SectionConfigHeadingUnion_CosmosElementIconSectionHeading_Fragment = { __typename: 'CosmosElementIconSectionHeading', icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, titleGradient?: Types.CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_modButtons> };

type SectionConfigHeadingUnion_CosmosElementSectionHeading_Fragment = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: Types.CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_title | null, buttons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_buttons>, modButtons: Array<AccordionTierCardsSectionFragment_config_heading_CosmosElementSectionHeading_modButtons> };

export type SectionConfigHeadingUnionFragment =
  | SectionConfigHeadingUnion_CosmosElementIconSectionHeading_Fragment
  | SectionConfigHeadingUnion_CosmosElementSectionHeading_Fragment
;

export type SectionConfigFragment = { __typename: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: Types.CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, backgroundOverlayOverride?: Types.EnumBackgroundGradientOverlays | null, backgroundLayoutOverride?: Types.EnumBackgroundLayoutType | null, heading?: AccordionTierCardsSectionFragment_config_heading | null, backgroundImage?: AccordionTierCardsSectionFragment_config_backgroundImage | null };

type PageSections_CosmosSectionAccordionFeatureCard_Fragment = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: AccordionFeatureCardsSectionFragment_config | null, items: Array<AccordionFeatureCardsSectionFragment_items> };

type PageSections_CosmosSectionAccordionTierCards_Fragment = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: AccordionTierCardsSectionFragment_config | null, items: Array<AccordionTierCardsSectionFragment_items> };

type PageSections_CosmosSectionAriesCards_Fragment = { __typename: 'CosmosSectionAriesCards', id: string, config?: AriesCardsSectionFragment_config | null, cards: Array<AriesCardsSectionFragment_cards> };

type PageSections_CosmosSectionAsset_Fragment = { __typename: 'CosmosSectionAsset', id: string, size?: Types.CosmosEnumSectionSizes | null, caption?: string | null, config?: AssetSectionFragment_config | null, sectionAsset: AssetSectionFragment_sectionAsset };

type PageSections_CosmosSectionAssetCarousel_Fragment = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

type PageSections_CosmosSectionAssetGallery_Fragment = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

type PageSections_CosmosSectionBlobTable_Fragment = { __typename: 'CosmosSectionBlobTable', id: string, environmentVariable: string, limit?: number | null, variant?: Types.CosmosEnumBlobTableVariants | null, config?: BlobTableSectionFragment_config | null };

type PageSections_CosmosSectionBlogCard_Fragment = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: Types.CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: BlogCardsSectionFragment_config | null, cards: Array<BlogCardsSectionFragment_cards> };

type PageSections_CosmosSectionCkRichText_Fragment = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons> };

type PageSections_CosmosSectionCommunity_Fragment = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: Types.CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: CommunitySectionFragment_config | null, forumButton?: CommunitySectionFragment_forumButton | null, resources?: CommunitySectionFragment_resources | null };

type PageSections_CosmosSectionComplexCtaCard_Fragment = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: Types.CosmosEnumComplexCtaVariant | null, config?: ComplexCtaCardsSectionFragment_config | null, cards: Array<ComplexCtaCardsSectionFragment_cards>, bottomDescription?: ComplexCtaCardsSectionFragment_bottomDescription | null };

type PageSections_CosmosSectionContentLargeImage_Fragment = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

type PageSections_CosmosSectionContentSliderAsset_Fragment = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentSliderAssetFragment_config | null, badges: Array<ContentSliderAssetFragment_badges>, title?: ContentSliderAssetFragment_title | null, buttons: Array<ContentSliderAssetFragment_buttons>, assets: Array<ContentSliderAssetFragment_assets> };

type PageSections_CosmosSectionCrux_Fragment = { __typename: 'CosmosSectionCrux', id: string, config?: CruxSectionFragment_config | null, cruxLinks: Array<CruxSectionFragment_cruxLinks> };

type PageSections_CosmosSectionDelphinusCardsGrid_Fragment = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: DelphinusCardsGridSectionFragment_config | null, grid: Array<DelphinusCardsGridSectionFragment_grid> };

type PageSections_CosmosSectionDevelopersList_Fragment = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: DevelopersListSectionFragment_config | null, developersTsv?: DevelopersListSectionFragment_developersTsv | null };

type PageSections_CosmosSectionDivider_Fragment = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

type PageSections_CosmosSectionDownloadCard_Fragment = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

type PageSections_CosmosSectionDownloadable_Fragment = { __typename: 'CosmosSectionDownloadable', id: string, config?: DownloadableSectionFragment_config | null, instructions?: DownloadableSectionFragment_instructions | null, executables: Array<DownloadableSectionFragment_executables>, footer?: DownloadableSectionFragment_footer | null };

type PageSections_CosmosSectionEmbed_Fragment = { __typename: 'CosmosSectionEmbed', id: string, size?: Types.CosmosEnumSectionSizes | null, config?: EmbedSectionFragment_config | null, embed?: EmbedSectionFragment_embed | null };

type PageSections_CosmosSectionEventsTable_Fragment = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: EventsTableSectionFragment_config | null, blurredImage?: EventsTableSectionFragment_blurredImage | null, events: Array<EventsTableSectionFragment_events> };

type PageSections_CosmosSectionFaq_Fragment = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSectionFragment_config | null, title?: FaqSectionFragment_title | null, items: Array<FaqSectionFragment_items>, refFaqItems: Array<FaqSectionFragment_refFaqItems>, modButtons: Array<FaqSectionFragment_modButtons>, faqButtons: Array<FaqSectionFragment_faqButtons> };

type PageSections_CosmosSectionFaqSearch_Fragment = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSearchSectionFragment_config | null, title?: FaqSearchSectionFragment_title | null, faqTabs: Array<FaqSearchSectionFragment_faqTabs>, modButtons: Array<FaqSearchSectionFragment_modButtons> };

type PageSections_CosmosSectionFeatureCard_Fragment = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: FeatureCardsSectionFragment_config | null, tags: Array<FeatureCardsSectionFragment_tags>, cards: Array<FeatureCardsSectionFragment_cards> };

type PageSections_CosmosSectionGameDevFeatureCard_Fragment = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: FeaturePanelsSectionFragment_config | null, cards: Array<FeaturePanelsSectionFragment_cards>, buttons: Array<FeaturePanelsSectionFragment_buttons> };

type PageSections_CosmosSectionGeminiCard_Fragment = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: Types.CosmosEnumGeminiVariants | null, logoImage?: GeminiCardsSectionFragment_logoImage | null, config?: GeminiCardsSectionFragment_config | null, title?: GeminiCardsSectionFragment_title | null, cards: Array<GeminiCardsSectionFragment_cards> };

type PageSections_CosmosSectionHydrusColumnList_Fragment = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: HydrusColumnListSectionFragment_config | null, columns: Array<HydrusColumnListSectionFragment_columns> };

type PageSections_CosmosSectionLatestNews_Fragment = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: Types.CosmosEnumLatestNewsVariants | null, config?: LatestNewsSectionFragment_config | null, wfRefBlogTags: Array<LatestNewsSectionFragment_wfRefBlogTags>, cosmosPageBlogDetails: Array<LatestNewsSectionFragment_cosmosPageBlogDetails> };

type PageSections_CosmosSectionLearn_Fragment = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: Types.CosmosEnumApplicationFamily | null, config?: LearnSectionFragment_config | null, tabs: Array<LearnSectionFragment_tabs>, categories: Array<LearnSectionFragment_categories> };

type PageSections_CosmosSectionLicensesCollapsed_Fragment = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: LicensesCollapsedSectionFragment_config | null, topCard?: LicensesCollapsedSectionFragment_topCard | null, collapsedCards: Array<LicensesCollapsedSectionFragment_collapsedCards>, collapsedCta?: LicensesCollapsedSectionFragment_collapsedCta | null };

type PageSections_CosmosSectionLogoList_Fragment = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

type PageSections_CosmosSectionLogoMultiCard_Fragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

type PageSections_CosmosSectionNewsCard_Fragment = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: Types.EnumSmallNewsCardMax | null, config?: NewsCardsSectionFragment_config | null, cards: Array<NewsCardsSectionFragment_cards> };

type PageSections_CosmosSectionNewsMediaCard_Fragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

type PageSections_CosmosSectionNewsletterSignup_Fragment = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: NewsletterSignupFragment_industriesRef | null };

type PageSections_CosmosSectionNumberCallout_Fragment = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: Types.CosmosEnumNumberCalloutVariants | null, config?: NumberCalloutSectionFragment_config | null, title?: NumberCalloutSectionFragment_title | null, callouts: Array<NumberCalloutSectionFragment_callouts>, buttons: Array<NumberCalloutSectionFragment_buttons>, asset?: NumberCalloutSectionFragment_asset | null };

type PageSections_CosmosSectionOrionCards_Fragment = { __typename: 'CosmosSectionOrionCards', id: string, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, config?: OrionCardsSectionFragment_config | null, title?: OrionCardsSectionFragment_title | null, modButtons: Array<OrionCardsSectionFragment_modButtons>, cards: Array<OrionCardsSectionFragment_cards> };

type PageSections_CosmosSectionPluginListTable_Fragment = { __typename: 'CosmosSectionPluginListTable', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config | null, tableItems: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems> };

type PageSections_CosmosSectionQuote_Fragment = { __typename: 'CosmosSectionQuote', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config | null, quotes: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes> };

type PageSections_CosmosSectionResellersSearch_Fragment = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards>, cards2: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2>, cards3: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3>, cards4: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4>, blurredBackgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage | null };

type PageSections_CosmosSectionRichText_Fragment = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config | null, content?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons> };

type PageSections_CosmosSectionSimpleCta_Fragment = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

type PageSections_CosmosSectionSlimContactCard_Fragment = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards> };

type PageSections_CosmosSectionSpeakerCard_Fragment = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config | null, speakers: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers> };

type PageSections_CosmosSectionTabbedBlogCard_Fragment = { __typename: 'CosmosSectionTabbedBlogCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs> };

type PageSections_CosmosSectionTabbedContentImage_Fragment = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs> };

type PageSections_CosmosSectionTabbedFullWidthAsset_Fragment = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs> };

type PageSections_CosmosSectionUtCard_Fragment = { __typename: 'CosmosSectionUtCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards> };

export type PageSectionsFragment =
  | PageSections_CosmosSectionAccordionFeatureCard_Fragment
  | PageSections_CosmosSectionAccordionTierCards_Fragment
  | PageSections_CosmosSectionAriesCards_Fragment
  | PageSections_CosmosSectionAsset_Fragment
  | PageSections_CosmosSectionAssetCarousel_Fragment
  | PageSections_CosmosSectionAssetGallery_Fragment
  | PageSections_CosmosSectionBlobTable_Fragment
  | PageSections_CosmosSectionBlogCard_Fragment
  | PageSections_CosmosSectionCkRichText_Fragment
  | PageSections_CosmosSectionCommunity_Fragment
  | PageSections_CosmosSectionComplexCtaCard_Fragment
  | PageSections_CosmosSectionContentLargeImage_Fragment
  | PageSections_CosmosSectionContentSliderAsset_Fragment
  | PageSections_CosmosSectionCrux_Fragment
  | PageSections_CosmosSectionDelphinusCardsGrid_Fragment
  | PageSections_CosmosSectionDevelopersList_Fragment
  | PageSections_CosmosSectionDivider_Fragment
  | PageSections_CosmosSectionDownloadCard_Fragment
  | PageSections_CosmosSectionDownloadable_Fragment
  | PageSections_CosmosSectionEmbed_Fragment
  | PageSections_CosmosSectionEventsTable_Fragment
  | PageSections_CosmosSectionFaq_Fragment
  | PageSections_CosmosSectionFaqSearch_Fragment
  | PageSections_CosmosSectionFeatureCard_Fragment
  | PageSections_CosmosSectionGameDevFeatureCard_Fragment
  | PageSections_CosmosSectionGeminiCard_Fragment
  | PageSections_CosmosSectionHydrusColumnList_Fragment
  | PageSections_CosmosSectionLatestNews_Fragment
  | PageSections_CosmosSectionLearn_Fragment
  | PageSections_CosmosSectionLicensesCollapsed_Fragment
  | PageSections_CosmosSectionLogoList_Fragment
  | PageSections_CosmosSectionLogoMultiCard_Fragment
  | PageSections_CosmosSectionNewsCard_Fragment
  | PageSections_CosmosSectionNewsMediaCard_Fragment
  | PageSections_CosmosSectionNewsletterSignup_Fragment
  | PageSections_CosmosSectionNumberCallout_Fragment
  | PageSections_CosmosSectionOrionCards_Fragment
  | PageSections_CosmosSectionPluginListTable_Fragment
  | PageSections_CosmosSectionQuote_Fragment
  | PageSections_CosmosSectionResellersSearch_Fragment
  | PageSections_CosmosSectionRichText_Fragment
  | PageSections_CosmosSectionSimpleCta_Fragment
  | PageSections_CosmosSectionSlimContactCard_Fragment
  | PageSections_CosmosSectionSpeakerCard_Fragment
  | PageSections_CosmosSectionTabbedBlogCard_Fragment
  | PageSections_CosmosSectionTabbedContentImage_Fragment
  | PageSections_CosmosSectionTabbedFullWidthAsset_Fragment
  | PageSections_CosmosSectionUtCard_Fragment
;

export type CosmosSeoFragment = { title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: PageDirectoryMetadataFragment_metaTags_openGraphImage | null };

export type SimpleCtaSectionFragment = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type SlimContactCardFragment = { slimContactCardDesc?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_slimContactCardDesc | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards_buttons> };

export type SlimContactCardsSectionFragment = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards> };

export type SpeakerCardFragment = { id: string, icon?: Types.EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers_asset | null };

export type SpeakerCardsSectionFragment = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config | null, speakers: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers> };

export type TabbedBlogCardsItemFragment = { __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_buttons>, backgroundAsset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_backgroundAsset | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_cards>, featuredCards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs_featuredCards> };

export type TabbedBlogCardsSectionFragment = { __typename: 'CosmosSectionTabbedBlogCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs> };

export type TabbedContentImageItemFragment = { __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_buttons>, asset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_asset | null, blurredImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs_blurredImage | null };

export type TabbedContentImageSectionFragment = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs> };

export type TabbedFullWidthAssetItemFragment = { tabLabel?: string | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_buttons>, heroAsset?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs_heroAsset | null };

export type TabbedFullWidthAssetSectionFragment = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs> };

export type CosmosUserProfileFragment = { __typename: 'CosmosElementUserProfile', variant?: Types.CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: ArticleComponentsFragment_CosmosElementUserProfile_avatar | null, logoImage?: ArticleComponentsFragment_CosmosElementUserProfile_logoImage | null, button?: ArticleComponentsFragment_CosmosElementUserProfile_button | null };

export type UtCardFragment = { href?: string | null, label?: string | null, cardImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards_cardImage | null, logoImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards_logoImage | null };

export type UtCardSectionFragment = { __typename: 'CosmosSectionUtCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards> };

export type BlogTagFragment = { __typename: 'WfRefBlogTag', id: string, tagId: string, label: string };

export type BlogCategoryFragment = { __typename: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: BlogCardFragment_category_tag | null };

export type CreateWfRefBlogTagMutation_createWfRefBlogTag = { id: string };

export type CreateWfRefBlogTagMutation = { createWfRefBlogTag?: CreateWfRefBlogTagMutation_createWfRefBlogTag | null };


export type CreateWfRefBlogTagMutationVariables = Exact<{
  tagId: string;
  label: string;
}>;

export type UpdateLocalizationWfRefBlogTagMutation_updateWfRefBlogTag = { id: string };

export type UpdateLocalizationWfRefBlogTagMutation = { updateWfRefBlogTag?: UpdateLocalizationWfRefBlogTagMutation_updateWfRefBlogTag | null };


export type UpdateLocalizationWfRefBlogTagMutationVariables = Exact<{
  locale: Types.Locale;
  tagId: string;
  label: string;
}>;

export type UpdateWfRefBlogTagIdMutation_updateWfRefBlogTag = { id: string, tagId: string };

export type UpdateWfRefBlogTagIdMutation = { updateWfRefBlogTag?: UpdateWfRefBlogTagIdMutation_updateWfRefBlogTag | null };


export type UpdateWfRefBlogTagIdMutationVariables = Exact<{
  newTagId: string;
  existingTagId: string;
}>;

export type QueryLearnSearchQuery_values = { learnSearch?: any };

export type QueryLearnSearchQuery = { values?: QueryLearnSearchQuery_values | null };


export type QueryLearnSearchQueryVariables = Exact<{
  id: string | number;
  categoryType: string;
  industry: string;
  applicationFamily: string;
}>;

export type CosmosPageAgreementEntitiesQuery_cosmosPageAgreement = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, blocked: Array<Types.CosmosEnumCountryCodes>, hero?: CosmosPageAgreementEntitiesFragment_hero | null, refSections: Array<CosmosPageAgreementEntitiesFragment_refSections>, agreementDetails?: CosmosPageAgreementEntitiesFragment_agreementDetails | null };

export type CosmosPageAgreementEntitiesQuery = { cosmosPageAgreement?: CosmosPageAgreementEntitiesQuery_cosmosPageAgreement | null };


export type CosmosPageAgreementEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageAgreementQuery_cosmosPageAgreement = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, blocked: Array<Types.CosmosEnumCountryCodes>, hero?: CosmosPageAgreementFragment_hero | null, refSections: Array<CosmosPageAgreementFragment_refSections>, agreementDetails?: CosmosPageAgreementFragment_agreementDetails | null };

export type CosmosPageAgreementQuery = { cosmosPageAgreement?: CosmosPageAgreementQuery_cosmosPageAgreement | null };


export type CosmosPageAgreementQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageAgreementDetailsQuery_entities_CosmosElementAgreementDetail = { __typename: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null };

export type CosmosPageAgreementDetailsQuery_entities =
  | CosmosPageAgreementDetailsQuery_entities_CosmosElementAgreementDetail
  | Record<PropertyKey, never>
;

export type CosmosPageAgreementDetailsQuery = { entities?: Array<CosmosPageAgreementDetailsQuery_entities> | null };


export type CosmosPageAgreementDetailsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageAgreementMetadataQuery_cosmosPageAgreement = { __typename: 'CosmosPageAgreement', id: string, createdAt?: any, updatedAt?: any, slug: string, metaTags?: PageAgreementMetadataFragment_metaTags | null };

export type CosmosPageAgreementMetadataQuery = { cosmosPageAgreement?: CosmosPageAgreementMetadataQuery_cosmosPageAgreement | null };


export type CosmosPageAgreementMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageBlogDetailEntitiesQuery_cosmosPageBlogDetail = { __typename: 'CosmosPageBlogDetail', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageBlogDetailEntitiesFragment_owner | null, blogConfig?: PageBlogDetailEntitiesFragment_blogConfig | null, hero?: PageBlogDetailEntitiesFragment_hero | null, articleComponents: Array<PageBlogDetailEntitiesFragment_articleComponents>, refSections: Array<PageBlogDetailEntitiesFragment_refSections> };

export type CosmosPageBlogDetailEntitiesQuery = { cosmosPageBlogDetail?: CosmosPageBlogDetailEntitiesQuery_cosmosPageBlogDetail | null };


export type CosmosPageBlogDetailEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAccordionFeatureCard = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: AccordionFeatureCardsSectionFragment_config | null, items: Array<AccordionFeatureCardsSectionFragment_items> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAccordionTierCards = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: AccordionTierCardsSectionFragment_config | null, items: Array<AccordionTierCardsSectionFragment_items> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAriesCards = { __typename: 'CosmosSectionAriesCards', id: string, config?: AriesCardsSectionFragment_config | null, cards: Array<AriesCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAsset = { __typename: 'CosmosSectionAsset', id: string, size?: Types.CosmosEnumSectionSizes | null, caption?: string | null, config?: AssetSectionFragment_config | null, sectionAsset: AssetSectionFragment_sectionAsset };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionBlobTable = { __typename: 'CosmosSectionBlobTable', id: string, environmentVariable: string, limit?: number | null, variant?: Types.CosmosEnumBlobTableVariants | null, config?: BlobTableSectionFragment_config | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionBlogCard = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: Types.CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: BlogCardsSectionFragment_config | null, cards: Array<BlogCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionCkRichText = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionCommunity = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: Types.CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: CommunitySectionFragment_config | null, forumButton?: CommunitySectionFragment_forumButton | null, resources?: CommunitySectionFragment_resources | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionComplexCtaCard = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: Types.CosmosEnumComplexCtaVariant | null, config?: ComplexCtaCardsSectionFragment_config | null, cards: Array<ComplexCtaCardsSectionFragment_cards>, bottomDescription?: ComplexCtaCardsSectionFragment_bottomDescription | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionContentSliderAsset = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentSliderAssetFragment_config | null, badges: Array<ContentSliderAssetFragment_badges>, title?: ContentSliderAssetFragment_title | null, buttons: Array<ContentSliderAssetFragment_buttons>, assets: Array<ContentSliderAssetFragment_assets> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionCrux = { __typename: 'CosmosSectionCrux', id: string, config?: CruxSectionFragment_config | null, cruxLinks: Array<CruxSectionFragment_cruxLinks> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDelphinusCardsGrid = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: DelphinusCardsGridSectionFragment_config | null, grid: Array<DelphinusCardsGridSectionFragment_grid> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDevelopersList = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: DevelopersListSectionFragment_config | null, developersTsv?: DevelopersListSectionFragment_developersTsv | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDownloadCard = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDownloadable = { __typename: 'CosmosSectionDownloadable', id: string, config?: DownloadableSectionFragment_config | null, instructions?: DownloadableSectionFragment_instructions | null, executables: Array<DownloadableSectionFragment_executables>, footer?: DownloadableSectionFragment_footer | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionEmbed = { __typename: 'CosmosSectionEmbed', id: string, size?: Types.CosmosEnumSectionSizes | null, config?: EmbedSectionFragment_config | null, embed?: EmbedSectionFragment_embed | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionEventsTable = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: EventsTableSectionFragment_config | null, blurredImage?: EventsTableSectionFragment_blurredImage | null, events: Array<EventsTableSectionFragment_events> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionFaq = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSectionFragment_config | null, title?: FaqSectionFragment_title | null, items: Array<FaqSectionFragment_items>, refFaqItems: Array<FaqSectionFragment_refFaqItems>, modButtons: Array<FaqSectionFragment_modButtons>, faqButtons: Array<FaqSectionFragment_faqButtons> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionFaqSearch = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSearchSectionFragment_config | null, title?: FaqSearchSectionFragment_title | null, faqTabs: Array<FaqSearchSectionFragment_faqTabs>, modButtons: Array<FaqSearchSectionFragment_modButtons> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionFeatureCard = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: FeatureCardsSectionFragment_config | null, tags: Array<FeatureCardsSectionFragment_tags>, cards: Array<FeatureCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionGameDevFeatureCard = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: FeaturePanelsSectionFragment_config | null, cards: Array<FeaturePanelsSectionFragment_cards>, buttons: Array<FeaturePanelsSectionFragment_buttons> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionGeminiCard = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: Types.CosmosEnumGeminiVariants | null, logoImage?: GeminiCardsSectionFragment_logoImage | null, config?: GeminiCardsSectionFragment_config | null, title?: GeminiCardsSectionFragment_title | null, cards: Array<GeminiCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionHydrusColumnList = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: HydrusColumnListSectionFragment_config | null, columns: Array<HydrusColumnListSectionFragment_columns> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLatestNews = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: Types.CosmosEnumLatestNewsVariants | null, config?: LatestNewsSectionFragment_config | null, wfRefBlogTags: Array<LatestNewsSectionFragment_wfRefBlogTags>, cosmosPageBlogDetails: Array<LatestNewsSectionFragment_cosmosPageBlogDetails> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLearn = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: Types.CosmosEnumApplicationFamily | null, config?: LearnSectionFragment_config | null, tabs: Array<LearnSectionFragment_tabs>, categories: Array<LearnSectionFragment_categories> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLicensesCollapsed = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: LicensesCollapsedSectionFragment_config | null, topCard?: LicensesCollapsedSectionFragment_topCard | null, collapsedCards: Array<LicensesCollapsedSectionFragment_collapsedCards>, collapsedCta?: LicensesCollapsedSectionFragment_collapsedCta | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNewsCard = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: Types.EnumSmallNewsCardMax | null, config?: NewsCardsSectionFragment_config | null, cards: Array<NewsCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNewsletterSignup = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: NewsletterSignupFragment_industriesRef | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNumberCallout = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: Types.CosmosEnumNumberCalloutVariants | null, config?: NumberCalloutSectionFragment_config | null, title?: NumberCalloutSectionFragment_title | null, callouts: Array<NumberCalloutSectionFragment_callouts>, buttons: Array<NumberCalloutSectionFragment_buttons>, asset?: NumberCalloutSectionFragment_asset | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionOrionCards = { __typename: 'CosmosSectionOrionCards', id: string, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, config?: OrionCardsSectionFragment_config | null, title?: OrionCardsSectionFragment_title | null, modButtons: Array<OrionCardsSectionFragment_modButtons>, cards: Array<OrionCardsSectionFragment_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionPluginListTable = { __typename: 'CosmosSectionPluginListTable', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config | null, tableItems: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionQuote = { __typename: 'CosmosSectionQuote', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config | null, quotes: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionResellersSearch = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards>, cards2: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2>, cards3: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3>, cards4: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4>, blurredBackgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionRichText = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config | null, content?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionSlimContactCard = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionSpeakerCard = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config | null, speakers: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionTabbedBlogCard = { __typename: 'CosmosSectionTabbedBlogCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionTabbedContentImage = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionTabbedFullWidthAsset = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs> };

export type CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionUtCard = { __typename: 'CosmosSectionUtCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards> };

export type CosmosPageBlogDetailSectionsQuery_entities =
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAccordionFeatureCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAccordionTierCards
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAriesCards
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAsset
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAssetCarousel
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionAssetGallery
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionBlobTable
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionBlogCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionCkRichText
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionCommunity
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionComplexCtaCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionContentLargeImage
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionContentSliderAsset
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionCrux
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDelphinusCardsGrid
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDevelopersList
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDivider
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDownloadCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionDownloadable
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionEmbed
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionEventsTable
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionFaq
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionFaqSearch
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionFeatureCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionGameDevFeatureCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionGeminiCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionHydrusColumnList
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLatestNews
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLearn
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLicensesCollapsed
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLogoList
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionLogoMultiCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNewsCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNewsMediaCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNewsletterSignup
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionNumberCallout
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionOrionCards
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionPluginListTable
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionQuote
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionResellersSearch
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionRichText
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionSimpleCta
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionSlimContactCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionSpeakerCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionTabbedBlogCard
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionTabbedContentImage
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionTabbedFullWidthAsset
  | CosmosPageBlogDetailSectionsQuery_entities_CosmosSectionUtCard
  | Record<PropertyKey, never>
;

export type CosmosPageBlogDetailSectionsQuery = { entities?: Array<CosmosPageBlogDetailSectionsQuery_entities> | null };


export type CosmosPageBlogDetailSectionsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageBlogDetailHeroQuery_entities_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type CosmosPageBlogDetailHeroQuery_entities_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type CosmosPageBlogDetailHeroQuery_entities_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type CosmosPageBlogDetailHeroQuery_entities_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type CosmosPageBlogDetailHeroQuery_entities =
  | CosmosPageBlogDetailHeroQuery_entities_CosmosHeroAlpha
  | CosmosPageBlogDetailHeroQuery_entities_CosmosHeroArticleImage
  | CosmosPageBlogDetailHeroQuery_entities_CosmosHeroBravo
  | CosmosPageBlogDetailHeroQuery_entities_CosmosHeroGlow
  | Record<PropertyKey, never>
;

export type CosmosPageBlogDetailHeroQuery = { entities?: Array<CosmosPageBlogDetailHeroQuery_entities> | null };


export type CosmosPageBlogDetailHeroQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageBlogDetailMetadataQuery_cosmosPageBlogDetail = { __typename: 'CosmosPageBlogDetail', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageBlogDetailMetadataFragment_owner | null, metaTags?: PageBlogDetailMetadataFragment_metaTags | null };

export type CosmosPageBlogDetailMetadataQuery = { cosmosPageBlogDetail?: CosmosPageBlogDetailMetadataQuery_cosmosPageBlogDetail | null };


export type CosmosPageBlogDetailMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageLegalContentMetadataQuery_cosmosPageLegalContent = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageLegalContentMetadataFragment_owner | null, metaTags?: PageLegalContentMetadataFragment_metaTags | null };

export type CosmosPageLegalContentMetadataQuery = { cosmosPageLegalContent?: CosmosPageLegalContentMetadataQuery_cosmosPageLegalContent | null };


export type CosmosPageLegalContentMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageLegalContentQuery_cosmosPageLegalContent = { id: string, createdAt?: any, updatedAt?: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, owner?: PageLegalContentFragment_owner | null, hero?: PageLegalContentFragment_hero | null, sections: Array<PageLegalContentFragment_sections> };

export type CosmosPageLegalContentQuery = { cosmosPageLegalContent?: CosmosPageLegalContentQuery_cosmosPageLegalContent | null };


export type CosmosPageLegalContentQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageLegalContentSlugSingleQuery_cosmosPageLegalContent = { id: string, createdAt?: any, updatedAt?: any, slug: string, locale: Types.Locale, owner?: PageLegalContentSlugDataFragment_owner | null };

export type CosmosPageLegalContentSlugSingleQuery = { cosmosPageLegalContent?: CosmosPageLegalContentSlugSingleQuery_cosmosPageLegalContent | null };


export type CosmosPageLegalContentSlugSingleQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageDirectoryMetadataQuery_cosmosPageDirectory = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageDirectoryMetadataFragment_owner | null, metaTags?: PageDirectoryMetadataFragment_metaTags | null };

export type CosmosPageDirectoryMetadataQuery = { cosmosPageDirectory?: CosmosPageDirectoryMetadataQuery_cosmosPageDirectory | null };


export type CosmosPageDirectoryMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageDirectoryEntitiesQuery_cosmosPageDirectory = { id: string, createdAt?: any, updatedAt?: any, slug: string, variant: Types.CosmosEnumDirectoryVariant, directoryEyebrow?: string | null, directoryTitle?: string | null, directoryDesc?: string | null, searchPlaceholder?: string | null, industryFilterLabel?: string | null, serviceFilterLabel?: string | null, serviceFilterPlaceholder?: string | null, noResultsLabel?: string | null, owner?: PageDirectoryEntitiesFragment_owner | null, hero?: PageDirectoryEntitiesFragment_hero | null, topRefSections: Array<PageDirectoryEntitiesFragment_topRefSections>, bottomRefSections: Array<PageDirectoryEntitiesFragment_bottomRefSections>, servicePartnerDetail?: PageDirectoryEntitiesFragment_servicePartnerDetail | null };

export type CosmosPageDirectoryEntitiesQuery = { cosmosPageDirectory?: CosmosPageDirectoryEntitiesQuery_cosmosPageDirectory | null };


export type CosmosPageDirectoryEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageEulaKeyQuery_cosmosPageEulaKey = { id: string, createdAt?: any, updatedAt?: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, disclaimer?: string | null, title?: string | null, subtitle?: string | null, eulaKey: string, owner?: PageEulaKeyFragment_owner | null };

export type CosmosPageEulaKeyQuery = { cosmosPageEulaKey?: CosmosPageEulaKeyQuery_cosmosPageEulaKey | null };


export type CosmosPageEulaKeyQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageEulaKeyMetadataQuery_cosmosPageEulaKey = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageEulaKeyMetadataFragment_owner | null, metaTags?: PageEulaKeyMetadataFragment_metaTags | null };

export type CosmosPageEulaKeyMetadataQuery = { cosmosPageEulaKey?: CosmosPageEulaKeyMetadataQuery_cosmosPageEulaKey | null };


export type CosmosPageEulaKeyMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageFeedEntitiesQuery_cosmosPageFeed = { id: string, createdAt?: any, updatedAt?: any, slug: string, searchPlaceholder?: string | null, clearFiltersButtonLabel?: string | null, featuredLabel?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, noResultsDescription?: string | null, owner?: PageFeedFragment_owner | null, tags: Array<PageFeedFragment_tags>, categories: Array<PageFeedFragment_categories> };

export type CosmosPageFeedEntitiesQuery_wfRefBlogCategories = { __typename: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: BlogCardFragment_category_tag | null };

export type CosmosPageFeedEntitiesQuery = { cosmosPageFeed?: CosmosPageFeedEntitiesQuery_cosmosPageFeed | null, wfRefBlogCategories: Array<CosmosPageFeedEntitiesQuery_wfRefBlogCategories> };


export type CosmosPageFeedEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageFeedMetadataQuery_cosmosPageFeed = { id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageFeedMetadataFragment_owner | null, metaTags?: PageFeedMetadataFragment_metaTags | null };

export type CosmosPageFeedMetadataQuery = { cosmosPageFeed?: CosmosPageFeedMetadataQuery_cosmosPageFeed | null };


export type CosmosPageFeedMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageHeroAndSectionMetadataQuery_cosmosPageHeroAndSection = { __typename: 'CosmosPageHeroAndSection', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageHeroAndSectionsMetadataFragment_owner | null, metaTags?: PageHeroAndSectionsMetadataFragment_metaTags | null };

export type CosmosPageHeroAndSectionMetadataQuery = { cosmosPageHeroAndSection?: CosmosPageHeroAndSectionMetadataQuery_cosmosPageHeroAndSection | null };


export type CosmosPageHeroAndSectionMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageHeroAndSectionEntitiesQuery_cosmosPageHeroAndSection = { __typename: 'CosmosPageHeroAndSection', id: string, createdAt?: any, updatedAt?: any, slug: string, owner?: PageHeroAndSectionsEntitiesFragment_owner | null, hero?: PageHeroAndSectionsEntitiesFragment_hero | null, refSections: Array<PageHeroAndSectionsEntitiesFragment_refSections> };

export type CosmosPageHeroAndSectionEntitiesQuery = { cosmosPageHeroAndSection?: CosmosPageHeroAndSectionEntitiesQuery_cosmosPageHeroAndSection | null };


export type CosmosPageHeroAndSectionEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageHeroQuery_entities_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type CosmosPageHeroQuery_entities_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type CosmosPageHeroQuery_entities_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type CosmosPageHeroQuery_entities_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type CosmosPageHeroQuery_entities =
  | CosmosPageHeroQuery_entities_CosmosHeroAlpha
  | CosmosPageHeroQuery_entities_CosmosHeroArticleImage
  | CosmosPageHeroQuery_entities_CosmosHeroBravo
  | CosmosPageHeroQuery_entities_CosmosHeroGlow
  | Record<PropertyKey, never>
;

export type CosmosPageHeroQuery = { entities?: Array<CosmosPageHeroQuery_entities> | null };


export type CosmosPageHeroQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageHeroAlphaQuery_entities_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type CosmosPageHeroAlphaQuery_entities =
  | CosmosPageHeroAlphaQuery_entities_CosmosHeroAlpha
  | Record<PropertyKey, never>
;

export type CosmosPageHeroAlphaQuery = { entities?: Array<CosmosPageHeroAlphaQuery_entities> | null };


export type CosmosPageHeroAlphaQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageHeroGlowQuery_entities_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type CosmosPageHeroGlowQuery_entities =
  | CosmosPageHeroGlowQuery_entities_CosmosHeroGlow
  | Record<PropertyKey, never>
;

export type CosmosPageHeroGlowQuery = { entities?: Array<CosmosPageHeroGlowQuery_entities> | null };


export type CosmosPageHeroGlowQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageHeroArticleImageQuery_entities_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type CosmosPageHeroArticleImageQuery_entities =
  | CosmosPageHeroArticleImageQuery_entities_CosmosHeroArticleImage
  | Record<PropertyKey, never>
;

export type CosmosPageHeroArticleImageQuery = { entities?: Array<CosmosPageHeroArticleImageQuery_entities> | null };


export type CosmosPageHeroArticleImageQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageHeroBravoQuery_entities_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type CosmosPageHeroBravoQuery_entities =
  | CosmosPageHeroBravoQuery_entities_CosmosHeroBravo
  | Record<PropertyKey, never>
;

export type CosmosPageHeroBravoQuery = { entities?: Array<CosmosPageHeroBravoQuery_entities> | null };


export type CosmosPageHeroBravoQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageLicenseEntitiesQuery_cosmosPageLicense = { id: string, createdAt?: any, updatedAt?: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, refSections: Array<CosmosPageLicenseEntitiesFragment_refSections>, hero?: CosmosPageLicenseCoreFragment_hero | null, contentLargeImages: Array<CosmosPageLicenseCoreFragment_contentLargeImages>, freeCard?: CosmosPageLicenseCoreFragment_freeCard | null, mainCards: Array<CosmosPageLicenseCoreFragment_mainCards>, contactCard?: CosmosPageLicenseCoreFragment_contactCard | null, contactCard2?: CosmosPageLicenseCoreFragment_contactCard2 | null };

export type CosmosPageLicenseEntitiesQuery = { cosmosPageLicense?: CosmosPageLicenseEntitiesQuery_cosmosPageLicense | null };


export type CosmosPageLicenseEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageLicenseMetadataQuery_cosmosPageLicense = { createdAt?: any, updatedAt?: any, slug?: string | null, id: string, metaTags?: CosmosPageLicenseMetadataFragment_metaTags | null };

export type CosmosPageLicenseMetadataQuery = { cosmosPageLicense?: CosmosPageLicenseMetadataQuery_cosmosPageLicense | null };


export type CosmosPageLicenseMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPagePluginDetailEntitiesQuery_cosmosPagePluginDetail = { id: string, createdAt?: any, updatedAt?: any, slug: string, archivedVersionsTitle?: string | null, hero?: PagePluginDetailEntitiesFragment_hero | null, downloads: Array<PagePluginDetailEntitiesFragment_downloads>, latestCardSections: Array<PagePluginDetailEntitiesFragment_latestCardSections>, articleComponents: Array<PagePluginDetailEntitiesFragment_articleComponents>, refSections: Array<PagePluginDetailEntitiesFragment_refSections> };

export type CosmosPagePluginDetailEntitiesQuery = { cosmosPagePluginDetail?: CosmosPagePluginDetailEntitiesQuery_cosmosPagePluginDetail | null };


export type CosmosPagePluginDetailEntitiesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAccordionFeatureCard = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: AccordionFeatureCardsSectionFragment_config | null, items: Array<AccordionFeatureCardsSectionFragment_items> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAccordionTierCards = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: AccordionTierCardsSectionFragment_config | null, items: Array<AccordionTierCardsSectionFragment_items> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAriesCards = { __typename: 'CosmosSectionAriesCards', id: string, config?: AriesCardsSectionFragment_config | null, cards: Array<AriesCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAsset = { __typename: 'CosmosSectionAsset', id: string, size?: Types.CosmosEnumSectionSizes | null, caption?: string | null, config?: AssetSectionFragment_config | null, sectionAsset: AssetSectionFragment_sectionAsset };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionBlobTable = { __typename: 'CosmosSectionBlobTable', id: string, environmentVariable: string, limit?: number | null, variant?: Types.CosmosEnumBlobTableVariants | null, config?: BlobTableSectionFragment_config | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionBlogCard = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: Types.CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: BlogCardsSectionFragment_config | null, cards: Array<BlogCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionCkRichText = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionCommunity = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: Types.CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: CommunitySectionFragment_config | null, forumButton?: CommunitySectionFragment_forumButton | null, resources?: CommunitySectionFragment_resources | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionComplexCtaCard = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: Types.CosmosEnumComplexCtaVariant | null, config?: ComplexCtaCardsSectionFragment_config | null, cards: Array<ComplexCtaCardsSectionFragment_cards>, bottomDescription?: ComplexCtaCardsSectionFragment_bottomDescription | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionContentSliderAsset = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentSliderAssetFragment_config | null, badges: Array<ContentSliderAssetFragment_badges>, title?: ContentSliderAssetFragment_title | null, buttons: Array<ContentSliderAssetFragment_buttons>, assets: Array<ContentSliderAssetFragment_assets> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionCrux = { __typename: 'CosmosSectionCrux', id: string, config?: CruxSectionFragment_config | null, cruxLinks: Array<CruxSectionFragment_cruxLinks> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDelphinusCardsGrid = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: DelphinusCardsGridSectionFragment_config | null, grid: Array<DelphinusCardsGridSectionFragment_grid> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDevelopersList = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: DevelopersListSectionFragment_config | null, developersTsv?: DevelopersListSectionFragment_developersTsv | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDownloadCard = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDownloadable = { __typename: 'CosmosSectionDownloadable', id: string, config?: DownloadableSectionFragment_config | null, instructions?: DownloadableSectionFragment_instructions | null, executables: Array<DownloadableSectionFragment_executables>, footer?: DownloadableSectionFragment_footer | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionEmbed = { __typename: 'CosmosSectionEmbed', id: string, size?: Types.CosmosEnumSectionSizes | null, config?: EmbedSectionFragment_config | null, embed?: EmbedSectionFragment_embed | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionEventsTable = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: EventsTableSectionFragment_config | null, blurredImage?: EventsTableSectionFragment_blurredImage | null, events: Array<EventsTableSectionFragment_events> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionFaq = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSectionFragment_config | null, title?: FaqSectionFragment_title | null, items: Array<FaqSectionFragment_items>, refFaqItems: Array<FaqSectionFragment_refFaqItems>, modButtons: Array<FaqSectionFragment_modButtons>, faqButtons: Array<FaqSectionFragment_faqButtons> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionFaqSearch = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSearchSectionFragment_config | null, title?: FaqSearchSectionFragment_title | null, faqTabs: Array<FaqSearchSectionFragment_faqTabs>, modButtons: Array<FaqSearchSectionFragment_modButtons> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionFeatureCard = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: FeatureCardsSectionFragment_config | null, tags: Array<FeatureCardsSectionFragment_tags>, cards: Array<FeatureCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionGameDevFeatureCard = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: FeaturePanelsSectionFragment_config | null, cards: Array<FeaturePanelsSectionFragment_cards>, buttons: Array<FeaturePanelsSectionFragment_buttons> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionGeminiCard = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: Types.CosmosEnumGeminiVariants | null, logoImage?: GeminiCardsSectionFragment_logoImage | null, config?: GeminiCardsSectionFragment_config | null, title?: GeminiCardsSectionFragment_title | null, cards: Array<GeminiCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionHydrusColumnList = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: HydrusColumnListSectionFragment_config | null, columns: Array<HydrusColumnListSectionFragment_columns> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLatestNews = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: Types.CosmosEnumLatestNewsVariants | null, config?: LatestNewsSectionFragment_config | null, wfRefBlogTags: Array<LatestNewsSectionFragment_wfRefBlogTags>, cosmosPageBlogDetails: Array<LatestNewsSectionFragment_cosmosPageBlogDetails> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLearn = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: Types.CosmosEnumApplicationFamily | null, config?: LearnSectionFragment_config | null, tabs: Array<LearnSectionFragment_tabs>, categories: Array<LearnSectionFragment_categories> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLicensesCollapsed = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: LicensesCollapsedSectionFragment_config | null, topCard?: LicensesCollapsedSectionFragment_topCard | null, collapsedCards: Array<LicensesCollapsedSectionFragment_collapsedCards>, collapsedCta?: LicensesCollapsedSectionFragment_collapsedCta | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNewsCard = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: Types.EnumSmallNewsCardMax | null, config?: NewsCardsSectionFragment_config | null, cards: Array<NewsCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNewsletterSignup = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: NewsletterSignupFragment_industriesRef | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNumberCallout = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: Types.CosmosEnumNumberCalloutVariants | null, config?: NumberCalloutSectionFragment_config | null, title?: NumberCalloutSectionFragment_title | null, callouts: Array<NumberCalloutSectionFragment_callouts>, buttons: Array<NumberCalloutSectionFragment_buttons>, asset?: NumberCalloutSectionFragment_asset | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionOrionCards = { __typename: 'CosmosSectionOrionCards', id: string, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, config?: OrionCardsSectionFragment_config | null, title?: OrionCardsSectionFragment_title | null, modButtons: Array<OrionCardsSectionFragment_modButtons>, cards: Array<OrionCardsSectionFragment_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionPluginListTable = { __typename: 'CosmosSectionPluginListTable', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config | null, tableItems: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionQuote = { __typename: 'CosmosSectionQuote', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config | null, quotes: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionResellersSearch = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards>, cards2: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2>, cards3: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3>, cards4: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4>, blurredBackgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionRichText = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config | null, content?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionSlimContactCard = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionSpeakerCard = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config | null, speakers: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionTabbedBlogCard = { __typename: 'CosmosSectionTabbedBlogCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionTabbedContentImage = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionTabbedFullWidthAsset = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs> };

export type CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionUtCard = { __typename: 'CosmosSectionUtCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards> };

export type CosmosPagePluginDetailSectionsQuery_entities =
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAccordionFeatureCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAccordionTierCards
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAriesCards
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAsset
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAssetCarousel
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionAssetGallery
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionBlobTable
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionBlogCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionCkRichText
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionCommunity
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionComplexCtaCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionContentLargeImage
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionContentSliderAsset
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionCrux
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDelphinusCardsGrid
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDevelopersList
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDivider
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDownloadCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionDownloadable
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionEmbed
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionEventsTable
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionFaq
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionFaqSearch
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionFeatureCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionGameDevFeatureCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionGeminiCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionHydrusColumnList
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLatestNews
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLearn
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLicensesCollapsed
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLogoList
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionLogoMultiCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNewsCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNewsMediaCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNewsletterSignup
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionNumberCallout
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionOrionCards
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionPluginListTable
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionQuote
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionResellersSearch
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionRichText
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionSimpleCta
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionSlimContactCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionSpeakerCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionTabbedBlogCard
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionTabbedContentImage
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionTabbedFullWidthAsset
  | CosmosPagePluginDetailSectionsQuery_entities_CosmosSectionUtCard
  | Record<PropertyKey, never>
;

export type CosmosPagePluginDetailSectionsQuery = { entities?: Array<CosmosPagePluginDetailSectionsQuery_entities> | null };


export type CosmosPagePluginDetailSectionsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPagePluginDetailHeroQuery_entities_CosmosHeroAlpha = { __typename: 'CosmosHeroAlpha', id: string, variant?: Types.CosmosEnumHeroAlphaVariants | null, logoVariant?: Types.CosmosEnumHeroAlphaLogoVariants | null, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: HeroAlphaFragment_blurredImage | null, heroAsset?: HeroAlphaFragment_heroAsset | null, logoImage?: HeroAlphaMainStackFragment_logoImage | null, title?: HeroAlphaMainStackFragment_title | null, buttons: Array<HeroAlphaMainStackFragment_buttons>, modButtons: Array<HeroAlphaMainStackFragment_modButtons> };

export type CosmosPagePluginDetailHeroQuery_entities_CosmosHeroArticleImage = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: Types.CosmosEnumEdsGradients | null, caption?: string | null, title?: HeroArticleImageFragment_title | null, description?: HeroArticleImageFragment_description | null, buttons: Array<HeroArticleImageFragment_buttons>, modButtons: Array<HeroArticleImageFragment_modButtons>, asset?: HeroArticleImageFragment_asset | null, backgroundAsset?: HeroArticleImageFragment_backgroundAsset | null };

export type CosmosPagePluginDetailHeroQuery_entities_CosmosHeroBravo = { __typename: 'CosmosHeroBravo', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, title?: HeroBravoFragment_title | null, buttons: Array<HeroBravoFragment_buttons>, modButtons: Array<HeroBravoFragment_modButtons>, backgroundAsset?: HeroBravoFragment_backgroundAsset | null };

export type CosmosPagePluginDetailHeroQuery_entities_CosmosHeroGlow = { __typename: 'CosmosHeroGlow', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, disablePaddingBlockEnd?: boolean | null, blurredImage?: HeroGlowFragment_blurredImage | null, logoImage?: HeroGlowFragment_logoImage | null, title?: HeroGlowFragment_title | null, modButtons: Array<HeroGlowFragment_modButtons> };

export type CosmosPagePluginDetailHeroQuery_entities =
  | CosmosPagePluginDetailHeroQuery_entities_CosmosHeroAlpha
  | CosmosPagePluginDetailHeroQuery_entities_CosmosHeroArticleImage
  | CosmosPagePluginDetailHeroQuery_entities_CosmosHeroBravo
  | CosmosPagePluginDetailHeroQuery_entities_CosmosHeroGlow
  | Record<PropertyKey, never>
;

export type CosmosPagePluginDetailHeroQuery = { entities?: Array<CosmosPagePluginDetailHeroQuery_entities> | null };


export type CosmosPagePluginDetailHeroQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPagePluginDetailMetadataQuery_cosmosPagePluginDetail = { id: string, createdAt?: any, updatedAt?: any, slug: string, metaTags?: PagePluginDetailMetadataFragment_metaTags | null };

export type CosmosPagePluginDetailMetadataQuery = { cosmosPagePluginDetail?: CosmosPagePluginDetailMetadataQuery_cosmosPagePluginDetail | null };


export type CosmosPagePluginDetailMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageRedirectQuery_cosmosPageRedirect = { __typename: 'CosmosPageRedirect', id: string, slug: string, destination: string, permanent?: boolean | null, owner?: CosmosRedirectPageFragment_owner | null };

export type CosmosPageRedirectQuery = { cosmosPageRedirect?: CosmosPageRedirectQuery_cosmosPageRedirect | null };


export type CosmosPageRedirectQueryVariables = Exact<{
  slug: string;
}>;

export type CosmosPageRedirectsQuery_cosmosPageRedirects = { __typename: 'CosmosPageRedirect', id: string, slug: string, destination: string, permanent?: boolean | null, owner?: CosmosRedirectPageFragment_owner | null };

export type CosmosPageRedirectsQuery = { cosmosPageRedirects: Array<CosmosPageRedirectsQuery_cosmosPageRedirects> };


export type CosmosPageRedirectsQueryVariables = Exact<{ [key: string]: never; }>;

export type CosmosPageResearchMetadataQuery_cosmosPageResearch = { id: string, createdAt?: any, updatedAt?: any, slug: string, metaTags?: PageResearchMetadataFragment_metaTags | null };

export type CosmosPageResearchMetadataQuery = { cosmosPageResearch?: CosmosPageResearchMetadataQuery_cosmosPageResearch | null };


export type CosmosPageResearchMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageResearchQuery_cosmosPageResearch = { createdAt?: any, updatedAt?: any, slug: string, hero?: PageResearchFragment_hero | null, researchCards: Array<PageResearchFragment_researchCards>, researchCardsSectionConfig?: PageResearchFragment_researchCardsSectionConfig | null };

export type CosmosPageResearchQuery = { cosmosPageResearch?: CosmosPageResearchQuery_cosmosPageResearch | null };


export type CosmosPageResearchQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageSearchFiltersQuery_cosmosPageSearch = { __typename: 'CosmosPageSearch', id: string, slug: string, defaultSearchFilter?: string | null, searchFilters: Array<PageSearchFiltersFragment_searchFilters> };

export type CosmosPageSearchFiltersQuery = { cosmosPageSearch?: CosmosPageSearchFiltersQuery_cosmosPageSearch | null };


export type CosmosPageSearchFiltersQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageSearchMetadataQuery_cosmosPageSearch = { __typename: 'CosmosPageSearch', id: string, createdAt?: any, updatedAt?: any, slug: string, defaultSearchFilter?: string | null, metaTags?: PageSearchMetadataFragment_metaTags | null, searchFilters: Array<PageSearchMetadataFragment_searchFilters> };

export type CosmosPageSearchMetadataQuery = { cosmosPageSearch?: CosmosPageSearchMetadataQuery_cosmosPageSearch | null };


export type CosmosPageSearchMetadataQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageSearchQuery_cosmosPageSearch = { __typename: 'CosmosPageSearch', id: string, createdAt?: any, updatedAt?: any, slug: string, title?: string | null, desc?: string | null, searchPlaceholder?: string | null, clearSearchLabel?: string | null, defaultSearchFilter?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, suggestedLinksLabel?: string | null, searchFilters: Array<PageSearchFragment_searchFilters>, suggestedLinks: Array<PageSearchFragment_suggestedLinks> };

export type CosmosPageSearchQuery = { cosmosPageSearch?: CosmosPageSearchQuery_cosmosPageSearch | null };


export type CosmosPageSearchQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type CosmosPageRefSectionAssetQuery_entities_CosmosReferenceSection_section_CosmosSectionAsset = { __typename: 'CosmosSectionAsset', id: string, size?: Types.CosmosEnumSectionSizes | null, caption?: string | null, config?: AssetSectionFragment_config | null, sectionAsset: AssetSectionFragment_sectionAsset };

export type CosmosPageRefSectionAssetQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionAssetQuery_entities_CosmosReferenceSection_section_CosmosSectionAsset
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAssetQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionAssetQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionAssetQuery_entities =
  | CosmosPageRefSectionAssetQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAssetQuery = { entities?: Array<CosmosPageRefSectionAssetQuery_entities> | null };


export type CosmosPageRefSectionAssetQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionAssetCarouselQuery_entities_CosmosReferenceSection_section_CosmosSectionAssetCarousel = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: AssetCarouselSectionFragment_config | null, assets: Array<AssetCarouselSectionFragment_assets> };

export type CosmosPageRefSectionAssetCarouselQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionAssetCarouselQuery_entities_CosmosReferenceSection_section_CosmosSectionAssetCarousel
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAssetCarouselQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionAssetCarouselQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionAssetCarouselQuery_entities =
  | CosmosPageRefSectionAssetCarouselQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAssetCarouselQuery = { entities?: Array<CosmosPageRefSectionAssetCarouselQuery_entities> | null };


export type CosmosPageRefSectionAssetCarouselQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionAssetGalleryQuery_entities_CosmosReferenceSection_section_CosmosSectionAssetGallery = { __typename: 'CosmosSectionAssetGallery', id: string, config?: AssetGallerySectionFragment_config | null, assets: Array<AssetGallerySectionFragment_assets> };

export type CosmosPageRefSectionAssetGalleryQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionAssetGalleryQuery_entities_CosmosReferenceSection_section_CosmosSectionAssetGallery
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAssetGalleryQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionAssetGalleryQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionAssetGalleryQuery_entities =
  | CosmosPageRefSectionAssetGalleryQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAssetGalleryQuery = { entities?: Array<CosmosPageRefSectionAssetGalleryQuery_entities> | null };


export type CosmosPageRefSectionAssetGalleryQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionBlogCardQuery_entities_CosmosReferenceSection_section_CosmosSectionBlogCard = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: Types.CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: BlogCardsSectionFragment_config | null, cards: Array<BlogCardsSectionFragment_cards> };

export type CosmosPageRefSectionBlogCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionBlogCardQuery_entities_CosmosReferenceSection_section_CosmosSectionBlogCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionBlogCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionBlogCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionBlogCardQuery_entities =
  | CosmosPageRefSectionBlogCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionBlogCardQuery = { entities?: Array<CosmosPageRefSectionBlogCardQuery_entities> | null };


export type CosmosPageRefSectionBlogCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionBlobTableQuery_entities_CosmosReferenceSection_section_CosmosSectionBlobTable = { __typename: 'CosmosSectionBlobTable', id: string, environmentVariable: string, limit?: number | null, variant?: Types.CosmosEnumBlobTableVariants | null, config?: BlobTableSectionFragment_config | null };

export type CosmosPageRefSectionBlobTableQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionBlobTableQuery_entities_CosmosReferenceSection_section_CosmosSectionBlobTable
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionBlobTableQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionBlobTableQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionBlobTableQuery_entities =
  | CosmosPageRefSectionBlobTableQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionBlobTableQuery = { entities?: Array<CosmosPageRefSectionBlobTableQuery_entities> | null };


export type CosmosPageRefSectionBlobTableQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionCommunityQuery_entities_CosmosReferenceSection_section_CosmosSectionCommunity = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: Types.CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: CommunitySectionFragment_config | null, forumButton?: CommunitySectionFragment_forumButton | null, resources?: CommunitySectionFragment_resources | null };

export type CosmosPageRefSectionCommunityQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionCommunityQuery_entities_CosmosReferenceSection_section_CosmosSectionCommunity
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionCommunityQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionCommunityQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionCommunityQuery_entities =
  | CosmosPageRefSectionCommunityQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionCommunityQuery = { entities?: Array<CosmosPageRefSectionCommunityQuery_entities> | null };


export type CosmosPageRefSectionCommunityQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionComplexCtaCardQuery_entities_CosmosReferenceSection_section_CosmosSectionComplexCtaCard = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: Types.CosmosEnumComplexCtaVariant | null, config?: ComplexCtaCardsSectionFragment_config | null, cards: Array<ComplexCtaCardsSectionFragment_cards>, bottomDescription?: ComplexCtaCardsSectionFragment_bottomDescription | null };

export type CosmosPageRefSectionComplexCtaCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionComplexCtaCardQuery_entities_CosmosReferenceSection_section_CosmosSectionComplexCtaCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionComplexCtaCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionComplexCtaCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionComplexCtaCardQuery_entities =
  | CosmosPageRefSectionComplexCtaCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionComplexCtaCardQuery = { entities?: Array<CosmosPageRefSectionComplexCtaCardQuery_entities> | null };


export type CosmosPageRefSectionComplexCtaCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionContentLargeImageQuery_entities_CosmosReferenceSection_section_CosmosSectionContentLargeImage = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentLargeImageFragment_config | null, badges: Array<ContentLargeImageFragment_badges>, title?: ContentLargeImageFragment_title | null, buttons: Array<ContentLargeImageFragment_buttons>, modButtons: Array<ContentLargeImageFragment_modButtons>, asset?: ContentLargeImageFragment_asset | null, blurredImage?: ContentLargeImageFragment_blurredImage | null };

export type CosmosPageRefSectionContentLargeImageQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionContentLargeImageQuery_entities_CosmosReferenceSection_section_CosmosSectionContentLargeImage
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionContentLargeImageQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionContentLargeImageQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionContentLargeImageQuery_entities =
  | CosmosPageRefSectionContentLargeImageQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionContentLargeImageQuery = { entities?: Array<CosmosPageRefSectionContentLargeImageQuery_entities> | null };


export type CosmosPageRefSectionContentLargeImageQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionCruxQuery_entities_CosmosReferenceSection_section_CosmosSectionCrux = { __typename: 'CosmosSectionCrux', id: string, config?: CruxSectionFragment_config | null, cruxLinks: Array<CruxSectionFragment_cruxLinks> };

export type CosmosPageRefSectionCruxQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionCruxQuery_entities_CosmosReferenceSection_section_CosmosSectionCrux
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionCruxQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionCruxQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionCruxQuery_entities =
  | CosmosPageRefSectionCruxQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionCruxQuery = { entities?: Array<CosmosPageRefSectionCruxQuery_entities> | null };


export type CosmosPageRefSectionCruxQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionDividerQuery_entities_CosmosReferenceSection_section_CosmosSectionDivider = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: Types.CosmosEnumEdsBackgroundColors | null, size?: Types.CosmosEnumSectionSizes | null };

export type CosmosPageRefSectionDividerQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionDividerQuery_entities_CosmosReferenceSection_section_CosmosSectionDivider
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDividerQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionDividerQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionDividerQuery_entities =
  | CosmosPageRefSectionDividerQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDividerQuery = { entities?: Array<CosmosPageRefSectionDividerQuery_entities> | null };


export type CosmosPageRefSectionDividerQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionDownloadableQuery_entities_CosmosReferenceSection_section_CosmosSectionDownloadable = { __typename: 'CosmosSectionDownloadable', id: string, config?: DownloadableSectionFragment_config | null, instructions?: DownloadableSectionFragment_instructions | null, executables: Array<DownloadableSectionFragment_executables>, footer?: DownloadableSectionFragment_footer | null };

export type CosmosPageRefSectionDownloadableQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionDownloadableQuery_entities_CosmosReferenceSection_section_CosmosSectionDownloadable
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDownloadableQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionDownloadableQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionDownloadableQuery_entities =
  | CosmosPageRefSectionDownloadableQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDownloadableQuery = { entities?: Array<CosmosPageRefSectionDownloadableQuery_entities> | null };


export type CosmosPageRefSectionDownloadableQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionDownloadCardQuery_entities_CosmosReferenceSection_section_CosmosSectionDownloadCard = { __typename: 'CosmosSectionDownloadCard', id: string, config?: DownloadCardsSectionFragment_config | null, steps: Array<DownloadCardsSectionFragment_steps>, footer?: DownloadCardsSectionFragment_footer | null };

export type CosmosPageRefSectionDownloadCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionDownloadCardQuery_entities_CosmosReferenceSection_section_CosmosSectionDownloadCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDownloadCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionDownloadCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionDownloadCardQuery_entities =
  | CosmosPageRefSectionDownloadCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDownloadCardQuery = { entities?: Array<CosmosPageRefSectionDownloadCardQuery_entities> | null };


export type CosmosPageRefSectionDownloadCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionEmbedQuery_entities_CosmosReferenceSection_section_CosmosSectionEmbed = { __typename: 'CosmosSectionEmbed', id: string, size?: Types.CosmosEnumSectionSizes | null, config?: EmbedSectionFragment_config | null, embed?: EmbedSectionFragment_embed | null };

export type CosmosPageRefSectionEmbedQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionEmbedQuery_entities_CosmosReferenceSection_section_CosmosSectionEmbed
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionEmbedQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionEmbedQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionEmbedQuery_entities =
  | CosmosPageRefSectionEmbedQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionEmbedQuery = { entities?: Array<CosmosPageRefSectionEmbedQuery_entities> | null };


export type CosmosPageRefSectionEmbedQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionEventsTableQuery_entities_CosmosReferenceSection_section_CosmosSectionEventsTable = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: EventsTableSectionFragment_config | null, blurredImage?: EventsTableSectionFragment_blurredImage | null, events: Array<EventsTableSectionFragment_events> };

export type CosmosPageRefSectionEventsTableQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionEventsTableQuery_entities_CosmosReferenceSection_section_CosmosSectionEventsTable
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionEventsTableQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionEventsTableQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionEventsTableQuery_entities =
  | CosmosPageRefSectionEventsTableQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionEventsTableQuery = { entities?: Array<CosmosPageRefSectionEventsTableQuery_entities> | null };


export type CosmosPageRefSectionEventsTableQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionFeatureCardQuery_entities_CosmosReferenceSection_section_CosmosSectionFeatureCard = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: FeatureCardsSectionFragment_config | null, tags: Array<FeatureCardsSectionFragment_tags>, cards: Array<FeatureCardsSectionFragment_cards> };

export type CosmosPageRefSectionFeatureCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionFeatureCardQuery_entities_CosmosReferenceSection_section_CosmosSectionFeatureCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionFeatureCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionFeatureCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionFeatureCardQuery_entities =
  | CosmosPageRefSectionFeatureCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionFeatureCardQuery = { entities?: Array<CosmosPageRefSectionFeatureCardQuery_entities> | null };


export type CosmosPageRefSectionFeatureCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionFaqQuery_entities_CosmosReferenceSection_section_CosmosSectionFaq = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSectionFragment_config | null, title?: FaqSectionFragment_title | null, items: Array<FaqSectionFragment_items>, refFaqItems: Array<FaqSectionFragment_refFaqItems>, modButtons: Array<FaqSectionFragment_modButtons>, faqButtons: Array<FaqSectionFragment_faqButtons> };

export type CosmosPageRefSectionFaqQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionFaqQuery_entities_CosmosReferenceSection_section_CosmosSectionFaq
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionFaqQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionFaqQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionFaqQuery_entities =
  | CosmosPageRefSectionFaqQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionFaqQuery = { entities?: Array<CosmosPageRefSectionFaqQuery_entities> | null };


export type CosmosPageRefSectionFaqQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionGameDevFeatureCardQuery_entities_CosmosReferenceSection_section_CosmosSectionGameDevFeatureCard = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: FeaturePanelsSectionFragment_config | null, cards: Array<FeaturePanelsSectionFragment_cards>, buttons: Array<FeaturePanelsSectionFragment_buttons> };

export type CosmosPageRefSectionGameDevFeatureCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionGameDevFeatureCardQuery_entities_CosmosReferenceSection_section_CosmosSectionGameDevFeatureCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionGameDevFeatureCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionGameDevFeatureCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionGameDevFeatureCardQuery_entities =
  | CosmosPageRefSectionGameDevFeatureCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionGameDevFeatureCardQuery = { entities?: Array<CosmosPageRefSectionGameDevFeatureCardQuery_entities> | null };


export type CosmosPageRefSectionGameDevFeatureCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionAccordionFeatureCardQuery_entities_CosmosReferenceSection_section_CosmosSectionAccordionFeatureCard = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: AccordionFeatureCardsSectionFragment_config | null, items: Array<AccordionFeatureCardsSectionFragment_items> };

export type CosmosPageRefSectionAccordionFeatureCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionAccordionFeatureCardQuery_entities_CosmosReferenceSection_section_CosmosSectionAccordionFeatureCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAccordionFeatureCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionAccordionFeatureCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionAccordionFeatureCardQuery_entities =
  | CosmosPageRefSectionAccordionFeatureCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAccordionFeatureCardQuery = { entities?: Array<CosmosPageRefSectionAccordionFeatureCardQuery_entities> | null };


export type CosmosPageRefSectionAccordionFeatureCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionAccordionTierCardsQuery_entities_CosmosReferenceSection_section_CosmosSectionAccordionTierCards = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: AccordionTierCardsSectionFragment_config | null, items: Array<AccordionTierCardsSectionFragment_items> };

export type CosmosPageRefSectionAccordionTierCardsQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionAccordionTierCardsQuery_entities_CosmosReferenceSection_section_CosmosSectionAccordionTierCards
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAccordionTierCardsQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionAccordionTierCardsQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionAccordionTierCardsQuery_entities =
  | CosmosPageRefSectionAccordionTierCardsQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAccordionTierCardsQuery = { entities?: Array<CosmosPageRefSectionAccordionTierCardsQuery_entities> | null };


export type CosmosPageRefSectionAccordionTierCardsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionLearnQuery_entities_CosmosReferenceSection_section_CosmosSectionLearn = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: Types.CosmosEnumApplicationFamily | null, config?: LearnSectionFragment_config | null, tabs: Array<LearnSectionFragment_tabs>, categories: Array<LearnSectionFragment_categories> };

export type CosmosPageRefSectionLearnQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionLearnQuery_entities_CosmosReferenceSection_section_CosmosSectionLearn
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLearnQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionLearnQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionLearnQuery_entities =
  | CosmosPageRefSectionLearnQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLearnQuery = { entities?: Array<CosmosPageRefSectionLearnQuery_entities> | null };


export type CosmosPageRefSectionLearnQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionLogoListQuery_entities_CosmosReferenceSection_section_CosmosSectionLogoList = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: LogoListSectionFragment_config | null, logos: Array<LogoListSectionFragment_logos> };

export type CosmosPageRefSectionLogoListQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionLogoListQuery_entities_CosmosReferenceSection_section_CosmosSectionLogoList
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLogoListQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionLogoListQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionLogoListQuery_entities =
  | CosmosPageRefSectionLogoListQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLogoListQuery = { entities?: Array<CosmosPageRefSectionLogoListQuery_entities> | null };


export type CosmosPageRefSectionLogoListQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionLogoMultiCardQuery_entities_CosmosReferenceSection_section_CosmosSectionLogoMultiCard = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: LogoMultiCardsSectionFragment_config | null, title?: LogoMultiCardsSectionFragment_title | null, buttons: Array<LogoMultiCardsSectionFragment_buttons>, links: Array<LogoMultiCardsSectionFragment_links>, cards: Array<LogoMultiCardsSectionFragment_cards> };

export type CosmosPageRefSectionLogoMultiCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionLogoMultiCardQuery_entities_CosmosReferenceSection_section_CosmosSectionLogoMultiCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLogoMultiCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionLogoMultiCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionLogoMultiCardQuery_entities =
  | CosmosPageRefSectionLogoMultiCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLogoMultiCardQuery = { entities?: Array<CosmosPageRefSectionLogoMultiCardQuery_entities> | null };


export type CosmosPageRefSectionLogoMultiCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionNewsCardQuery_entities_CosmosReferenceSection_section_CosmosSectionNewsCard = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: Types.EnumSmallNewsCardMax | null, config?: NewsCardsSectionFragment_config | null, cards: Array<NewsCardsSectionFragment_cards> };

export type CosmosPageRefSectionNewsCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionNewsCardQuery_entities_CosmosReferenceSection_section_CosmosSectionNewsCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNewsCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionNewsCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionNewsCardQuery_entities =
  | CosmosPageRefSectionNewsCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNewsCardQuery = { entities?: Array<CosmosPageRefSectionNewsCardQuery_entities> | null };


export type CosmosPageRefSectionNewsCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionNewsMediaCardQuery_entities_CosmosReferenceSection_section_CosmosSectionNewsMediaCard = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: NewsMediaCardsSectionFragment_config | null, cards: Array<NewsMediaCardsSectionFragment_cards> };

export type CosmosPageRefSectionNewsMediaCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionNewsMediaCardQuery_entities_CosmosReferenceSection_section_CosmosSectionNewsMediaCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNewsMediaCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionNewsMediaCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionNewsMediaCardQuery_entities =
  | CosmosPageRefSectionNewsMediaCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNewsMediaCardQuery = { entities?: Array<CosmosPageRefSectionNewsMediaCardQuery_entities> | null };


export type CosmosPageRefSectionNewsMediaCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionLicensesCollapsedQuery_entities_CosmosReferenceSection_section_CosmosSectionLicensesCollapsed = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: LicensesCollapsedSectionFragment_config | null, topCard?: LicensesCollapsedSectionFragment_topCard | null, collapsedCards: Array<LicensesCollapsedSectionFragment_collapsedCards>, collapsedCta?: LicensesCollapsedSectionFragment_collapsedCta | null };

export type CosmosPageRefSectionLicensesCollapsedQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionLicensesCollapsedQuery_entities_CosmosReferenceSection_section_CosmosSectionLicensesCollapsed
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLicensesCollapsedQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionLicensesCollapsedQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionLicensesCollapsedQuery_entities =
  | CosmosPageRefSectionLicensesCollapsedQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLicensesCollapsedQuery = { entities?: Array<CosmosPageRefSectionLicensesCollapsedQuery_entities> | null };


export type CosmosPageRefSectionLicensesCollapsedQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionRichTextQuery_entities_CosmosReferenceSection_section_CosmosSectionRichText = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_config | null, content?: CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_content | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionRichText_buttons> };

export type CosmosPageRefSectionRichTextQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionRichTextQuery_entities_CosmosReferenceSection_section_CosmosSectionRichText
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionRichTextQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionRichTextQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionRichTextQuery_entities =
  | CosmosPageRefSectionRichTextQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionRichTextQuery = { entities?: Array<CosmosPageRefSectionRichTextQuery_entities> | null };


export type CosmosPageRefSectionRichTextQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionGeminiCardQuery_entities_CosmosReferenceSection_section_CosmosSectionGeminiCard = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: Types.CosmosEnumGeminiVariants | null, logoImage?: GeminiCardsSectionFragment_logoImage | null, config?: GeminiCardsSectionFragment_config | null, title?: GeminiCardsSectionFragment_title | null, cards: Array<GeminiCardsSectionFragment_cards> };

export type CosmosPageRefSectionGeminiCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionGeminiCardQuery_entities_CosmosReferenceSection_section_CosmosSectionGeminiCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionGeminiCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionGeminiCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionGeminiCardQuery_entities =
  | CosmosPageRefSectionGeminiCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionGeminiCardQuery = { entities?: Array<CosmosPageRefSectionGeminiCardQuery_entities> | null };


export type CosmosPageRefSectionGeminiCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionHydrusColumnListQuery_entities_CosmosReferenceSection_section_CosmosSectionHydrusColumnList = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: HydrusColumnListSectionFragment_config | null, columns: Array<HydrusColumnListSectionFragment_columns> };

export type CosmosPageRefSectionHydrusColumnListQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionHydrusColumnListQuery_entities_CosmosReferenceSection_section_CosmosSectionHydrusColumnList
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionHydrusColumnListQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionHydrusColumnListQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionHydrusColumnListQuery_entities =
  | CosmosPageRefSectionHydrusColumnListQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionHydrusColumnListQuery = { entities?: Array<CosmosPageRefSectionHydrusColumnListQuery_entities> | null };


export type CosmosPageRefSectionHydrusColumnListQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionDelphinusCardsGridQuery_entities_CosmosReferenceSection_section_CosmosSectionDelphinusCardsGrid = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: DelphinusCardsGridSectionFragment_config | null, grid: Array<DelphinusCardsGridSectionFragment_grid> };

export type CosmosPageRefSectionDelphinusCardsGridQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionDelphinusCardsGridQuery_entities_CosmosReferenceSection_section_CosmosSectionDelphinusCardsGrid
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDelphinusCardsGridQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionDelphinusCardsGridQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionDelphinusCardsGridQuery_entities =
  | CosmosPageRefSectionDelphinusCardsGridQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDelphinusCardsGridQuery = { entities?: Array<CosmosPageRefSectionDelphinusCardsGridQuery_entities> | null };


export type CosmosPageRefSectionDelphinusCardsGridQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionNewsletterSignupQuery_entities_CosmosReferenceSection_section_CosmosSectionNewsletterSignup = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: NewsletterSignupFragment_industriesRef | null };

export type CosmosPageRefSectionNewsletterSignupQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionNewsletterSignupQuery_entities_CosmosReferenceSection_section_CosmosSectionNewsletterSignup
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNewsletterSignupQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionNewsletterSignupQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionNewsletterSignupQuery_entities =
  | CosmosPageRefSectionNewsletterSignupQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNewsletterSignupQuery = { entities?: Array<CosmosPageRefSectionNewsletterSignupQuery_entities> | null };


export type CosmosPageRefSectionNewsletterSignupQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionSimpleCtaQuery_entities_CosmosReferenceSection_section_CosmosSectionSimpleCta = { __typename: 'CosmosSectionSimpleCta', id: string, style?: Types.CosmosEnumSimpleCtaStyle | null, gradient?: Types.CosmosEnumEdsGradients | null, icon?: Types.EdsIconsEnum | null, eyebrow?: string | null, leftDesc?: string | null, desc?: string | null, simpleCtaVariant?: Types.CosmosEnumSimpleCtaVariant | null, title?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_title | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_buttons>, backgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSimpleCta_backgroundImage | null };

export type CosmosPageRefSectionSimpleCtaQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionSimpleCtaQuery_entities_CosmosReferenceSection_section_CosmosSectionSimpleCta
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionSimpleCtaQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionSimpleCtaQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionSimpleCtaQuery_entities =
  | CosmosPageRefSectionSimpleCtaQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionSimpleCtaQuery = { entities?: Array<CosmosPageRefSectionSimpleCtaQuery_entities> | null };


export type CosmosPageRefSectionSimpleCtaQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionSlimContactCardQuery_entities_CosmosReferenceSection_section_CosmosSectionSlimContactCard = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSlimContactCard_cards> };

export type CosmosPageRefSectionSlimContactCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionSlimContactCardQuery_entities_CosmosReferenceSection_section_CosmosSectionSlimContactCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionSlimContactCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionSlimContactCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionSlimContactCardQuery_entities =
  | CosmosPageRefSectionSlimContactCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionSlimContactCardQuery = { entities?: Array<CosmosPageRefSectionSlimContactCardQuery_entities> | null };


export type CosmosPageRefSectionSlimContactCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionSpeakerCardQuery_entities_CosmosReferenceSection_section_CosmosSectionSpeakerCard = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_config | null, speakers: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionSpeakerCard_speakers> };

export type CosmosPageRefSectionSpeakerCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionSpeakerCardQuery_entities_CosmosReferenceSection_section_CosmosSectionSpeakerCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionSpeakerCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionSpeakerCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionSpeakerCardQuery_entities =
  | CosmosPageRefSectionSpeakerCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionSpeakerCardQuery = { entities?: Array<CosmosPageRefSectionSpeakerCardQuery_entities> | null };


export type CosmosPageRefSectionSpeakerCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionLatestNewsQuery_entities_CosmosReferenceSection_section_CosmosSectionLatestNews = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: Types.CosmosEnumLatestNewsVariants | null, config?: LatestNewsSectionFragment_config | null, wfRefBlogTags: Array<LatestNewsSectionFragment_wfRefBlogTags>, cosmosPageBlogDetails: Array<LatestNewsSectionFragment_cosmosPageBlogDetails> };

export type CosmosPageRefSectionLatestNewsQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionLatestNewsQuery_entities_CosmosReferenceSection_section_CosmosSectionLatestNews
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLatestNewsQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionLatestNewsQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionLatestNewsQuery_entities =
  | CosmosPageRefSectionLatestNewsQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionLatestNewsQuery = { entities?: Array<CosmosPageRefSectionLatestNewsQuery_entities> | null };


export type CosmosPageRefSectionLatestNewsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionNumberCalloutQuery_entities_CosmosReferenceSection_section_CosmosSectionNumberCallout = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: Types.EdsIconsEnum | null, iconGradient?: Types.CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: Types.CosmosEnumNumberCalloutVariants | null, config?: NumberCalloutSectionFragment_config | null, title?: NumberCalloutSectionFragment_title | null, callouts: Array<NumberCalloutSectionFragment_callouts>, buttons: Array<NumberCalloutSectionFragment_buttons>, asset?: NumberCalloutSectionFragment_asset | null };

export type CosmosPageRefSectionNumberCalloutQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionNumberCalloutQuery_entities_CosmosReferenceSection_section_CosmosSectionNumberCallout
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNumberCalloutQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionNumberCalloutQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionNumberCalloutQuery_entities =
  | CosmosPageRefSectionNumberCalloutQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionNumberCalloutQuery = { entities?: Array<CosmosPageRefSectionNumberCalloutQuery_entities> | null };


export type CosmosPageRefSectionNumberCalloutQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionTabbedFullWidthAssetQuery_entities_CosmosReferenceSection_section_CosmosSectionTabbedFullWidthAsset = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedFullWidthAsset_tabs> };

export type CosmosPageRefSectionTabbedFullWidthAssetQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionTabbedFullWidthAssetQuery_entities_CosmosReferenceSection_section_CosmosSectionTabbedFullWidthAsset
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionTabbedFullWidthAssetQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionTabbedFullWidthAssetQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionTabbedFullWidthAssetQuery_entities =
  | CosmosPageRefSectionTabbedFullWidthAssetQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionTabbedFullWidthAssetQuery = { entities?: Array<CosmosPageRefSectionTabbedFullWidthAssetQuery_entities> | null };


export type CosmosPageRefSectionTabbedFullWidthAssetQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionTabbedBlogCardQuery_entities_CosmosReferenceSection_section_CosmosSectionTabbedBlogCard = { __typename: 'CosmosSectionTabbedBlogCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedBlogCard_tabs> };

export type CosmosPageRefSectionTabbedBlogCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionTabbedBlogCardQuery_entities_CosmosReferenceSection_section_CosmosSectionTabbedBlogCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionTabbedBlogCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionTabbedBlogCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionTabbedBlogCardQuery_entities =
  | CosmosPageRefSectionTabbedBlogCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionTabbedBlogCardQuery = { entities?: Array<CosmosPageRefSectionTabbedBlogCardQuery_entities> | null };


export type CosmosPageRefSectionTabbedBlogCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionTabbedContentImageQuery_entities_CosmosReferenceSection_section_CosmosSectionTabbedContentImage = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_config | null, tabs: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionTabbedContentImage_tabs> };

export type CosmosPageRefSectionTabbedContentImageQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionTabbedContentImageQuery_entities_CosmosReferenceSection_section_CosmosSectionTabbedContentImage
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionTabbedContentImageQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionTabbedContentImageQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionTabbedContentImageQuery_entities =
  | CosmosPageRefSectionTabbedContentImageQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionTabbedContentImageQuery = { entities?: Array<CosmosPageRefSectionTabbedContentImageQuery_entities> | null };


export type CosmosPageRefSectionTabbedContentImageQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionFaqSearchQuery_entities_CosmosReferenceSection_section_CosmosSectionFaqSearch = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: Types.CosmosEnumFaqButtonsPosition | null, config?: FaqSearchSectionFragment_config | null, title?: FaqSearchSectionFragment_title | null, faqTabs: Array<FaqSearchSectionFragment_faqTabs>, modButtons: Array<FaqSearchSectionFragment_modButtons> };

export type CosmosPageRefSectionFaqSearchQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionFaqSearchQuery_entities_CosmosReferenceSection_section_CosmosSectionFaqSearch
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionFaqSearchQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionFaqSearchQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionFaqSearchQuery_entities =
  | CosmosPageRefSectionFaqSearchQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionFaqSearchQuery = { entities?: Array<CosmosPageRefSectionFaqSearchQuery_entities> | null };


export type CosmosPageRefSectionFaqSearchQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionCkRichTextQuery_entities_CosmosReferenceSection_section_CosmosSectionCkRichText = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_config | null, buttons: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionCkRichText_buttons> };

export type CosmosPageRefSectionCkRichTextQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionCkRichTextQuery_entities_CosmosReferenceSection_section_CosmosSectionCkRichText
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionCkRichTextQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionCkRichTextQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionCkRichTextQuery_entities =
  | CosmosPageRefSectionCkRichTextQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionCkRichTextQuery = { entities?: Array<CosmosPageRefSectionCkRichTextQuery_entities> | null };


export type CosmosPageRefSectionCkRichTextQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionAriesCardsQuery_entities_CosmosReferenceSection_section_CosmosSectionAriesCards = { __typename: 'CosmosSectionAriesCards', id: string, config?: AriesCardsSectionFragment_config | null, cards: Array<AriesCardsSectionFragment_cards> };

export type CosmosPageRefSectionAriesCardsQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionAriesCardsQuery_entities_CosmosReferenceSection_section_CosmosSectionAriesCards
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAriesCardsQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionAriesCardsQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionAriesCardsQuery_entities =
  | CosmosPageRefSectionAriesCardsQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionAriesCardsQuery = { entities?: Array<CosmosPageRefSectionAriesCardsQuery_entities> | null };


export type CosmosPageRefSectionAriesCardsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionContentSliderAssetQuery_entities_CosmosReferenceSection_section_CosmosSectionContentSliderAsset = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: ContentSliderAssetFragment_config | null, badges: Array<ContentSliderAssetFragment_badges>, title?: ContentSliderAssetFragment_title | null, buttons: Array<ContentSliderAssetFragment_buttons>, assets: Array<ContentSliderAssetFragment_assets> };

export type CosmosPageRefSectionContentSliderAssetQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionContentSliderAssetQuery_entities_CosmosReferenceSection_section_CosmosSectionContentSliderAsset
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionContentSliderAssetQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionContentSliderAssetQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionContentSliderAssetQuery_entities =
  | CosmosPageRefSectionContentSliderAssetQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionContentSliderAssetQuery = { entities?: Array<CosmosPageRefSectionContentSliderAssetQuery_entities> | null };


export type CosmosPageRefSectionContentSliderAssetQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionQuoteQuery_entities_CosmosReferenceSection_section_CosmosSectionQuote = { __typename: 'CosmosSectionQuote', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_config | null, quotes: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionQuote_quotes> };

export type CosmosPageRefSectionQuoteQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionQuoteQuery_entities_CosmosReferenceSection_section_CosmosSectionQuote
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionQuoteQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionQuoteQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionQuoteQuery_entities =
  | CosmosPageRefSectionQuoteQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionQuoteQuery = { entities?: Array<CosmosPageRefSectionQuoteQuery_entities> | null };


export type CosmosPageRefSectionQuoteQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionUtCardQuery_entities_CosmosReferenceSection_section_CosmosSectionUtCard = { __typename: 'CosmosSectionUtCard', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionUtCard_cards> };

export type CosmosPageRefSectionUtCardQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionUtCardQuery_entities_CosmosReferenceSection_section_CosmosSectionUtCard
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionUtCardQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionUtCardQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionUtCardQuery_entities =
  | CosmosPageRefSectionUtCardQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionUtCardQuery = { entities?: Array<CosmosPageRefSectionUtCardQuery_entities> | null };


export type CosmosPageRefSectionUtCardQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionResellersSearchQuery_entities_CosmosReferenceSection_section_CosmosSectionResellersSearch = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_config | null, cards: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards>, cards2: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards2>, cards3: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards3>, cards4: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_cards4>, blurredBackgroundImage?: CosmosPageAgreementFragment_refSections_section_CosmosSectionResellersSearch_blurredBackgroundImage | null };

export type CosmosPageRefSectionResellersSearchQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionResellersSearchQuery_entities_CosmosReferenceSection_section_CosmosSectionResellersSearch
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionResellersSearchQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionResellersSearchQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionResellersSearchQuery_entities =
  | CosmosPageRefSectionResellersSearchQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionResellersSearchQuery = { entities?: Array<CosmosPageRefSectionResellersSearchQuery_entities> | null };


export type CosmosPageRefSectionResellersSearchQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionPluginListTableQuery_entities_CosmosReferenceSection_section_CosmosSectionPluginListTable = { __typename: 'CosmosSectionPluginListTable', id: string, config?: CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_config | null, tableItems: Array<CosmosPageAgreementFragment_refSections_section_CosmosSectionPluginListTable_tableItems> };

export type CosmosPageRefSectionPluginListTableQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionPluginListTableQuery_entities_CosmosReferenceSection_section_CosmosSectionPluginListTable
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionPluginListTableQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionPluginListTableQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionPluginListTableQuery_entities =
  | CosmosPageRefSectionPluginListTableQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionPluginListTableQuery = { entities?: Array<CosmosPageRefSectionPluginListTableQuery_entities> | null };


export type CosmosPageRefSectionPluginListTableQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionDevelopersListQuery_entities_CosmosReferenceSection_section_CosmosSectionDevelopersList = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: DevelopersListSectionFragment_config | null, developersTsv?: DevelopersListSectionFragment_developersTsv | null };

export type CosmosPageRefSectionDevelopersListQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionDevelopersListQuery_entities_CosmosReferenceSection_section_CosmosSectionDevelopersList
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDevelopersListQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionDevelopersListQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionDevelopersListQuery_entities =
  | CosmosPageRefSectionDevelopersListQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionDevelopersListQuery = { entities?: Array<CosmosPageRefSectionDevelopersListQuery_entities> | null };


export type CosmosPageRefSectionDevelopersListQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionOrionCardsQuery_entities_CosmosReferenceSection_section_CosmosSectionOrionCards = { __typename: 'CosmosSectionOrionCards', id: string, eyebrow?: string | null, titleGradient?: Types.CosmosEnumEdsGradients | null, desc?: string | null, config?: OrionCardsSectionFragment_config | null, title?: OrionCardsSectionFragment_title | null, modButtons: Array<OrionCardsSectionFragment_modButtons>, cards: Array<OrionCardsSectionFragment_cards> };

export type CosmosPageRefSectionOrionCardsQuery_entities_CosmosReferenceSection_section =
  | CosmosPageRefSectionOrionCardsQuery_entities_CosmosReferenceSection_section_CosmosSectionOrionCards
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionOrionCardsQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageRefSectionOrionCardsQuery_entities_CosmosReferenceSection_section | null };

export type CosmosPageRefSectionOrionCardsQuery_entities =
  | CosmosPageRefSectionOrionCardsQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionOrionCardsQuery = { entities?: Array<CosmosPageRefSectionOrionCardsQuery_entities> | null };


export type CosmosPageRefSectionOrionCardsQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageRefSectionQuery_entities_CosmosReferenceSection = { __typename: 'CosmosReferenceSection', id: string, section?: CosmosPageAgreementFragment_refSections_section | null };

export type CosmosPageRefSectionQuery_entities =
  | CosmosPageRefSectionQuery_entities_CosmosReferenceSection
  | Record<PropertyKey, never>
;

export type CosmosPageRefSectionQuery = { entities?: Array<CosmosPageRefSectionQuery_entities> | null };


export type CosmosPageRefSectionQueryVariables = Exact<{
  entities: Array<Types.EntityWhereInput> | Types.EntityWhereInput;
  locale?: Array<Types.Locale> | Types.Locale | null | undefined;
}>;

export type CosmosPageTemplatesQuery_cosmosPageHeroAndSection = { __typename: 'CosmosPageHeroAndSection', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageDirectory = { __typename: 'CosmosPageDirectory', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageBlogDetail = { __typename: 'CosmosPageBlogDetail', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageEulaKey = { __typename: 'CosmosPageEulaKey', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageRedirect = { __typename: 'CosmosPageRedirect', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageLegalContent = { __typename: 'CosmosPageLegalContent', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageSearch = { __typename: 'CosmosPageSearch', id: string, slug: string };

export type CosmosPageTemplatesQuery_cosmosPageResearch = { __typename: 'CosmosPageResearch', id: string, slug: string };

export type CosmosPageTemplatesQuery = { cosmosPageHeroAndSection?: CosmosPageTemplatesQuery_cosmosPageHeroAndSection | null, cosmosPageDirectory?: CosmosPageTemplatesQuery_cosmosPageDirectory | null, cosmosPageBlogDetail?: CosmosPageTemplatesQuery_cosmosPageBlogDetail | null, cosmosPageEulaKey?: CosmosPageTemplatesQuery_cosmosPageEulaKey | null, cosmosPageRedirect?: CosmosPageTemplatesQuery_cosmosPageRedirect | null, cosmosPageLegalContent?: CosmosPageTemplatesQuery_cosmosPageLegalContent | null, cosmosPageSearch?: CosmosPageTemplatesQuery_cosmosPageSearch | null, cosmosPageResearch?: CosmosPageTemplatesQuery_cosmosPageResearch | null };


export type CosmosPageTemplatesQueryVariables = Exact<{
  locale: Array<Types.Locale> | Types.Locale;
  slug: string;
}>;

export type WfRefApplicationOwnersQuery_wfRefApplicationOwners = { id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type WfRefApplicationOwnersQuery = { wfRefApplicationOwners: Array<WfRefApplicationOwnersQuery_wfRefApplicationOwners> };


export type WfRefApplicationOwnersQueryVariables = Exact<{ [key: string]: never; }>;

export type WfRefTagsQuery_wfRefBlogTags = { tagId: string };

export type WfRefTagsQuery = { wfRefBlogTags: Array<WfRefTagsQuery_wfRefBlogTags> };


export type WfRefTagsQueryVariables = Exact<{
  first?: number | null | undefined;
  skip?: number | null | undefined;
}>;

export const WfRefApplicationOwnerFragmentDoc = gql`
    fragment WfRefApplicationOwner on WfRefApplicationOwner {
  id
  isDefault
  label
  ownerId
  prodUrl
  gamedevUrl
  pageSlugPrefix
}
    `;
export const CosmosSeoFragmentDoc = gql`
    fragment CosmosSeo on CosmosSeo {
  title
  socialTitle
  description
  socialDescription
  openGraphImage {
    url(transformation: {image: {resize: {width: 1200}}})
    width
    height
  }
  noIndex
  noFollow
}
    `;
export const PageDirectoryMetadataFragmentDoc = gql`
    fragment PageDirectoryMetadata on CosmosPageDirectory {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const RefSectionsEntitiesFragmentDoc = gql`
    fragment RefSectionsEntities on CosmosReferenceSection {
  __typename
  id
  stage
  section {
    ... on Entity {
      id
      stage
      __typename
    }
  }
}
    `;
export const CosmosRichTextFragmentDoc = gql`
    fragment CosmosRichText on RichText {
  __typename
  html
  text
}
    `;
export const CosmosButtonFragmentDoc = gql`
    fragment CosmosButton on CosmosElementButton {
  __typename
  label
  variant
  href
  name
}
    `;
export const CosmosIconButtonFragmentDoc = gql`
    fragment CosmosIconButton on CosmosElementIconButton {
  __typename
  icon
  name
  label
  variant
  href
  iconPosition
}
    `;
export const CosmosModButtonFragmentDoc = gql`
    fragment CosmosModButton on CosmosElementSectionHeadingmodButtonsUnion {
  ... on CosmosElementButton {
    ...CosmosButton
  }
  ... on CosmosElementIconButton {
    ...CosmosIconButton
  }
}
    ${CosmosButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const SectionHeadingFragmentDoc = gql`
    fragment SectionHeading on CosmosElementSectionHeading {
  __typename
  title {
    ...CosmosRichText
  }
  compressedTitle
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  centeredVerticalStack
  titleGradient
  buttonAlignLeft
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const IconSectionHeadingFragmentDoc = gql`
    fragment IconSectionHeading on CosmosElementIconSectionHeading {
  __typename
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  titleGradient
  compressedTitle
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  centeredVerticalStack
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const SectionConfigHeadingUnionFragmentDoc = gql`
    fragment SectionConfigHeadingUnion on CosmosConfigSectionheadingUnion {
  ... on CosmosElementSectionHeading {
    ...SectionHeading
  }
  ... on CosmosElementIconSectionHeading {
    ...IconSectionHeading
  }
}
    ${SectionHeadingFragmentDoc}
${IconSectionHeadingFragmentDoc}`;
export const CosmosAssetFragmentDoc = gql`
    fragment CosmosAsset on Asset {
  __typename
  id
  url
  altText
  attribution
  mimeType
  enableVideoControls
  width
  height
  fallbackImage {
    url
    altText
    width
    height
    mimeType
    optUrl: url(
      transformation: {image: {resize: {width: 1200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  overrideEmbedUrl
  overrideEmbedDisableOverlay
}
    `;
export const SectionConfigFragmentDoc = gql`
    fragment SectionConfig on CosmosConfigSection {
  __typename
  anchorId
  heading {
    ...SectionConfigHeadingUnion
  }
  edsBackgroundColor
  backgroundImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  backgroundFullHeight
  collapsed
  backgroundAnimation
  disablePaddingBottom
  backgroundOverlayOverride
  backgroundLayoutOverride
}
    ${SectionConfigHeadingUnionFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const ServicePartnerDetailFragmentDoc = gql`
    fragment ServicePartnerDetail on CosmosDetailServicePartner {
  __typename
  id
  config {
    ...SectionConfig
  }
  blurredBackgroundImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1680}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${SectionConfigFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const PageDirectoryEntitiesFragmentDoc = gql`
    fragment PageDirectoryEntities on CosmosPageDirectory {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  topRefSections(first: 30) {
    ...RefSectionsEntities
  }
  bottomRefSections(first: 30) {
    ...RefSectionsEntities
  }
  variant
  servicePartnerDetail {
    ...ServicePartnerDetail
  }
  directoryEyebrow
  directoryTitle
  directoryDesc
  searchPlaceholder
  industryFilterLabel
  serviceFilterLabel
  serviceFilterPlaceholder
  noResultsLabel
}
    ${WfRefApplicationOwnerFragmentDoc}
${RefSectionsEntitiesFragmentDoc}
${ServicePartnerDetailFragmentDoc}`;
export const DocumentListItemFragmentDoc = gql`
    fragment DocumentListItem on CosmosElementDocumentListItem {
  icon
  iconGradient
  title
  href
}
    `;
export const DocumentListFragmentDoc = gql`
    fragment DocumentList on CosmosElementDocumentList {
  listId
  heading
  items {
    ...DocumentListItem
  }
}
    ${DocumentListItemFragmentDoc}`;
export const CosmosPageAgreementCoreFragmentDoc = gql`
    fragment CosmosPageAgreementCore on CosmosPageAgreement {
  __typename
  id
  createdAt
  updatedAt
  slug
  title
  blocked
}
    `;
export const AgreementDetailsFragmentDoc = gql`
    fragment AgreementDetails on CosmosElementAgreementDetail {
  __typename
  agreementKeyEula
  acceptedRedirect
  acceptedTimeout
  acceptButtonLabel
  acceptOptionLabel
  acceptedContent
  mustAcceptWarning
}
    `;
export const CosmosPageAgreementEntitiesFragmentDoc = gql`
    fragment CosmosPageAgreementEntities on CosmosPageAgreement {
  ...CosmosPageAgreementCore
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
  agreementDetails {
    ...AgreementDetails
  }
}
    ${CosmosPageAgreementCoreFragmentDoc}
${RefSectionsEntitiesFragmentDoc}
${AgreementDetailsFragmentDoc}`;
export const PageAgreementMetadataFragmentDoc = gql`
    fragment PageAgreementMetadata on CosmosPageAgreement {
  __typename
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    ${CosmosSeoFragmentDoc}`;
export const HeroAlphaMainStackFragmentDoc = gql`
    fragment HeroAlphaMainStack on CosmosHeroAlpha {
  logoImage {
    __typename
    url
    width
    height
    altText
  }
  logoVariant
  eyebrow
  title {
    html
    text
  }
  gradient
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
}
    ${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const HeroAlphaFragmentDoc = gql`
    fragment HeroAlpha on CosmosHeroAlpha {
  __typename
  id
  variant
  blurredImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  heroAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  ...HeroAlphaMainStack
}
    ${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}`;
export const HeroGlowFragmentDoc = gql`
    fragment HeroGlow on CosmosHeroGlow {
  __typename
  id
  blurredImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  logoImage {
    __typename
    url
    width
    height
    altText
  }
  eyebrow
  title {
    ...CosmosRichText
  }
  gradient
  desc
  narrow
  disablePaddingBlockEnd
  modButtons {
    ...CosmosModButton
  }
}
    ${CosmosAssetFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const HeroArticleImageFragmentDoc = gql`
    fragment HeroArticleImage on CosmosHeroArticleImage {
  __typename
  id
  title {
    ...CosmosRichText
  }
  gradient
  description {
    ...CosmosRichText
  }
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1000}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
  backgroundAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const HeroBravoFragmentDoc = gql`
    fragment HeroBravo on CosmosHeroBravo {
  __typename
  id
  title {
    ...CosmosRichText
  }
  gradient
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  backgroundAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const PageHeroesFragmentDoc = gql`
    fragment PageHeroes on CosmosPageHeroAndSectionheroUnion {
  ... on CosmosHeroAlpha {
    ...HeroAlpha
  }
  ... on CosmosHeroGlow {
    ...HeroGlow
  }
  ... on CosmosHeroArticleImage {
    ...HeroArticleImage
  }
  ... on CosmosHeroBravo {
    ...HeroBravo
  }
}
    ${HeroAlphaFragmentDoc}
${HeroGlowFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}`;
export const AssetSectionFragmentDoc = gql`
    fragment AssetSection on CosmosSectionAsset {
  __typename
  id
  config {
    ...SectionConfig
  }
  size
  sectionAsset: asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
}
    ${SectionConfigFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const AssetCarouselSectionFragmentDoc = gql`
    fragment AssetCarouselSection on CosmosSectionAssetCarousel {
  __typename
  id
  config {
    ...SectionConfig
  }
  assets {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
}
    ${SectionConfigFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const AssetGallerySectionFragmentDoc = gql`
    fragment AssetGallerySection on CosmosSectionAssetGallery {
  __typename
  id
  config {
    ...SectionConfig
  }
  assets {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${SectionConfigFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const BlogTagFragmentDoc = gql`
    fragment BlogTag on WfRefBlogTag {
  __typename
  id
  tagId
  label
}
    `;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategory on WfRefBlogCategory {
  __typename
  id
  categoryId
  categorySlug
  label
  pluralLabel
  badgeColor
  tag {
    ...BlogTag
  }
}
    ${BlogTagFragmentDoc}`;
export const BlogCardFragmentDoc = gql`
    fragment BlogCard on CosmosElementBlogCard {
  __typename
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  href
  category {
    ...BlogCategory
  }
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosIconButton
  }
  eyebrow
}
    ${CosmosAssetFragmentDoc}
${BlogCategoryFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const BlogCardsSectionFragmentDoc = gql`
    fragment BlogCardsSection on CosmosSectionBlogCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...BlogCard
  }
  maxSize
  cardGridFitToWidth
}
    ${SectionConfigFragmentDoc}
${BlogCardFragmentDoc}`;
export const BlobTableSectionFragmentDoc = gql`
    fragment BlobTableSection on CosmosSectionBlobTable {
  __typename
  id
  config {
    ...SectionConfig
  }
  environmentVariable
  limit
  variant
}
    ${SectionConfigFragmentDoc}`;
export const CosmosLinkFragmentDoc = gql`
    fragment CosmosLink on CosmosElementLink {
  label
  href
  icon
  iconPosition
}
    `;
export const CommunityCardFragmentFragmentDoc = gql`
    fragment CommunityCardFragment on CommunityCard {
  title
  description
  iconType
  iconGradient
  link {
    ...CosmosLink
  }
}
    ${CosmosLinkFragmentDoc}`;
export const CommunityResourceFragmentFragmentDoc = gql`
    fragment CommunityResourceFragment on CommunityResource {
  cards(first: 10) {
    ...CommunityCardFragment
  }
  title
  showMoreStr
  hideStr
}
    ${CommunityCardFragmentFragmentDoc}`;
export const CommunitySectionFragmentDoc = gql`
    fragment CommunitySection on CosmosSectionCommunity {
  __typename
  id
  config {
    ...SectionConfig
  }
  forumTitle
  forumButton {
    ...CosmosButton
  }
  resources {
    ...CommunityResourceFragment
  }
  application
  skipCommunityTable
}
    ${SectionConfigFragmentDoc}
${CosmosButtonFragmentDoc}
${CommunityResourceFragmentFragmentDoc}`;
export const ComplexCtaCardFragmentDoc = gql`
    fragment ComplexCtaCard on CosmosElementComplexCtaCard {
  icon
  title {
    ...CosmosRichText
  }
  desc
  button {
    ...CosmosButton
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const ComplexCtaCardsSectionFragmentDoc = gql`
    fragment ComplexCtaCardsSection on CosmosSectionComplexCtaCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards(first: 20) {
    ...ComplexCtaCard
  }
  bottomDescription {
    ...CosmosRichText
  }
  complexCtaVariant
}
    ${SectionConfigFragmentDoc}
${ComplexCtaCardFragmentDoc}
${CosmosRichTextFragmentDoc}`;
export const CosmosTagFragmentDoc = gql`
    fragment CosmosTag on CosmosElementTag {
  href
  label
}
    `;
export const CosmosImageFragmentDoc = gql`
    fragment CosmosImage on Asset {
  __typename
  id
  url
  width
  height
  mimeType
  altText
}
    `;
export const ContentLargeImageFragmentDoc = gql`
    fragment ContentLargeImage on CosmosSectionContentLargeImage {
  __typename
  id
  config {
    ...SectionConfig
  }
  eyebrow
  badges {
    ...CosmosTag
  }
  gradient
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
  blurredImage {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  flip
  verticallyCenter
}
    ${SectionConfigFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosImageFragmentDoc}`;
export const CruxLinkFragmentDoc = gql`
    fragment CruxLink on CosmosElementCruxLink {
  label
  href
  icon
  iconGradient
}
    `;
export const CruxSectionFragmentDoc = gql`
    fragment CruxSection on CosmosSectionCrux {
  __typename
  id
  config {
    ...SectionConfig
  }
  cruxLinks {
    ...CruxLink
  }
}
    ${SectionConfigFragmentDoc}
${CruxLinkFragmentDoc}`;
export const DividerSectionFragmentDoc = gql`
    fragment DividerSection on CosmosSectionDivider {
  __typename
  id
  edsBackgroundColor
  size
}
    `;
export const CosmosDownloadButtonFragmentDoc = gql`
    fragment CosmosDownloadButton on CosmosElementDownloadButton {
  __typename
  label
  variant
  windowsUrl
  macUrl
  mobileDisclaimer {
    ...CosmosRichText
  }
}
    ${CosmosRichTextFragmentDoc}`;
export const CosmosCtaRichTextFragmentDoc = gql`
    fragment CosmosCtaRichText on CosmosElementRichText {
  text {
    ...CosmosRichText
  }
}
    ${CosmosRichTextFragmentDoc}`;
export const DownloadCardCtaLinkFragmentDoc = gql`
    fragment DownloadCardCtaLink on CosmosElementLink {
  label
  href
  linkIcon: icon
  iconPosition
}
    `;
export const DownloadCardCtaFragmentDoc = gql`
    fragment DownloadCardCta on CosmosElementDownloadCardctaUnion {
  ... on CosmosElementButton {
    __typename
    ...CosmosButton
  }
  ... on CosmosElementDownloadButton {
    __typename
    ...CosmosDownloadButton
  }
  ... on CosmosElementIconButton {
    __typename
    ...CosmosIconButton
  }
  ... on CosmosElementRichText {
    __typename
    ...CosmosCtaRichText
  }
  ... on CosmosElementLink {
    __typename
    ...DownloadCardCtaLink
  }
}
    ${CosmosButtonFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}`;
export const DownloadCardFragmentDoc = gql`
    fragment DownloadCard on CosmosElementDownloadCard {
  titleIcon
  title {
    ...CosmosRichText
  }
  description {
    ...CosmosRichText
  }
  cta {
    ...DownloadCardCta
  }
}
    ${CosmosRichTextFragmentDoc}
${DownloadCardCtaFragmentDoc}`;
export const DownloadStepFragmentDoc = gql`
    fragment DownloadStep on CosmosElementDownloadStep {
  __typename
  gradient
  label
  content {
    ...DownloadCard
  }
}
    ${DownloadCardFragmentDoc}`;
export const DownloadCardsSectionFragmentDoc = gql`
    fragment DownloadCardsSection on CosmosSectionDownloadCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  steps {
    ...DownloadStep
  }
  footer {
    ...DownloadCard
  }
}
    ${SectionConfigFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}`;
export const DownloadableSectionFragmentDoc = gql`
    fragment DownloadableSection on CosmosSectionDownloadable {
  __typename
  id
  config {
    ...SectionConfig
  }
  instructions {
    __typename
    id
    section {
      ... on CosmosSectionDownloadCard {
        ...DownloadCardsSection
      }
    }
  }
  executables {
    ...DownloadCard
  }
  footer {
    ...DownloadCard
  }
}
    ${SectionConfigFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${DownloadCardFragmentDoc}`;
export const CosmosVideoEmbedFragmentDoc = gql`
    fragment CosmosVideoEmbed on CosmosElementVideoEmbed {
  __typename
  iframeSrc
  overlayImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  disableOverlay
  playButtonAriaLabel
  attribution
}
    ${CosmosAssetFragmentDoc}`;
export const EmbedSectionFragmentDoc = gql`
    fragment EmbedSection on CosmosSectionEmbed {
  __typename
  id
  config {
    ...SectionConfig
  }
  size
  embed {
    ...CosmosVideoEmbed
  }
}
    ${SectionConfigFragmentDoc}
${CosmosVideoEmbedFragmentDoc}`;
export const EventsTableRowFragmentDoc = gql`
    fragment EventsTableRow on CosmosElementEventsTableRow {
  id
  title
  badgeLabel
  timeAndDate
  endTimeAndDate
  timeZone
  timeAndDateFormat
  location
  description {
    ...CosmosRichText
  }
  href
}
    ${CosmosRichTextFragmentDoc}`;
export const EventsTableSectionFragmentDoc = gql`
    fragment EventsTableSection on CosmosSectionEventsTable {
  __typename
  id
  config {
    ...SectionConfig
  }
  blurredImage {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 400}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  upcomingTabLabel
  pastTabLabel
  titleColumnLabel
  locationColumnLabel
  detailsColumnLabel
  events {
    ...EventsTableRow
  }
}
    ${SectionConfigFragmentDoc}
${CosmosImageFragmentDoc}
${EventsTableRowFragmentDoc}`;
export const FaqItemElementFragmentDoc = gql`
    fragment FAQItemElement on CosmosElementFAQItem {
  __typename
  id
  question {
    ...CosmosRichText
  }
  answer {
    ...CosmosRichText
  }
  defaultOpen
  anchorLinkId
}
    ${CosmosRichTextFragmentDoc}`;
export const RefFaqItemElementFragmentDoc = gql`
    fragment RefFAQItemElement on CosmosReferenceFAQItem {
  id
  question
  answer
  anchorLinkId
}
    `;
export const FaqSectionFragmentDoc = gql`
    fragment FAQSection on CosmosSectionFaq {
  __typename
  id
  config {
    ...SectionConfig
  }
  title {
    ...CosmosRichText
  }
  items(first: 25) {
    ...FAQItemElement
  }
  refFaqItems(first: 25) {
    ...RefFAQItemElement
  }
  firstItemDefaultOpen
  modButtons {
    ...CosmosModButton
  }
  faqButtonsPosition
  faqButtons {
    ...CosmosIconButton
  }
}
    ${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const FeatureCardFragmentDoc = gql`
    fragment FeatureCard on CosmosElementFeatureCard {
  __typename
  img {
    __typename
    url(
      transformation: {image: {resize: {width: 540}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
    width
    height
  }
  imageLabel
  label
  href
}
    `;
export const FeatureCardsSectionFragmentDoc = gql`
    fragment FeatureCardsSection on CosmosSectionFeatureCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  tagListTitle
  tags {
    ...CosmosTag
  }
  cards(first: 20) {
    ...FeatureCard
  }
}
    ${SectionConfigFragmentDoc}
${CosmosTagFragmentDoc}
${FeatureCardFragmentDoc}`;
export const LinkListItemFragmentDoc = gql`
    fragment LinkListItem on CosmosElementLink {
  id
  href
  label
  iconPosition
  icon
}
    `;
export const FeaturePanelFragmentDoc = gql`
    fragment FeaturePanel on CosmosElementGameDevFeatureCard {
  eyebrowBadges {
    ...CosmosTag
  }
  eyebrow
  title {
    ...CosmosRichText
  }
  gradient
  desc
  links {
    ...LinkListItem
  }
  linksAsTags
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  flip
}
    ${CosmosTagFragmentDoc}
${CosmosRichTextFragmentDoc}
${LinkListItemFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const FeaturePanelsSectionFragmentDoc = gql`
    fragment FeaturePanelsSection on CosmosSectionGameDevFeatureCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...FeaturePanel
  }
  disableCardBg
  verticallyCenter
  buttons {
    ...CosmosButton
  }
}
    ${SectionConfigFragmentDoc}
${FeaturePanelFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const AccordionFeatureCardFragmentDoc = gql`
    fragment AccordionFeatureCard on CosmosElementAccordionFeatureCard {
  title {
    ...CosmosRichText
  }
  cards(first: 20) {
    ...FeaturePanel
  }
  defaultOpen
  anchorLinkId
}
    ${CosmosRichTextFragmentDoc}
${FeaturePanelFragmentDoc}`;
export const AccordionFeatureCardsSectionFragmentDoc = gql`
    fragment AccordionFeatureCardsSection on CosmosSectionAccordionFeatureCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  items(first: 20) {
    ...AccordionFeatureCard
  }
}
    ${SectionConfigFragmentDoc}
${AccordionFeatureCardFragmentDoc}`;
export const AccordionTierFeatureCardFragmentDoc = gql`
    fragment AccordionTierFeatureCard on CosmosElementAccordionTierFeatureCard {
  __typename
  id
  title {
    ...CosmosRichText
  }
  desc
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 600}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  buttons {
    ...CosmosModButton
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const AccordionTierCtaCardFragmentDoc = gql`
    fragment AccordionTierCtaCard on CosmosElementAccordionTierCtaCard {
  __typename
  id
  title {
    ...CosmosRichText
  }
  desc
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  buttons {
    ...CosmosModButton
  }
  gradient
}
    ${CosmosRichTextFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const AccordionTierCardFragmentDoc = gql`
    fragment AccordionTierCard on CosmosElementAccordionTierCard {
  __typename
  id
  title {
    ...CosmosRichText
  }
  tag
  gradient
  defaultOpen
  anchorLinkId
  items(first: 20) {
    ... on CosmosElementAccordionTierFeatureCard {
      ...AccordionTierFeatureCard
    }
    ... on CosmosElementAccordionTierCtaCard {
      ...AccordionTierCtaCard
    }
  }
}
    ${CosmosRichTextFragmentDoc}
${AccordionTierFeatureCardFragmentDoc}
${AccordionTierCtaCardFragmentDoc}`;
export const AccordionTierCardsSectionFragmentDoc = gql`
    fragment AccordionTierCardsSection on CosmosSectionAccordionTierCards {
  __typename
  id
  config {
    ...SectionConfig
  }
  items(first: 10) {
    ...AccordionTierCard
  }
}
    ${SectionConfigFragmentDoc}
${AccordionTierCardFragmentDoc}`;
export const CosmosElementLearnDocumentationCardFragmentDoc = gql`
    fragment CosmosElementLearnDocumentationCard on CosmosElementLearnDocumentationCard {
  __typename
  description {
    ...CosmosRichText
  }
  links(first: 10) {
    ...CosmosLink
  }
  cta {
    ...CosmosButton
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosLinkFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const CosmosElementLearnImageCardSourceFragmentDoc = gql`
    fragment CosmosElementLearnImageCardSource on CosmosElementLearnImageCardSource {
  author
  timestamp
  ago
}
    `;
export const CosmosElementLearnImageCardFragmentDoc = gql`
    fragment CosmosElementLearnImageCard on CosmosElementLearnImageCard {
  __typename
  title {
    ...CosmosRichText
  }
  desc
  imageLabel
  url
  source {
    ...CosmosElementLearnImageCardSource
  }
  img {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  industries
}
    ${CosmosRichTextFragmentDoc}
${CosmosElementLearnImageCardSourceFragmentDoc}
${CosmosImageFragmentDoc}`;
export const ElementLearnCategoryFragmentDoc = gql`
    fragment ElementLearnCategory on ElementLearnCategory {
  __typename
  categoryType
  desc
  description {
    ...CosmosRichText
  }
  title {
    ...CosmosRichText
  }
  titleHref
  remoteLearn {
    id
    learnSearch(
      industries: "games"
      types: "tutorial"
      applicationFamily: "unreal_engine"
    )
  }
  cards(first: 20) {
    ...CosmosElementLearnDocumentationCard
    ...CosmosElementLearnImageCard
  }
  cardCount
  cta {
    ...CosmosButton
  }
  remoteCards(first: 20) {
    id
    industries
    type
    data
  }
  squareImage
}
    ${CosmosRichTextFragmentDoc}
${CosmosElementLearnDocumentationCardFragmentDoc}
${CosmosElementLearnImageCardFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const LearnSectionFragmentDoc = gql`
    fragment LearnSection on CosmosSectionLearn {
  __typename
  id
  config {
    ...SectionConfig
  }
  tabs {
    label
    value
  }
  categories(first: 10) {
    ...ElementLearnCategory
  }
  applicationFamily
}
    ${SectionConfigFragmentDoc}
${ElementLearnCategoryFragmentDoc}`;
export const LogoFragmentDoc = gql`
    fragment Logo on CosmosElementLogo {
  image {
    ...CosmosImage
  }
  href
  title
  landscape
}
    ${CosmosImageFragmentDoc}`;
export const LogoListSectionFragmentDoc = gql`
    fragment LogoListSection on CosmosSectionLogoList {
  __typename
  id
  config {
    ...SectionConfig
  }
  logos(first: 30) {
    ...Logo
  }
  disableMarquee
}
    ${SectionConfigFragmentDoc}
${LogoFragmentDoc}`;
export const LogoMultiCardFragmentDoc = gql`
    fragment LogoMultiCard on CosmosElementLogoMultiCard {
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  desc
  href
}
    ${CosmosRichTextFragmentDoc}`;
export const LogoMultiCardsSectionFragmentDoc = gql`
    fragment LogoMultiCardsSection on CosmosSectionLogoMultiCard {
  __typename
  config {
    ...SectionConfig
  }
  id
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ... on CosmosElementButton {
      ...CosmosButton
    }
    ... on CosmosElementIconButton {
      ...CosmosIconButton
    }
  }
  links {
    ...CosmosLink
  }
  cards {
    ...LogoMultiCard
  }
}
    ${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosLinkFragmentDoc}
${LogoMultiCardFragmentDoc}`;
export const NewsAuthorTagFragmentDoc = gql`
    fragment NewsAuthorTag on CosmosElementImageTag {
  __typename
  image {
    __typename
    url(transformation: {image: {resize: {width: 20}, quality: {value: 90}}})
    altText
  }
  href
  label
}
    `;
export const NewsCardFragmentDoc = gql`
    fragment NewsCard on CosmosElementNewsCard {
  __typename
  image {
    __typename
    url(
      transformation: {image: {resize: {width: 256}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
    altText
  }
  href
  title {
    ...CosmosRichText
  }
  description {
    ...CosmosRichText
  }
  tag {
    ...CosmosTag
  }
  authorTag {
    ...NewsAuthorTag
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosTagFragmentDoc}
${NewsAuthorTagFragmentDoc}`;
export const NewsCardsSectionFragmentDoc = gql`
    fragment NewsCardsSection on CosmosSectionNewsCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...NewsCard
  }
  maxCount
}
    ${SectionConfigFragmentDoc}
${NewsCardFragmentDoc}`;
export const NewsMediaCardFragmentDoc = gql`
    fragment NewsMediaCard on CosmosElementNewsMediaCard {
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 740}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  href
  title {
    ...CosmosRichText
  }
  desc
  author
  modButtons {
    ...CosmosModButton
  }
}
    ${CosmosAssetFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const NewsMediaCardsSectionFragmentDoc = gql`
    fragment NewsMediaCardsSection on CosmosSectionNewsMediaCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...NewsMediaCard
  }
}
    ${SectionConfigFragmentDoc}
${NewsMediaCardFragmentDoc}`;
export const CheckListItemFragmentDoc = gql`
    fragment CheckListItem on CosmosElementCheckListItem {
  label
  icon
}
    `;
export const LicenseTopCardFragmentDoc = gql`
    fragment LicenseTopCard on CosmosElementLicenseTopCard {
  __typename
  title
  bullets {
    ...CosmosRichText
  }
  checkList {
    ...CheckListItem
  }
  buttons {
    ...CosmosButton
  }
}
    ${CosmosRichTextFragmentDoc}
${CheckListItemFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const LicenseCollapsedCardFragmentDoc = gql`
    fragment LicenseCollapsedCard on CosmosElementLicenseCollapsedCard {
  icon
  title
  description {
    ...CosmosRichText
  }
}
    ${CosmosRichTextFragmentDoc}`;
export const LicensesCollapsedSectionFragmentDoc = gql`
    fragment LicensesCollapsedSection on CosmosSectionLicensesCollapsed {
  __typename
  id
  config {
    ...SectionConfig
  }
  freeHeading
  topCard {
    ...LicenseTopCard
  }
  collapsedCardsHeading
  collapsedCards {
    ...LicenseCollapsedCard
  }
  collapsedCta {
    ...CosmosLink
  }
}
    ${SectionConfigFragmentDoc}
${LicenseTopCardFragmentDoc}
${LicenseCollapsedCardFragmentDoc}
${CosmosLinkFragmentDoc}`;
export const RichTextSectionFragmentDoc = gql`
    fragment RichTextSection on CosmosSectionRichText {
  __typename
  id
  config {
    ...SectionConfig
  }
  content {
    ...CosmosRichText
  }
  wide
  centered
  centeredButton
  buttons {
    ...CosmosButton
  }
}
    ${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const GeminiLinkFragmentDoc = gql`
    fragment GeminiLink on CosmosElementGeminiLink {
  id
  edsIcon: icon
  label
  href
  endIcon
}
    `;
export const GeminiCardFragmentDoc = gql`
    fragment GeminiCard on CosmosElementGeminiCard {
  id
  eyebrow
  heading {
    ...CosmosRichText
  }
  badge {
    label
    href
  }
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  cardHref
  desc
  links(first: 10) {
    ...GeminiLink
  }
  buttons(first: 10) {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  background
  anchorLinkId
}
    ${CosmosRichTextFragmentDoc}
${GeminiLinkFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const GeminiCardsSectionFragmentDoc = gql`
    fragment GeminiCardsSection on CosmosSectionGeminiCard {
  __typename
  id
  logoImage {
    ...CosmosAsset
  }
  config {
    ...SectionConfig
  }
  title {
    ...CosmosRichText
  }
  gradient
  desc
  cards(first: 25) {
    ...GeminiCard
  }
  cardsVariant
}
    ${CosmosAssetFragmentDoc}
${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${GeminiCardFragmentDoc}`;
export const HydrusLinkFragmentDoc = gql`
    fragment HydrusLink on CosmosElementHydrusLink {
  id
  icon
  label
  href
  badgeLabel
}
    `;
export const HydrusColumnFragmentDoc = gql`
    fragment HydrusColumn on CosmosElementHydrusColumn {
  id
  title
  titleHref
  links(first: 10) {
    ...HydrusLink
  }
}
    ${HydrusLinkFragmentDoc}`;
export const HydrusColumnListSectionFragmentDoc = gql`
    fragment HydrusColumnListSection on CosmosSectionHydrusColumnList {
  __typename
  id
  config {
    ...SectionConfig
  }
  columns(first: 4) {
    ...HydrusColumn
  }
}
    ${SectionConfigFragmentDoc}
${HydrusColumnFragmentDoc}`;
export const CosmosAvatarFragmentDoc = gql`
    fragment CosmosAvatar on CosmosElementAvatar {
  href
  label
  imageSrc
  imageAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 100}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  color
}
    ${CosmosAssetFragmentDoc}`;
export const DelphinusCardFragmentDoc = gql`
    fragment DelphinusCard on CosmosElementDelphinusCard {
  id
  preHeading
  icon
  iconGradient
  title
  titleHref
  desc
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  assetPosition
  badge {
    label
    href
  }
  avatar {
    ...CosmosAvatar
  }
}
    ${CosmosAssetFragmentDoc}
${CosmosAvatarFragmentDoc}`;
export const DelphinusCardsGridSectionFragmentDoc = gql`
    fragment DelphinusCardsGridSection on CosmosSectionDelphinusCardsGrid {
  __typename
  id
  config {
    ...SectionConfig
  }
  grid(first: 9) {
    ...DelphinusCard
  }
}
    ${SectionConfigFragmentDoc}
${DelphinusCardFragmentDoc}`;
export const IndustryFragmentDoc = gql`
    fragment Industry on CosmosElementIndustry {
  salesForceId
  dataRouterId
  label
}
    `;
export const IndustryListFragmentDoc = gql`
    fragment IndustryList on CosmosRefIndustryList {
  industries {
    ...Industry
  }
}
    ${IndustryFragmentDoc}`;
export const NewsletterSignupFragmentDoc = gql`
    fragment NewsletterSignup on CosmosSectionNewsletterSignup {
  id
  __typename
  signUpLabel
  successTitle
  successDescription
  industryPlaceholder
  industriesRef {
    ...IndustryList
  }
}
    ${IndustryListFragmentDoc}`;
export const SimpleCtaSectionFragmentDoc = gql`
    fragment SimpleCtaSection on CosmosSectionSimpleCta {
  __typename
  id
  style
  simpleCtaVariant: variant
  gradient
  title {
    ...CosmosRichText
  }
  icon
  eyebrow
  leftDesc
  desc
  buttons {
    ...CosmosIconButton
  }
  backgroundImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1024}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const SlimContactCardFragmentDoc = gql`
    fragment SlimContactCard on CosmosElementLicenseContactCard {
  slimContactCardDesc: description {
    ...CosmosRichText
  }
  buttons {
    ...CosmosIconButton
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const SlimContactCardsSectionFragmentDoc = gql`
    fragment SlimContactCardsSection on CosmosSectionSlimContactCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards(first: 20) {
    ...SlimContactCard
  }
  forceShowPaddingTop
  forceShowPaddingBottom
}
    ${SectionConfigFragmentDoc}
${SlimContactCardFragmentDoc}`;
export const SpeakerCardFragmentDoc = gql`
    fragment SpeakerCard on CosmosElementSpeakerCard {
  id
  icon
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  title
  company
  desc
}
    ${CosmosAssetFragmentDoc}`;
export const SpeakerCardsSectionFragmentDoc = gql`
    fragment SpeakerCardsSection on CosmosSectionSpeakerCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  speakers(first: 20) {
    ...SpeakerCard
  }
}
    ${SectionConfigFragmentDoc}
${SpeakerCardFragmentDoc}`;
export const LatestNewsSectionFragmentDoc = gql`
    fragment LatestNewsSection on CosmosSectionLatestNews {
  __typename
  id
  config {
    ...SectionConfig
  }
  wfRefBlogTags {
    ...BlogTag
  }
  preserveStickySort
  cosmosPageBlogDetails {
    slug
  }
  latestNewsVariant: variant
  featuredLabel
  feedBrand
  disableCategoryPills
}
    ${SectionConfigFragmentDoc}
${BlogTagFragmentDoc}`;
export const NumberCalloutFragmentDoc = gql`
    fragment NumberCallout on CosmosElementNumberCallout {
  number
  numberDisplay
  label
}
    `;
export const NumberCalloutSectionFragmentDoc = gql`
    fragment NumberCalloutSection on CosmosSectionNumberCallout {
  __typename
  id
  config {
    ...SectionConfig
  }
  icon
  iconGradient
  eyebrow
  title {
    ...CosmosRichText
  }
  titleGradient
  desc
  numberCalloutVariant: variant
  callouts {
    ...NumberCallout
  }
  timeAndDate
  buttons {
    ...CosmosIconButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  flip
  verticallyCenter
}
    ${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${NumberCalloutFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const TabbedFullWidthAssetItemFragmentDoc = gql`
    fragment TabbedFullWidthAssetItem on CosmosElementTabbedFullWidthAssetItem {
  tabLabel
  eyebrow
  title {
    html
    text
  }
  gradient
  desc
  buttons {
    ...CosmosIconButton
  }
  heroAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const TabbedFullWidthAssetSectionFragmentDoc = gql`
    fragment TabbedFullWidthAssetSection on CosmosSectionTabbedFullWidthAsset {
  __typename
  id
  tabs {
    ...TabbedFullWidthAssetItem
  }
}
    ${TabbedFullWidthAssetItemFragmentDoc}`;
export const TabbedBlogCardsItemFragmentDoc = gql`
    fragment TabbedBlogCardsItem on CosmosElementTabbedBlogCardsItem {
  __typename
  id
  tabLabel
  title {
    ...CosmosRichText
  }
  description
  buttons {
    ...CosmosButton
  }
  backgroundAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  cards {
    ...BlogCard
  }
  featuredCards {
    ...BlogCard
  }
  cardGridFitToWidth
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosAssetFragmentDoc}
${BlogCardFragmentDoc}`;
export const TabbedBlogCardsSectionFragmentDoc = gql`
    fragment TabbedBlogCardsSection on CosmosSectionTabbedBlogCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  tabs {
    ...TabbedBlogCardsItem
  }
}
    ${SectionConfigFragmentDoc}
${TabbedBlogCardsItemFragmentDoc}`;
export const TabbedContentImageItemFragmentDoc = gql`
    fragment TabbedContentImageItem on CosmosElementTabbedContentImageItem {
  __typename
  id
  tabLabel
  gradient
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  blurredImage {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  flip
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosImageFragmentDoc}`;
export const TabbedContentImageSectionFragmentDoc = gql`
    fragment TabbedContentImageSection on CosmosSectionTabbedContentImage {
  __typename
  id
  config {
    ...SectionConfig
  }
  tabs {
    ...TabbedContentImageItem
  }
}
    ${SectionConfigFragmentDoc}
${TabbedContentImageItemFragmentDoc}`;
export const FaqTabElementFragmentDoc = gql`
    fragment FAQTabElement on CosmosElementFaqTab {
  __typename
  id
  title
  items(first: 25) {
    ...FAQItemElement
  }
  refFaqItems(first: 25) {
    ...RefFAQItemElement
  }
  firstItemDefaultOpen
  anchorLinkId
}
    ${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}`;
export const FaqSearchSectionFragmentDoc = gql`
    fragment FAQSearchSection on CosmosSectionFaqSearch {
  __typename
  id
  config {
    ...SectionConfig
  }
  title {
    ...CosmosRichText
  }
  desc
  faqTabs(first: 25) {
    ...FAQTabElement
  }
  modButtons {
    ...CosmosModButton
  }
  faqButtonsPosition
}
    ${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${FaqTabElementFragmentDoc}
${CosmosModButtonFragmentDoc}`;
export const CkRichTextSectionFragmentDoc = gql`
    fragment CkRichTextSection on CosmosSectionCkRichText {
  __typename
  id
  config {
    ...SectionConfig
  }
  ckContent: content
  wide
  centered
  centeredButton
  buttons {
    ...CosmosButton
  }
}
    ${SectionConfigFragmentDoc}
${CosmosButtonFragmentDoc}`;
export const AriesCardFragmentDoc = gql`
    fragment AriesCard on CosmosElementAriesCard {
  id
  icon
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1680}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  icon
  fullWidth
}
    ${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const AriesCardsSectionFragmentDoc = gql`
    fragment AriesCardsSection on CosmosSectionAriesCards {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...AriesCard
  }
}
    ${SectionConfigFragmentDoc}
${AriesCardFragmentDoc}`;
export const ContentSliderAssetFragmentDoc = gql`
    fragment ContentSliderAsset on CosmosSectionContentSliderAsset {
  __typename
  id
  config {
    ...SectionConfig
  }
  eyebrow
  badges {
    ...CosmosTag
  }
  gradient
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  assets(first: 10) {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  flip
  verticallyCenter
}
    ${SectionConfigFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosQuoteFragmentDoc = gql`
    fragment CosmosQuote on CosmosElementQuote {
  __typename
  quote
  source
  description
  iconGradient
}
    `;
export const QuoteSectionFragmentDoc = gql`
    fragment QuoteSection on CosmosSectionQuote {
  __typename
  id
  config {
    ...SectionConfig
  }
  quotes(first: 20) {
    ...CosmosQuote
  }
}
    ${SectionConfigFragmentDoc}
${CosmosQuoteFragmentDoc}`;
export const UtCardFragmentDoc = gql`
    fragment UtCard on CosmosElementUtCard {
  cardImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {height: 600}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  logoImage {
    ...CosmosAsset
  }
  href
  label
}
    ${CosmosAssetFragmentDoc}`;
export const UtCardSectionFragmentDoc = gql`
    fragment UtCardSection on CosmosSectionUtCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...UtCard
  }
}
    ${SectionConfigFragmentDoc}
${UtCardFragmentDoc}`;
export const ResellerCardFragmentDoc = gql`
    fragment ResellerCard on CosmosElementResellerCard {
  __typename
  id
  name
  website
  email
  street
  postalCode
  city
  region
  phone
  continents
  location {
    __typename
    latitude
    longitude
  }
}
    `;
export const ResellersSearchSectionFragmentDoc = gql`
    fragment ResellersSearchSection on CosmosSectionResellersSearch {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards(first: 100) {
    ...ResellerCard
  }
  cards2(first: 50) {
    ...ResellerCard
  }
  cards3(first: 50) {
    ...ResellerCard
  }
  cards4(first: 50) {
    ...ResellerCard
  }
  viewLocationLabel
  searchLabel
  noResultsLabel
  locationLinkTemplate
  blurredBackgroundImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1680}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${SectionConfigFragmentDoc}
${ResellerCardFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPluginDownloadDetailFragmentDoc = gql`
    fragment CosmosPluginDownloadDetail on CosmosElementPluginDownloadDetail {
  __typename
  operatingSystem
  downloadUrl
  dateLastUpdated
  infoContent
  releaseNotesUrl
  tpsNoticesUrl
  sizeInBytes
}
    `;
export const PluginListItemFragmentDoc = gql`
    fragment PluginListItem on CosmosElementPluginListItem {
  __typename
  id
  title
  desc
  learnMoreUrl
  compatibilityTags
  downloads {
    ...CosmosPluginDownloadDetail
  }
  extraButtons {
    ...CosmosIconButton
  }
}
    ${CosmosPluginDownloadDetailFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const PluginListTableSectionFragmentDoc = gql`
    fragment PluginListTableSection on CosmosSectionPluginListTable {
  __typename
  id
  config {
    ...SectionConfig
  }
  tableItems: items {
    ...PluginListItem
  }
}
    ${SectionConfigFragmentDoc}
${PluginListItemFragmentDoc}`;
export const DevelopersListSectionFragmentDoc = gql`
    fragment DevelopersListSection on CosmosSectionDevelopersList {
  __typename
  id
  config {
    ...SectionConfig
  }
  developersTsv {
    url
    mimeType
  }
  itemsPerPage
  tableHeading
}
    ${SectionConfigFragmentDoc}`;
export const OrionCardFragmentDoc = gql`
    fragment OrionCard on CosmosElementOrionCard {
  __typename
  id
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  desc
  cardHref
  anchorLinkId
}
    ${CosmosRichTextFragmentDoc}`;
export const OrionCardsSectionFragmentDoc = gql`
    fragment OrionCardsSection on CosmosSectionOrionCards {
  __typename
  id
  config {
    ...SectionConfig
  }
  eyebrow
  title {
    ...CosmosRichText
  }
  titleGradient
  desc
  modButtons {
    ...CosmosModButton
  }
  cards(first: 3) {
    ...OrionCard
  }
}
    ${SectionConfigFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosModButtonFragmentDoc}
${OrionCardFragmentDoc}`;
export const PageSectionsFragmentDoc = gql`
    fragment PageSections on CosmosReferenceSectionsectionUnion {
  ... on CosmosSectionAsset {
    ...AssetSection
  }
  ... on CosmosSectionAssetCarousel {
    ...AssetCarouselSection
  }
  ... on CosmosSectionAssetGallery {
    ...AssetGallerySection
  }
  ... on CosmosSectionBlogCard {
    ...BlogCardsSection
  }
  ... on CosmosSectionBlobTable {
    ...BlobTableSection
  }
  ... on CosmosSectionCommunity {
    ...CommunitySection
  }
  ... on CosmosSectionComplexCtaCard {
    ...ComplexCtaCardsSection
  }
  ... on CosmosSectionContentLargeImage {
    ...ContentLargeImage
  }
  ... on CosmosSectionCrux {
    ...CruxSection
  }
  ... on CosmosSectionDivider {
    ...DividerSection
  }
  ... on CosmosSectionDownloadable {
    ...DownloadableSection
  }
  ... on CosmosSectionDownloadCard {
    ...DownloadCardsSection
  }
  ... on CosmosSectionEmbed {
    ...EmbedSection
  }
  ... on CosmosSectionEventsTable {
    ...EventsTableSection
  }
  ... on CosmosSectionFaq {
    ...FAQSection
  }
  ... on CosmosSectionFeatureCard {
    ...FeatureCardsSection
  }
  ... on CosmosSectionGameDevFeatureCard {
    ...FeaturePanelsSection
  }
  ... on CosmosSectionAccordionFeatureCard {
    ...AccordionFeatureCardsSection
  }
  ... on CosmosSectionAccordionTierCards {
    ...AccordionTierCardsSection
  }
  ... on CosmosSectionLearn {
    ...LearnSection
  }
  ... on CosmosSectionLogoList {
    ...LogoListSection
  }
  ... on CosmosSectionLogoMultiCard {
    ...LogoMultiCardsSection
  }
  ... on CosmosSectionNewsCard {
    ...NewsCardsSection
  }
  ... on CosmosSectionNewsMediaCard {
    ...NewsMediaCardsSection
  }
  ... on CosmosSectionLicensesCollapsed {
    ...LicensesCollapsedSection
  }
  ... on CosmosSectionRichText {
    ...RichTextSection
  }
  ... on CosmosSectionGeminiCard {
    ...GeminiCardsSection
  }
  ... on CosmosSectionHydrusColumnList {
    ...HydrusColumnListSection
  }
  ... on CosmosSectionDelphinusCardsGrid {
    ...DelphinusCardsGridSection
  }
  ... on CosmosSectionNewsletterSignup {
    ...NewsletterSignup
  }
  ... on CosmosSectionSimpleCta {
    ...SimpleCtaSection
  }
  ... on CosmosSectionSlimContactCard {
    ...SlimContactCardsSection
  }
  ... on CosmosSectionSpeakerCard {
    ...SpeakerCardsSection
  }
  ... on CosmosSectionLatestNews {
    ...LatestNewsSection
  }
  ... on CosmosSectionNumberCallout {
    ...NumberCalloutSection
  }
  ... on CosmosSectionTabbedFullWidthAsset {
    ...TabbedFullWidthAssetSection
  }
  ... on CosmosSectionTabbedBlogCard {
    ...TabbedBlogCardsSection
  }
  ... on CosmosSectionTabbedContentImage {
    ...TabbedContentImageSection
  }
  ... on CosmosSectionFaqSearch {
    ...FAQSearchSection
  }
  ... on CosmosSectionCkRichText {
    ...CkRichTextSection
  }
  ... on CosmosSectionAriesCards {
    ...AriesCardsSection
  }
  ... on CosmosSectionContentSliderAsset {
    ...ContentSliderAsset
  }
  ... on CosmosSectionQuote {
    ...QuoteSection
  }
  ... on CosmosSectionUtCard {
    ...UtCardSection
  }
  ... on CosmosSectionResellersSearch {
    ...ResellersSearchSection
  }
  ... on CosmosSectionPluginListTable {
    ...PluginListTableSection
  }
  ... on CosmosSectionDevelopersList {
    ...DevelopersListSection
  }
  ... on CosmosSectionOrionCards {
    ...OrionCardsSection
  }
}
    ${AssetSectionFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${AssetGallerySectionFragmentDoc}
${BlogCardsSectionFragmentDoc}
${BlobTableSectionFragmentDoc}
${CommunitySectionFragmentDoc}
${ComplexCtaCardsSectionFragmentDoc}
${ContentLargeImageFragmentDoc}
${CruxSectionFragmentDoc}
${DividerSectionFragmentDoc}
${DownloadableSectionFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${EmbedSectionFragmentDoc}
${EventsTableSectionFragmentDoc}
${FaqSectionFragmentDoc}
${FeatureCardsSectionFragmentDoc}
${FeaturePanelsSectionFragmentDoc}
${AccordionFeatureCardsSectionFragmentDoc}
${AccordionTierCardsSectionFragmentDoc}
${LearnSectionFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${NewsCardsSectionFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${LicensesCollapsedSectionFragmentDoc}
${RichTextSectionFragmentDoc}
${GeminiCardsSectionFragmentDoc}
${HydrusColumnListSectionFragmentDoc}
${DelphinusCardsGridSectionFragmentDoc}
${NewsletterSignupFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${SlimContactCardsSectionFragmentDoc}
${SpeakerCardsSectionFragmentDoc}
${LatestNewsSectionFragmentDoc}
${NumberCalloutSectionFragmentDoc}
${TabbedFullWidthAssetSectionFragmentDoc}
${TabbedBlogCardsSectionFragmentDoc}
${TabbedContentImageSectionFragmentDoc}
${FaqSearchSectionFragmentDoc}
${CkRichTextSectionFragmentDoc}
${AriesCardsSectionFragmentDoc}
${ContentSliderAssetFragmentDoc}
${QuoteSectionFragmentDoc}
${UtCardSectionFragmentDoc}
${ResellersSearchSectionFragmentDoc}
${PluginListTableSectionFragmentDoc}
${DevelopersListSectionFragmentDoc}
${OrionCardsSectionFragmentDoc}`;
export const RefSectionsFragmentDoc = gql`
    fragment RefSections on CosmosReferenceSection {
  __typename
  id
  section {
    ...PageSections
  }
}
    ${PageSectionsFragmentDoc}`;
export const CosmosPageAgreementFragmentDoc = gql`
    fragment CosmosPageAgreement on CosmosPageAgreement {
  ...CosmosPageAgreementCore
  hero {
    ...PageHeroes
  }
  refSections(first: 30) {
    ...RefSections
  }
  agreementDetails {
    ...AgreementDetails
  }
}
    ${CosmosPageAgreementCoreFragmentDoc}
${PageHeroesFragmentDoc}
${RefSectionsFragmentDoc}
${AgreementDetailsFragmentDoc}`;
export const BlogAuthorTagFragmentDoc = gql`
    fragment BlogAuthorTag on CosmosElementImageTag {
  __typename
  image {
    __typename
    url(transformation: {image: {resize: {width: 20}, quality: {value: 90}}})
    altText
  }
  href
  label
}
    `;
export const BlogConfigFragmentDoc = gql`
    fragment BlogConfig on CosmosConfigBlog {
  __typename
  sticky
  blogLandingCard {
    ...BlogCard
  }
  publicationDate
  authorTag {
    ...BlogAuthorTag
  }
  tags(first: 30) {
    ...BlogTag
  }
  categories(first: 30) {
    ...BlogCategory
  }
}
    ${BlogCardFragmentDoc}
${BlogAuthorTagFragmentDoc}
${BlogTagFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const CosmosGitHubGistFragmentDoc = gql`
    fragment CosmosGitHubGist on CosmosElementGithubGist {
  __typename
  username
  gistId
  file
}
    `;
export const CosmosEdsIconLinkFragmentDoc = gql`
    fragment CosmosEdsIconLink on CosmosElementEdsIconLink {
  ariaLabel
  href
  icon
}
    `;
export const CosmosIconLinkGroupFragmentDoc = gql`
    fragment CosmosIconLinkGroup on CosmosElementIconLinkGroup {
  __typename
  id
  description
  edsIconLinks {
    ...CosmosEdsIconLink
  }
}
    ${CosmosEdsIconLinkFragmentDoc}`;
export const CosmosInterviewFragmentDoc = gql`
    fragment CosmosInterview on CosmosElementInterview {
  __typename
  interviewee
  questions(first: 25) {
    question
    answer
  }
}
    `;
export const CosmosCompareFragmentDoc = gql`
    fragment CosmosCompare on CosmosElementCompare {
  __typename
  leftImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  rightImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
  attribution
}
    ${CosmosAssetFragmentDoc}`;
export const CosmosUserProfileFragmentDoc = gql`
    fragment CosmosUserProfile on CosmosElementUserProfile {
  __typename
  avatar {
    ...CosmosAvatar
    imageAsset {
      ...CosmosAsset
      optUrlMd: url(
        transformation: {image: {resize: {width: 350}, quality: {value: 90}}, document: {output: {format: autoImage}}}
      )
    }
  }
  variant
  logoImage {
    ...CosmosAsset
  }
  titleText: title
  desc
  button {
    ...CosmosIconButton
  }
}
    ${CosmosAvatarFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const CosmosCalloutCardFragmentDoc = gql`
    fragment CosmosCalloutCard on CosmosElementCalloutCard {
  __typename
  icon
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosIconButton
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const CosmosTitleAndDescFragmentDoc = gql`
    fragment CosmosTitleAndDesc on CosmosElementTitleAndDesc {
  __typename
  title {
    ...CosmosRichText
  }
  desc
}
    ${CosmosRichTextFragmentDoc}`;
export const ArticleComponentsFragmentDoc = gql`
    fragment ArticleComponents on CosmosPageBlogDetailarticleComponentsUnion {
  __typename
  ... on CosmosElementAsset {
    __typename
    articleComponentAsset: asset {
      ...CosmosAsset
      optUrl: url(
        transformation: {image: {resize: {width: 1200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
      )
    }
    caption
  }
  ... on CosmosElementButtonList {
    __typename
    buttons {
      ...CosmosButton
    }
  }
  ... on CosmosElementCkEditorText {
    __typename
    ckText
  }
  ... on CosmosElementGithubGist {
    ...CosmosGitHubGist
  }
  ... on CosmosElementIconLinkGroup {
    ...CosmosIconLinkGroup
  }
  ... on CosmosElementInterview {
    ...CosmosInterview
  }
  ... on CosmosElementRichText {
    __typename
    text {
      ...CosmosRichText
    }
  }
  ... on CosmosElementLicenseContactCard {
    ...SlimContactCard
  }
  ... on CosmosElementSectionHeading {
    ...SectionHeading
  }
  ... on CosmosElementVideoEmbed {
    ...CosmosVideoEmbed
  }
  ... on CosmosSectionAssetCarousel {
    ...AssetCarouselSection
  }
  ... on CosmosSectionAssetGallery {
    ...AssetGallerySection
  }
  ... on CosmosSectionContentLargeImage {
    ...ContentLargeImage
  }
  ... on CosmosSectionLogoList {
    ...LogoListSection
  }
  ... on CosmosSectionLogoMultiCard {
    ...LogoMultiCardsSection
  }
  ... on CosmosSectionNewsMediaCard {
    ...NewsMediaCardsSection
  }
  ... on CosmosElementCompare {
    ...CosmosCompare
  }
  ... on CosmosElementUserProfile {
    ...CosmosUserProfile
  }
  ... on CosmosSectionDivider {
    ...DividerSection
  }
  ... on CosmosElementQuote {
    ...CosmosQuote
  }
  ... on CosmosElementCalloutCard {
    ...CosmosCalloutCard
  }
  ... on CosmosElementTitleAndDesc {
    ...CosmosTitleAndDesc
  }
  ... on CosmosSectionSimpleCta {
    ...SimpleCtaSection
  }
}
    ${CosmosAssetFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosGitHubGistFragmentDoc}
${CosmosIconLinkGroupFragmentDoc}
${CosmosInterviewFragmentDoc}
${CosmosRichTextFragmentDoc}
${SlimContactCardFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${AssetGallerySectionFragmentDoc}
${ContentLargeImageFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${CosmosCompareFragmentDoc}
${CosmosUserProfileFragmentDoc}
${DividerSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${CosmosCalloutCardFragmentDoc}
${CosmosTitleAndDescFragmentDoc}
${SimpleCtaSectionFragmentDoc}`;
export const PageBlogDetailEntitiesFragmentDoc = gql`
    fragment PageBlogDetailEntities on CosmosPageBlogDetail {
  __typename
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  blogConfig {
    ...BlogConfig
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${BlogConfigFragmentDoc}
${ArticleComponentsFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const PageBlogDetailFragmentDoc = gql`
    fragment PageBlogDetail on CosmosPageBlogDetail {
  __typename
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  blogConfig {
    ...BlogConfig
  }
  hero {
    ...PageHeroes
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSections
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${BlogConfigFragmentDoc}
${PageHeroesFragmentDoc}
${ArticleComponentsFragmentDoc}
${RefSectionsFragmentDoc}`;
export const PageBlogDetailMetadataFragmentDoc = gql`
    fragment PageBlogDetailMetadata on CosmosPageBlogDetail {
  __typename
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const PageEulaKeyFragmentDoc = gql`
    fragment PageEulaKey on CosmosPageEulaKey {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  banner
  bannerCountryCodes
  disclaimer
  title
  subtitle
  eulaKey
}
    ${WfRefApplicationOwnerFragmentDoc}`;
export const PageEulaKeyMetadataFragmentDoc = gql`
    fragment PageEulaKeyMetadata on CosmosPageEulaKey {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const PageFeedFragmentDoc = gql`
    fragment PageFeed on CosmosPageFeed {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  tags {
    ...BlogTag
  }
  categories {
    ...BlogCategory
  }
  searchPlaceholder
  clearFiltersButtonLabel
  featuredLabel
  loadingLabel
  noResultsLabel
  noResultsDescription
}
    ${WfRefApplicationOwnerFragmentDoc}
${BlogTagFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const PageFeedMetadataFragmentDoc = gql`
    fragment PageFeedMetadata on CosmosPageFeed {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosEntityFragmentDoc = gql`
    fragment CosmosEntity on Entity {
  id
  stage
  __typename
}
    `;
export const PageHeroAndSectionsEntitiesFragmentDoc = gql`
    fragment PageHeroAndSectionsEntities on CosmosPageHeroAndSection {
  __typename
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const PageHeroAndSectionsFragmentDoc = gql`
    fragment PageHeroAndSections on CosmosPageHeroAndSection {
  __typename
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ...PageHeroes
  }
  refSections(first: 30) {
    ...RefSections
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${PageHeroesFragmentDoc}
${RefSectionsFragmentDoc}`;
export const PageHeroAndSectionsMetadataFragmentDoc = gql`
    fragment PageHeroAndSectionsMetadata on CosmosPageHeroAndSection {
  __typename
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const PageLegalContentEntitiesFragmentDoc = gql`
    fragment PageLegalContentEntities on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  sections(first: 50) {
    ... on Entity {
      id
      stage
      __typename
    }
  }
}
    ${WfRefApplicationOwnerFragmentDoc}`;
export const CosmosElementCkEditorTextFragmentDoc = gql`
    fragment CosmosElementCkEditorText on CosmosElementCkEditorText {
  __typename
  ckText
}
    `;
export const CosmosElementCkEditorTextCollapsibleFragmentDoc = gql`
    fragment CosmosElementCkEditorTextCollapsible on CosmosElementCkEditorTextCollapsible {
  __typename
  ckText
  collapseButtonLabel
  defaultOpen
}
    `;
export const PageLegalContentSectionsFragmentDoc = gql`
    fragment PageLegalContentSections on CosmosPageLegalContentsectionsUnion {
  ... on CosmosElementCkEditorText {
    ...CosmosElementCkEditorText
  }
  ... on CosmosElementCkEditorTextCollapsible {
    ...CosmosElementCkEditorTextCollapsible
  }
}
    ${CosmosElementCkEditorTextFragmentDoc}
${CosmosElementCkEditorTextCollapsibleFragmentDoc}`;
export const PageLegalContentFragmentDoc = gql`
    fragment PageLegalContent on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ...PageHeroes
  }
  sections(first: 50) {
    ...PageLegalContentSections
  }
  banner
  bannerCountryCodes
}
    ${WfRefApplicationOwnerFragmentDoc}
${PageHeroesFragmentDoc}
${PageLegalContentSectionsFragmentDoc}`;
export const PageLegalContentMetadataFragmentDoc = gql`
    fragment PageLegalContentMetadata on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    ${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const PageLegalContentSlugDataFragmentDoc = gql`
    fragment PageLegalContentSlugData on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  locale
}
    ${WfRefApplicationOwnerFragmentDoc}`;
export const LicenseCardTopFragmentDoc = gql`
    fragment LicenseCardTop on CosmosElementLicenseCardTop {
  __typename
  icon
  title
  description {
    ...CosmosRichText
  }
  example {
    ...CosmosRichText
  }
}
    ${CosmosRichTextFragmentDoc}`;
export const LicenseCardCoreFragmentDoc = gql`
    fragment LicenseCardCore on CosmosElementLicenseCardCore {
  __typename
  title
  description {
    ...CosmosRichText
  }
  example {
    ...CosmosRichText
  }
  buttons(first: 2) {
    __typename
    variant
    href
    name
    label
  }
  countryOverride {
    title
    description {
      ...CosmosRichText
    }
    example {
      ...CosmosRichText
    }
    buttons(first: 2) {
      __typename
      variant
      href
      name
      label
    }
  }
  countriesToOverride
}
    ${CosmosRichTextFragmentDoc}`;
export const LicenseSeatFragmentDoc = gql`
    fragment LicenseSeat on CosmosElementLicenseSeat {
  __typename
  title
  description {
    ...CosmosRichText
  }
  perSeatPerYear
  perYear
  taxes
  minusButtonLabel
  addButtonLabel
  buttons(first: 2) {
    ...CosmosIconButton
  }
  countryOverride {
    buttons(first: 2) {
      ...CosmosIconButton
    }
  }
  countriesToOverride
}
    ${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const LicenseMainCardFragmentDoc = gql`
    fragment LicenseMainCard on CosmosElementLicenseMainCard {
  __typename
  cardTop {
    ...LicenseCardTop
  }
  cardSections(first: 2) {
    ...LicenseCardCore
  }
  seats {
    ...LicenseSeat
  }
}
    ${LicenseCardTopFragmentDoc}
${LicenseCardCoreFragmentDoc}
${LicenseSeatFragmentDoc}`;
export const CosmosPageLicenseCoreFragmentDoc = gql`
    fragment CosmosPageLicenseCore on CosmosPageLicense {
  id
  createdAt
  updatedAt
  slug
  hero {
    ...HeroGlow
  }
  contentLargeImages {
    ...ContentLargeImage
  }
  title
  desc
  freeCardHeading
  freeCard {
    ...LicenseTopCard
  }
  cardHeading
  showExampleLabel
  hideExampleLabel
  mainCards(first: 2) {
    ...LicenseMainCard
  }
  contactCard {
    ...SlimContactCard
  }
  contactCard2 {
    ...SlimContactCard
  }
}
    ${HeroGlowFragmentDoc}
${ContentLargeImageFragmentDoc}
${LicenseTopCardFragmentDoc}
${LicenseMainCardFragmentDoc}
${SlimContactCardFragmentDoc}`;
export const CosmosPageLicenseEntitiesFragmentDoc = gql`
    fragment CosmosPageLicenseEntities on CosmosPageLicense {
  ...CosmosPageLicenseCore
  refSections(first: 12) {
    ...RefSectionsEntities
  }
}
    ${CosmosPageLicenseCoreFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const CosmosPageLicenseFragmentDoc = gql`
    fragment CosmosPageLicense on CosmosPageLicense {
  ...CosmosPageLicenseCore
  refSections(first: 12) {
    ...RefSections
  }
}
    ${CosmosPageLicenseCoreFragmentDoc}
${RefSectionsFragmentDoc}`;
export const CosmosPageLicenseMetadataFragmentDoc = gql`
    fragment CosmosPageLicenseMetadata on CosmosPageLicense {
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
  id
}
    ${CosmosSeoFragmentDoc}`;
export const CosmosPluginDownloadFragmentDoc = gql`
    fragment CosmosPluginDownload on CosmosElementPluginDownload {
  title
  desc
  details {
    ...CosmosPluginDownloadDetail
  }
}
    ${CosmosPluginDownloadDetailFragmentDoc}`;
export const PagePluginDetailEntitiesFragmentDoc = gql`
    fragment PagePluginDetailEntities on CosmosPagePluginDetail {
  id
  createdAt
  updatedAt
  slug
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  downloads {
    ...CosmosPluginDownload
  }
  archivedVersionsTitle
  latestCardSections {
    ...CosmosTitleAndDesc
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
}
    ${CosmosPluginDownloadFragmentDoc}
${CosmosTitleAndDescFragmentDoc}
${ArticleComponentsFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const PagePluginDetailFragmentDoc = gql`
    fragment PagePluginDetail on CosmosPagePluginDetail {
  createdAt
  updatedAt
  slug
  hero {
    ...PageHeroes
  }
  downloads {
    ...CosmosPluginDownload
  }
  archivedVersionsTitle
  latestCardSections {
    ...CosmosTitleAndDesc
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSections
  }
}
    ${PageHeroesFragmentDoc}
${CosmosPluginDownloadFragmentDoc}
${CosmosTitleAndDescFragmentDoc}
${ArticleComponentsFragmentDoc}
${RefSectionsFragmentDoc}`;
export const PagePluginDetailMetadataFragmentDoc = gql`
    fragment PagePluginDetailMetadata on CosmosPagePluginDetail {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    ${CosmosSeoFragmentDoc}`;
export const CosmosRedirectPageFragmentDoc = gql`
    fragment CosmosRedirectPage on CosmosPageRedirect {
  __typename
  id
  slug
  owner {
    ...WfRefApplicationOwner
  }
  destination
  permanent
}
    ${WfRefApplicationOwnerFragmentDoc}`;
export const ResearchCardFragmentDoc = gql`
    fragment ResearchCard on CosmosElementResearchCard {
  href
  publicationDate
  title {
    ...CosmosRichText
  }
  desc
  footer
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    ${CosmosRichTextFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const PageResearchFragmentDoc = gql`
    fragment PageResearch on CosmosPageResearch {
  createdAt
  updatedAt
  slug
  hero {
    ...PageHeroes
  }
  researchCards {
    ...ResearchCard
  }
  researchCardsSectionConfig {
    ...SectionConfig
  }
}
    ${PageHeroesFragmentDoc}
${ResearchCardFragmentDoc}
${SectionConfigFragmentDoc}`;
export const PageResearchMetadataFragmentDoc = gql`
    fragment PageResearchMetadata on CosmosPageResearch {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    ${CosmosSeoFragmentDoc}`;
export const SearchFilterFragmentDoc = gql`
    fragment SearchFilter on CosmosElementSearchFilter {
  id
  label
  value
}
    `;
export const PageSearchFragmentDoc = gql`
    fragment PageSearch on CosmosPageSearch {
  __typename
  id
  createdAt
  updatedAt
  slug
  title
  desc
  searchPlaceholder
  clearSearchLabel
  defaultSearchFilter
  searchFilters(first: 10) {
    ...SearchFilter
  }
  loadingLabel
  noResultsLabel
  suggestedLinksLabel
  suggestedLinks(first: 4) {
    ...GeminiCard
  }
}
    ${SearchFilterFragmentDoc}
${GeminiCardFragmentDoc}`;
export const PageSearchMetadataFragmentDoc = gql`
    fragment PageSearchMetadata on CosmosPageSearch {
  __typename
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
  defaultSearchFilter
  searchFilters(first: 10) {
    ...SearchFilter
  }
}
    ${CosmosSeoFragmentDoc}
${SearchFilterFragmentDoc}`;
export const PageSearchFiltersFragmentDoc = gql`
    fragment PageSearchFilters on CosmosPageSearch {
  __typename
  id
  slug
  defaultSearchFilter
  searchFilters(first: 10) {
    ...SearchFilter
  }
}
    ${SearchFilterFragmentDoc}`;
export const CreateWfRefBlogTagDocument = gql`
    mutation CreateWfRefBlogTag($tagId: String!, $label: String!) {
  createWfRefBlogTag(data: {tagId: $tagId, label: $label}) {
    id
  }
}
    `;
export const UpdateLocalizationWfRefBlogTagDocument = gql`
    mutation UpdateLocalizationWfRefBlogTag($locale: Locale!, $tagId: String!, $label: String!) {
  updateWfRefBlogTag(
    data: {localizations: {create: {data: {label: $label}, locale: $locale}}}
    where: {tagId: $tagId}
  ) {
    id
  }
}
    `;
export const UpdateWfRefBlogTagIdDocument = gql`
    mutation UpdateWfRefBlogTagId($newTagId: String!, $existingTagId: String!) {
  updateWfRefBlogTag(data: {tagId: $newTagId}, where: {tagId: $existingTagId}) {
    id
    tagId
  }
}
    `;
export const QueryLearnSearchDocument = gql`
    query QueryLearnSearch($id: ID!, $categoryType: String!, $industry: String!, $applicationFamily: String!) {
  values: remoteLearn(where: {id: $id}) {
    learnSearch(
      industries: $industry
      types: $categoryType
      applicationFamily: $applicationFamily
    )
  }
}
    `;
export const CosmosPageAgreementEntitiesDocument = gql`
    query CosmosPageAgreementEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageAgreement(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageAgreementEntities
  }
}
    ${CosmosPageAgreementEntitiesFragmentDoc}`;
export const CosmosPageAgreementDocument = gql`
    query CosmosPageAgreement($locale: [Locale!]!, $slug: String!) {
  cosmosPageAgreement(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageAgreement
  }
}
    ${CosmosPageAgreementFragmentDoc}`;
export const CosmosPageAgreementDetailsDocument = gql`
    query CosmosPageAgreementDetails($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosElementAgreementDetail {
      ...AgreementDetails
    }
  }
}
    ${AgreementDetailsFragmentDoc}`;
export const CosmosPageAgreementMetadataDocument = gql`
    query CosmosPageAgreementMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageAgreement(locales: $locale, where: {slug: $slug}) {
    ...PageAgreementMetadata
  }
}
    ${PageAgreementMetadataFragmentDoc}`;
export const CosmosPageBlogDetailEntitiesDocument = gql`
    query CosmosPageBlogDetailEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageBlogDetail(locales: $locale, where: {slug: $slug}) {
    ...PageBlogDetailEntities
  }
}
    ${PageBlogDetailEntitiesFragmentDoc}`;
export const CosmosPageBlogDetailSectionsDocument = gql`
    query CosmosPageBlogDetailSections($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageSections
  }
}
    ${PageSectionsFragmentDoc}`;
export const CosmosPageBlogDetailHeroDocument = gql`
    query CosmosPageBlogDetailHero($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageHeroes
  }
}
    ${PageHeroesFragmentDoc}`;
export const CosmosPageBlogDetailMetadataDocument = gql`
    query CosmosPageBlogDetailMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageBlogDetail(locales: $locale, where: {slug: $slug}) {
    ...PageBlogDetailMetadata
  }
}
    ${PageBlogDetailMetadataFragmentDoc}`;
export const CosmosPageLegalContentMetadataDocument = gql`
    query CosmosPageLegalContentMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    ...PageLegalContentMetadata
  }
}
    ${PageLegalContentMetadataFragmentDoc}`;
export const CosmosPageLegalContentDocument = gql`
    query CosmosPageLegalContent($locale: [Locale!]!, $slug: String!) {
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    ...PageLegalContent
  }
}
    ${PageLegalContentFragmentDoc}`;
export const CosmosPageLegalContentSlugSingleDocument = gql`
    query CosmosPageLegalContentSlugSingle($locale: [Locale!]!, $slug: String!) {
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    ...PageLegalContentSlugData
  }
}
    ${PageLegalContentSlugDataFragmentDoc}`;
export const CosmosPageDirectoryMetadataDocument = gql`
    query CosmosPageDirectoryMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageDirectory(locales: $locale, where: {slug: $slug}) {
    ...PageDirectoryMetadata
  }
}
    ${PageDirectoryMetadataFragmentDoc}`;
export const CosmosPageDirectoryEntitiesDocument = gql`
    query CosmosPageDirectoryEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageDirectory(locales: $locale, where: {slug: $slug}) {
    ...PageDirectoryEntities
  }
}
    ${PageDirectoryEntitiesFragmentDoc}`;
export const CosmosPageEulaKeyDocument = gql`
    query CosmosPageEulaKey($locale: [Locale!]!, $slug: String!) {
  cosmosPageEulaKey(locales: $locale, where: {slug: $slug}) {
    ...PageEulaKey
  }
}
    ${PageEulaKeyFragmentDoc}`;
export const CosmosPageEulaKeyMetadataDocument = gql`
    query CosmosPageEulaKeyMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageEulaKey(locales: $locale, where: {slug: $slug}) {
    ...PageEulaKeyMetadata
  }
}
    ${PageEulaKeyMetadataFragmentDoc}`;
export const CosmosPageFeedEntitiesDocument = gql`
    query CosmosPageFeedEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageFeed(locales: $locale, where: {slug: $slug}) {
    ...PageFeed
  }
  wfRefBlogCategories(locales: $locale) {
    ...BlogCategory
  }
}
    ${PageFeedFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const CosmosPageFeedMetadataDocument = gql`
    query CosmosPageFeedMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageFeed(locales: $locale, where: {slug: $slug}) {
    ...PageFeedMetadata
  }
}
    ${PageFeedMetadataFragmentDoc}`;
export const CosmosPageHeroAndSectionMetadataDocument = gql`
    query CosmosPageHeroAndSectionMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageHeroAndSection(locales: $locale, where: {slug: $slug}) {
    ...PageHeroAndSectionsMetadata
  }
}
    ${PageHeroAndSectionsMetadataFragmentDoc}`;
export const CosmosPageHeroAndSectionEntitiesDocument = gql`
    query CosmosPageHeroAndSectionEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageHeroAndSection(locales: $locale, where: {slug: $slug}) {
    ...PageHeroAndSectionsEntities
  }
}
    ${PageHeroAndSectionsEntitiesFragmentDoc}`;
export const CosmosPageHeroDocument = gql`
    query CosmosPageHero($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageHeroes
  }
}
    ${PageHeroesFragmentDoc}`;
export const CosmosPageHeroAlphaDocument = gql`
    query CosmosPageHeroAlpha($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroAlpha {
      ...HeroAlpha
    }
  }
}
    ${HeroAlphaFragmentDoc}`;
export const CosmosPageHeroGlowDocument = gql`
    query CosmosPageHeroGlow($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroGlow {
      ...HeroGlow
    }
  }
}
    ${HeroGlowFragmentDoc}`;
export const CosmosPageHeroArticleImageDocument = gql`
    query CosmosPageHeroArticleImage($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroArticleImage {
      ...HeroArticleImage
    }
  }
}
    ${HeroArticleImageFragmentDoc}`;
export const CosmosPageHeroBravoDocument = gql`
    query CosmosPageHeroBravo($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroBravo {
      ...HeroBravo
    }
  }
}
    ${HeroBravoFragmentDoc}`;
export const CosmosPageLicenseEntitiesDocument = gql`
    query CosmosPageLicenseEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageLicense(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageLicenseEntities
  }
}
    ${CosmosPageLicenseEntitiesFragmentDoc}`;
export const CosmosPageLicenseMetadataDocument = gql`
    query CosmosPageLicenseMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageLicense(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageLicenseMetadata
  }
}
    ${CosmosPageLicenseMetadataFragmentDoc}`;
export const CosmosPagePluginDetailEntitiesDocument = gql`
    query CosmosPagePluginDetailEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPagePluginDetail(locales: $locale, where: {slug: $slug}) {
    ...PagePluginDetailEntities
  }
}
    ${PagePluginDetailEntitiesFragmentDoc}`;
export const CosmosPagePluginDetailSectionsDocument = gql`
    query CosmosPagePluginDetailSections($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageSections
  }
}
    ${PageSectionsFragmentDoc}`;
export const CosmosPagePluginDetailHeroDocument = gql`
    query CosmosPagePluginDetailHero($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageHeroes
  }
}
    ${PageHeroesFragmentDoc}`;
export const CosmosPagePluginDetailMetadataDocument = gql`
    query CosmosPagePluginDetailMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPagePluginDetail(locales: $locale, where: {slug: $slug}) {
    ...PagePluginDetailMetadata
  }
}
    ${PagePluginDetailMetadataFragmentDoc}`;
export const CosmosPageRedirectDocument = gql`
    query CosmosPageRedirect($slug: String!) {
  cosmosPageRedirect(where: {slug: $slug}) {
    ...CosmosRedirectPage
  }
}
    ${CosmosRedirectPageFragmentDoc}`;
export const CosmosPageRedirectsDocument = gql`
    query CosmosPageRedirects {
  cosmosPageRedirects(first: 1000) {
    ...CosmosRedirectPage
  }
}
    ${CosmosRedirectPageFragmentDoc}`;
export const CosmosPageResearchMetadataDocument = gql`
    query CosmosPageResearchMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageResearch(locales: $locale, where: {slug: $slug}) {
    ...PageResearchMetadata
  }
}
    ${PageResearchMetadataFragmentDoc}`;
export const CosmosPageResearchDocument = gql`
    query CosmosPageResearch($locale: [Locale!]!, $slug: String!) {
  cosmosPageResearch(locales: $locale, where: {slug: $slug}) {
    ...PageResearch
  }
}
    ${PageResearchFragmentDoc}`;
export const CosmosPageSearchFiltersDocument = gql`
    query CosmosPageSearchFilters($locale: [Locale!]!, $slug: String!) {
  cosmosPageSearch(locales: $locale, where: {slug: $slug}) {
    ...PageSearchFilters
  }
}
    ${PageSearchFiltersFragmentDoc}`;
export const CosmosPageSearchMetadataDocument = gql`
    query CosmosPageSearchMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageSearch(locales: $locale, where: {slug: $slug}) {
    ...PageSearchMetadata
  }
}
    ${PageSearchMetadataFragmentDoc}`;
export const CosmosPageSearchDocument = gql`
    query CosmosPageSearch($locale: [Locale!]!, $slug: String!) {
  cosmosPageSearch(locales: $locale, where: {slug: $slug}) {
    ...PageSearch
  }
}
    ${PageSearchFragmentDoc}`;
export const CosmosPageRefSectionAssetDocument = gql`
    query CosmosPageRefSectionAsset($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionAsset {
          ...AssetSection
        }
      }
    }
  }
}
    ${AssetSectionFragmentDoc}`;
export const CosmosPageRefSectionAssetCarouselDocument = gql`
    query CosmosPageRefSectionAssetCarousel($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionAssetCarousel {
          ...AssetCarouselSection
        }
      }
    }
  }
}
    ${AssetCarouselSectionFragmentDoc}`;
export const CosmosPageRefSectionAssetGalleryDocument = gql`
    query CosmosPageRefSectionAssetGallery($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionAssetGallery {
          ...AssetGallerySection
        }
      }
    }
  }
}
    ${AssetGallerySectionFragmentDoc}`;
export const CosmosPageRefSectionBlogCardDocument = gql`
    query CosmosPageRefSectionBlogCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionBlogCard {
          ...BlogCardsSection
        }
      }
    }
  }
}
    ${BlogCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionBlobTableDocument = gql`
    query CosmosPageRefSectionBlobTable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionBlobTable {
          ...BlobTableSection
        }
      }
    }
  }
}
    ${BlobTableSectionFragmentDoc}`;
export const CosmosPageRefSectionCommunityDocument = gql`
    query CosmosPageRefSectionCommunity($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionCommunity {
          ...CommunitySection
        }
      }
    }
  }
}
    ${CommunitySectionFragmentDoc}`;
export const CosmosPageRefSectionComplexCtaCardDocument = gql`
    query CosmosPageRefSectionComplexCtaCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionComplexCtaCard {
          ...ComplexCtaCardsSection
        }
      }
    }
  }
}
    ${ComplexCtaCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionContentLargeImageDocument = gql`
    query CosmosPageRefSectionContentLargeImage($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionContentLargeImage {
          ...ContentLargeImage
        }
      }
    }
  }
}
    ${ContentLargeImageFragmentDoc}`;
export const CosmosPageRefSectionCruxDocument = gql`
    query CosmosPageRefSectionCrux($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionCrux {
          ...CruxSection
        }
      }
    }
  }
}
    ${CruxSectionFragmentDoc}`;
export const CosmosPageRefSectionDividerDocument = gql`
    query CosmosPageRefSectionDivider($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionDivider {
          ...DividerSection
        }
      }
    }
  }
}
    ${DividerSectionFragmentDoc}`;
export const CosmosPageRefSectionDownloadableDocument = gql`
    query CosmosPageRefSectionDownloadable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionDownloadable {
          ...DownloadableSection
        }
      }
    }
  }
}
    ${DownloadableSectionFragmentDoc}`;
export const CosmosPageRefSectionDownloadCardDocument = gql`
    query CosmosPageRefSectionDownloadCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionDownloadCard {
          ...DownloadCardsSection
        }
      }
    }
  }
}
    ${DownloadCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionEmbedDocument = gql`
    query CosmosPageRefSectionEmbed($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionEmbed {
          ...EmbedSection
        }
      }
    }
  }
}
    ${EmbedSectionFragmentDoc}`;
export const CosmosPageRefSectionEventsTableDocument = gql`
    query CosmosPageRefSectionEventsTable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionEventsTable {
          ...EventsTableSection
        }
      }
    }
  }
}
    ${EventsTableSectionFragmentDoc}`;
export const CosmosPageRefSectionFeatureCardDocument = gql`
    query CosmosPageRefSectionFeatureCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionFeatureCard {
          ...FeatureCardsSection
        }
      }
    }
  }
}
    ${FeatureCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionFaqDocument = gql`
    query CosmosPageRefSectionFaq($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionFaq {
          ...FAQSection
        }
      }
    }
  }
}
    ${FaqSectionFragmentDoc}`;
export const CosmosPageRefSectionGameDevFeatureCardDocument = gql`
    query CosmosPageRefSectionGameDevFeatureCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionGameDevFeatureCard {
          ...FeaturePanelsSection
        }
      }
    }
  }
}
    ${FeaturePanelsSectionFragmentDoc}`;
export const CosmosPageRefSectionAccordionFeatureCardDocument = gql`
    query CosmosPageRefSectionAccordionFeatureCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionAccordionFeatureCard {
          ...AccordionFeatureCardsSection
        }
      }
    }
  }
}
    ${AccordionFeatureCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionAccordionTierCardsDocument = gql`
    query CosmosPageRefSectionAccordionTierCards($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionAccordionTierCards {
          ...AccordionTierCardsSection
        }
      }
    }
  }
}
    ${AccordionTierCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionLearnDocument = gql`
    query CosmosPageRefSectionLearn($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionLearn {
          ...LearnSection
        }
      }
    }
  }
}
    ${LearnSectionFragmentDoc}`;
export const CosmosPageRefSectionLogoListDocument = gql`
    query CosmosPageRefSectionLogoList($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionLogoList {
          ...LogoListSection
        }
      }
    }
  }
}
    ${LogoListSectionFragmentDoc}`;
export const CosmosPageRefSectionLogoMultiCardDocument = gql`
    query CosmosPageRefSectionLogoMultiCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionLogoMultiCard {
          ...LogoMultiCardsSection
        }
      }
    }
  }
}
    ${LogoMultiCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionNewsCardDocument = gql`
    query CosmosPageRefSectionNewsCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionNewsCard {
          ...NewsCardsSection
        }
      }
    }
  }
}
    ${NewsCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionNewsMediaCardDocument = gql`
    query CosmosPageRefSectionNewsMediaCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionNewsMediaCard {
          ...NewsMediaCardsSection
        }
      }
    }
  }
}
    ${NewsMediaCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionLicensesCollapsedDocument = gql`
    query CosmosPageRefSectionLicensesCollapsed($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionLicensesCollapsed {
          ...LicensesCollapsedSection
        }
      }
    }
  }
}
    ${LicensesCollapsedSectionFragmentDoc}`;
export const CosmosPageRefSectionRichTextDocument = gql`
    query CosmosPageRefSectionRichText($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionRichText {
          ...RichTextSection
        }
      }
    }
  }
}
    ${RichTextSectionFragmentDoc}`;
export const CosmosPageRefSectionGeminiCardDocument = gql`
    query CosmosPageRefSectionGeminiCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionGeminiCard {
          ...GeminiCardsSection
        }
      }
    }
  }
}
    ${GeminiCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionHydrusColumnListDocument = gql`
    query CosmosPageRefSectionHydrusColumnList($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionHydrusColumnList {
          ...HydrusColumnListSection
        }
      }
    }
  }
}
    ${HydrusColumnListSectionFragmentDoc}`;
export const CosmosPageRefSectionDelphinusCardsGridDocument = gql`
    query CosmosPageRefSectionDelphinusCardsGrid($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionDelphinusCardsGrid {
          ...DelphinusCardsGridSection
        }
      }
    }
  }
}
    ${DelphinusCardsGridSectionFragmentDoc}`;
export const CosmosPageRefSectionNewsletterSignupDocument = gql`
    query CosmosPageRefSectionNewsletterSignup($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionNewsletterSignup {
          ...NewsletterSignup
        }
      }
    }
  }
}
    ${NewsletterSignupFragmentDoc}`;
export const CosmosPageRefSectionSimpleCtaDocument = gql`
    query CosmosPageRefSectionSimpleCta($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionSimpleCta {
          ...SimpleCtaSection
        }
      }
    }
  }
}
    ${SimpleCtaSectionFragmentDoc}`;
export const CosmosPageRefSectionSlimContactCardDocument = gql`
    query CosmosPageRefSectionSlimContactCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionSlimContactCard {
          ...SlimContactCardsSection
        }
      }
    }
  }
}
    ${SlimContactCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionSpeakerCardDocument = gql`
    query CosmosPageRefSectionSpeakerCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionSpeakerCard {
          ...SpeakerCardsSection
        }
      }
    }
  }
}
    ${SpeakerCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionLatestNewsDocument = gql`
    query CosmosPageRefSectionLatestNews($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionLatestNews {
          ...LatestNewsSection
        }
      }
    }
  }
}
    ${LatestNewsSectionFragmentDoc}`;
export const CosmosPageRefSectionNumberCalloutDocument = gql`
    query CosmosPageRefSectionNumberCallout($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionNumberCallout {
          ...NumberCalloutSection
        }
      }
    }
  }
}
    ${NumberCalloutSectionFragmentDoc}`;
export const CosmosPageRefSectionTabbedFullWidthAssetDocument = gql`
    query CosmosPageRefSectionTabbedFullWidthAsset($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionTabbedFullWidthAsset {
          ...TabbedFullWidthAssetSection
        }
      }
    }
  }
}
    ${TabbedFullWidthAssetSectionFragmentDoc}`;
export const CosmosPageRefSectionTabbedBlogCardDocument = gql`
    query CosmosPageRefSectionTabbedBlogCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionTabbedBlogCard {
          ...TabbedBlogCardsSection
        }
      }
    }
  }
}
    ${TabbedBlogCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionTabbedContentImageDocument = gql`
    query CosmosPageRefSectionTabbedContentImage($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionTabbedContentImage {
          ...TabbedContentImageSection
        }
      }
    }
  }
}
    ${TabbedContentImageSectionFragmentDoc}`;
export const CosmosPageRefSectionFaqSearchDocument = gql`
    query CosmosPageRefSectionFaqSearch($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionFaqSearch {
          ...FAQSearchSection
        }
      }
    }
  }
}
    ${FaqSearchSectionFragmentDoc}`;
export const CosmosPageRefSectionCkRichTextDocument = gql`
    query CosmosPageRefSectionCkRichText($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionCkRichText {
          ...CkRichTextSection
        }
      }
    }
  }
}
    ${CkRichTextSectionFragmentDoc}`;
export const CosmosPageRefSectionAriesCardsDocument = gql`
    query CosmosPageRefSectionAriesCards($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionAriesCards {
          ...AriesCardsSection
        }
      }
    }
  }
}
    ${AriesCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionContentSliderAssetDocument = gql`
    query CosmosPageRefSectionContentSliderAsset($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionContentSliderAsset {
          ...ContentSliderAsset
        }
      }
    }
  }
}
    ${ContentSliderAssetFragmentDoc}`;
export const CosmosPageRefSectionQuoteDocument = gql`
    query CosmosPageRefSectionQuote($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionQuote {
          ...QuoteSection
        }
      }
    }
  }
}
    ${QuoteSectionFragmentDoc}`;
export const CosmosPageRefSectionUtCardDocument = gql`
    query CosmosPageRefSectionUtCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionUtCard {
          ...UtCardSection
        }
      }
    }
  }
}
    ${UtCardSectionFragmentDoc}`;
export const CosmosPageRefSectionResellersSearchDocument = gql`
    query CosmosPageRefSectionResellersSearch($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionResellersSearch {
          ...ResellersSearchSection
        }
      }
    }
  }
}
    ${ResellersSearchSectionFragmentDoc}`;
export const CosmosPageRefSectionPluginListTableDocument = gql`
    query CosmosPageRefSectionPluginListTable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionPluginListTable {
          ...PluginListTableSection
        }
      }
    }
  }
}
    ${PluginListTableSectionFragmentDoc}`;
export const CosmosPageRefSectionDevelopersListDocument = gql`
    query CosmosPageRefSectionDevelopersList($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionDevelopersList {
          ...DevelopersListSection
        }
      }
    }
  }
}
    ${DevelopersListSectionFragmentDoc}`;
export const CosmosPageRefSectionOrionCardsDocument = gql`
    query CosmosPageRefSectionOrionCards($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosReferenceSection {
      __typename
      id
      section {
        ... on CosmosSectionOrionCards {
          ...OrionCardsSection
        }
      }
    }
  }
}
    ${OrionCardsSectionFragmentDoc}`;
export const CosmosPageRefSectionDocument = gql`
    query CosmosPageRefSection($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...RefSections
  }
}
    ${RefSectionsFragmentDoc}`;
export const CosmosPageTemplatesDocument = gql`
    query CosmosPageTemplates($locale: [Locale!]!, $slug: String!) {
  cosmosPageHeroAndSection(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageDirectory(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageBlogDetail(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageEulaKey(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageRedirect(where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageSearch(where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageResearch(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
}
    `;
export const WfRefApplicationOwnersDocument = gql`
    query WfRefApplicationOwners {
  wfRefApplicationOwners {
    ...WfRefApplicationOwner
  }
}
    ${WfRefApplicationOwnerFragmentDoc}`;
export const WfRefTagsDocument = gql`
    query WfRefTags($first: Int, $skip: Int) {
  wfRefBlogTags(stage: DRAFT, first: $first, skip: $skip) {
    tagId
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CreateWfRefBlogTag(variables: CreateWfRefBlogTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateWfRefBlogTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWfRefBlogTagMutation>({ document: CreateWfRefBlogTagDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateWfRefBlogTag', 'mutation', variables);
    },
    UpdateLocalizationWfRefBlogTag(variables: UpdateLocalizationWfRefBlogTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateLocalizationWfRefBlogTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLocalizationWfRefBlogTagMutation>({ document: UpdateLocalizationWfRefBlogTagDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateLocalizationWfRefBlogTag', 'mutation', variables);
    },
    UpdateWfRefBlogTagId(variables: UpdateWfRefBlogTagIdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateWfRefBlogTagIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWfRefBlogTagIdMutation>({ document: UpdateWfRefBlogTagIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateWfRefBlogTagId', 'mutation', variables);
    },
    QueryLearnSearch(variables: QueryLearnSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryLearnSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryLearnSearchQuery>({ document: QueryLearnSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'QueryLearnSearch', 'query', variables);
    },
    CosmosPageAgreementEntities(variables: CosmosPageAgreementEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementEntitiesQuery>({ document: CosmosPageAgreementEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreementEntities', 'query', variables);
    },
    CosmosPageAgreement(variables: CosmosPageAgreementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementQuery>({ document: CosmosPageAgreementDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreement', 'query', variables);
    },
    CosmosPageAgreementDetails(variables: CosmosPageAgreementDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementDetailsQuery>({ document: CosmosPageAgreementDetailsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreementDetails', 'query', variables);
    },
    CosmosPageAgreementMetadata(variables: CosmosPageAgreementMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementMetadataQuery>({ document: CosmosPageAgreementMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreementMetadata', 'query', variables);
    },
    CosmosPageBlogDetailEntities(variables: CosmosPageBlogDetailEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailEntitiesQuery>({ document: CosmosPageBlogDetailEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailEntities', 'query', variables);
    },
    CosmosPageBlogDetailSections(variables: CosmosPageBlogDetailSectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailSectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailSectionsQuery>({ document: CosmosPageBlogDetailSectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailSections', 'query', variables);
    },
    CosmosPageBlogDetailHero(variables: CosmosPageBlogDetailHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailHeroQuery>({ document: CosmosPageBlogDetailHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailHero', 'query', variables);
    },
    CosmosPageBlogDetailMetadata(variables: CosmosPageBlogDetailMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailMetadataQuery>({ document: CosmosPageBlogDetailMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailMetadata', 'query', variables);
    },
    CosmosPageLegalContentMetadata(variables: CosmosPageLegalContentMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLegalContentMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLegalContentMetadataQuery>({ document: CosmosPageLegalContentMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLegalContentMetadata', 'query', variables);
    },
    CosmosPageLegalContent(variables: CosmosPageLegalContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLegalContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLegalContentQuery>({ document: CosmosPageLegalContentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLegalContent', 'query', variables);
    },
    CosmosPageLegalContentSlugSingle(variables: CosmosPageLegalContentSlugSingleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLegalContentSlugSingleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLegalContentSlugSingleQuery>({ document: CosmosPageLegalContentSlugSingleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLegalContentSlugSingle', 'query', variables);
    },
    CosmosPageDirectoryMetadata(variables: CosmosPageDirectoryMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageDirectoryMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageDirectoryMetadataQuery>({ document: CosmosPageDirectoryMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageDirectoryMetadata', 'query', variables);
    },
    CosmosPageDirectoryEntities(variables: CosmosPageDirectoryEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageDirectoryEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageDirectoryEntitiesQuery>({ document: CosmosPageDirectoryEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageDirectoryEntities', 'query', variables);
    },
    CosmosPageEulaKey(variables: CosmosPageEulaKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageEulaKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageEulaKeyQuery>({ document: CosmosPageEulaKeyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageEulaKey', 'query', variables);
    },
    CosmosPageEulaKeyMetadata(variables: CosmosPageEulaKeyMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageEulaKeyMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageEulaKeyMetadataQuery>({ document: CosmosPageEulaKeyMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageEulaKeyMetadata', 'query', variables);
    },
    CosmosPageFeedEntities(variables: CosmosPageFeedEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageFeedEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageFeedEntitiesQuery>({ document: CosmosPageFeedEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageFeedEntities', 'query', variables);
    },
    CosmosPageFeedMetadata(variables: CosmosPageFeedMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageFeedMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageFeedMetadataQuery>({ document: CosmosPageFeedMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageFeedMetadata', 'query', variables);
    },
    CosmosPageHeroAndSectionMetadata(variables: CosmosPageHeroAndSectionMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroAndSectionMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroAndSectionMetadataQuery>({ document: CosmosPageHeroAndSectionMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroAndSectionMetadata', 'query', variables);
    },
    CosmosPageHeroAndSectionEntities(variables: CosmosPageHeroAndSectionEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroAndSectionEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroAndSectionEntitiesQuery>({ document: CosmosPageHeroAndSectionEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroAndSectionEntities', 'query', variables);
    },
    CosmosPageHero(variables: CosmosPageHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroQuery>({ document: CosmosPageHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHero', 'query', variables);
    },
    CosmosPageHeroAlpha(variables: CosmosPageHeroAlphaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroAlphaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroAlphaQuery>({ document: CosmosPageHeroAlphaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroAlpha', 'query', variables);
    },
    CosmosPageHeroGlow(variables: CosmosPageHeroGlowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroGlowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroGlowQuery>({ document: CosmosPageHeroGlowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroGlow', 'query', variables);
    },
    CosmosPageHeroArticleImage(variables: CosmosPageHeroArticleImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroArticleImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroArticleImageQuery>({ document: CosmosPageHeroArticleImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroArticleImage', 'query', variables);
    },
    CosmosPageHeroBravo(variables: CosmosPageHeroBravoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroBravoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroBravoQuery>({ document: CosmosPageHeroBravoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroBravo', 'query', variables);
    },
    CosmosPageLicenseEntities(variables: CosmosPageLicenseEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLicenseEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLicenseEntitiesQuery>({ document: CosmosPageLicenseEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLicenseEntities', 'query', variables);
    },
    CosmosPageLicenseMetadata(variables: CosmosPageLicenseMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLicenseMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLicenseMetadataQuery>({ document: CosmosPageLicenseMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLicenseMetadata', 'query', variables);
    },
    CosmosPagePluginDetailEntities(variables: CosmosPagePluginDetailEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailEntitiesQuery>({ document: CosmosPagePluginDetailEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailEntities', 'query', variables);
    },
    CosmosPagePluginDetailSections(variables: CosmosPagePluginDetailSectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailSectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailSectionsQuery>({ document: CosmosPagePluginDetailSectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailSections', 'query', variables);
    },
    CosmosPagePluginDetailHero(variables: CosmosPagePluginDetailHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailHeroQuery>({ document: CosmosPagePluginDetailHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailHero', 'query', variables);
    },
    CosmosPagePluginDetailMetadata(variables: CosmosPagePluginDetailMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailMetadataQuery>({ document: CosmosPagePluginDetailMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailMetadata', 'query', variables);
    },
    CosmosPageRedirect(variables: CosmosPageRedirectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRedirectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRedirectQuery>({ document: CosmosPageRedirectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRedirect', 'query', variables);
    },
    CosmosPageRedirects(variables?: CosmosPageRedirectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRedirectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRedirectsQuery>({ document: CosmosPageRedirectsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRedirects', 'query', variables);
    },
    CosmosPageResearchMetadata(variables: CosmosPageResearchMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageResearchMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageResearchMetadataQuery>({ document: CosmosPageResearchMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageResearchMetadata', 'query', variables);
    },
    CosmosPageResearch(variables: CosmosPageResearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageResearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageResearchQuery>({ document: CosmosPageResearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageResearch', 'query', variables);
    },
    CosmosPageSearchFilters(variables: CosmosPageSearchFiltersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSearchFiltersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSearchFiltersQuery>({ document: CosmosPageSearchFiltersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSearchFilters', 'query', variables);
    },
    CosmosPageSearchMetadata(variables: CosmosPageSearchMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSearchMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSearchMetadataQuery>({ document: CosmosPageSearchMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSearchMetadata', 'query', variables);
    },
    CosmosPageSearch(variables: CosmosPageSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSearchQuery>({ document: CosmosPageSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSearch', 'query', variables);
    },
    CosmosPageRefSectionAsset(variables: CosmosPageRefSectionAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionAssetQuery>({ document: CosmosPageRefSectionAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionAsset', 'query', variables);
    },
    CosmosPageRefSectionAssetCarousel(variables: CosmosPageRefSectionAssetCarouselQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionAssetCarouselQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionAssetCarouselQuery>({ document: CosmosPageRefSectionAssetCarouselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionAssetCarousel', 'query', variables);
    },
    CosmosPageRefSectionAssetGallery(variables: CosmosPageRefSectionAssetGalleryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionAssetGalleryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionAssetGalleryQuery>({ document: CosmosPageRefSectionAssetGalleryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionAssetGallery', 'query', variables);
    },
    CosmosPageRefSectionBlogCard(variables: CosmosPageRefSectionBlogCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionBlogCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionBlogCardQuery>({ document: CosmosPageRefSectionBlogCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionBlogCard', 'query', variables);
    },
    CosmosPageRefSectionBlobTable(variables: CosmosPageRefSectionBlobTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionBlobTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionBlobTableQuery>({ document: CosmosPageRefSectionBlobTableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionBlobTable', 'query', variables);
    },
    CosmosPageRefSectionCommunity(variables: CosmosPageRefSectionCommunityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionCommunityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionCommunityQuery>({ document: CosmosPageRefSectionCommunityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionCommunity', 'query', variables);
    },
    CosmosPageRefSectionComplexCtaCard(variables: CosmosPageRefSectionComplexCtaCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionComplexCtaCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionComplexCtaCardQuery>({ document: CosmosPageRefSectionComplexCtaCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionComplexCtaCard', 'query', variables);
    },
    CosmosPageRefSectionContentLargeImage(variables: CosmosPageRefSectionContentLargeImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionContentLargeImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionContentLargeImageQuery>({ document: CosmosPageRefSectionContentLargeImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionContentLargeImage', 'query', variables);
    },
    CosmosPageRefSectionCrux(variables: CosmosPageRefSectionCruxQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionCruxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionCruxQuery>({ document: CosmosPageRefSectionCruxDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionCrux', 'query', variables);
    },
    CosmosPageRefSectionDivider(variables: CosmosPageRefSectionDividerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionDividerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionDividerQuery>({ document: CosmosPageRefSectionDividerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionDivider', 'query', variables);
    },
    CosmosPageRefSectionDownloadable(variables: CosmosPageRefSectionDownloadableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionDownloadableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionDownloadableQuery>({ document: CosmosPageRefSectionDownloadableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionDownloadable', 'query', variables);
    },
    CosmosPageRefSectionDownloadCard(variables: CosmosPageRefSectionDownloadCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionDownloadCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionDownloadCardQuery>({ document: CosmosPageRefSectionDownloadCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionDownloadCard', 'query', variables);
    },
    CosmosPageRefSectionEmbed(variables: CosmosPageRefSectionEmbedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionEmbedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionEmbedQuery>({ document: CosmosPageRefSectionEmbedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionEmbed', 'query', variables);
    },
    CosmosPageRefSectionEventsTable(variables: CosmosPageRefSectionEventsTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionEventsTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionEventsTableQuery>({ document: CosmosPageRefSectionEventsTableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionEventsTable', 'query', variables);
    },
    CosmosPageRefSectionFeatureCard(variables: CosmosPageRefSectionFeatureCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionFeatureCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionFeatureCardQuery>({ document: CosmosPageRefSectionFeatureCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionFeatureCard', 'query', variables);
    },
    CosmosPageRefSectionFaq(variables: CosmosPageRefSectionFaqQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionFaqQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionFaqQuery>({ document: CosmosPageRefSectionFaqDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionFaq', 'query', variables);
    },
    CosmosPageRefSectionGameDevFeatureCard(variables: CosmosPageRefSectionGameDevFeatureCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionGameDevFeatureCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionGameDevFeatureCardQuery>({ document: CosmosPageRefSectionGameDevFeatureCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionGameDevFeatureCard', 'query', variables);
    },
    CosmosPageRefSectionAccordionFeatureCard(variables: CosmosPageRefSectionAccordionFeatureCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionAccordionFeatureCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionAccordionFeatureCardQuery>({ document: CosmosPageRefSectionAccordionFeatureCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionAccordionFeatureCard', 'query', variables);
    },
    CosmosPageRefSectionAccordionTierCards(variables: CosmosPageRefSectionAccordionTierCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionAccordionTierCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionAccordionTierCardsQuery>({ document: CosmosPageRefSectionAccordionTierCardsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionAccordionTierCards', 'query', variables);
    },
    CosmosPageRefSectionLearn(variables: CosmosPageRefSectionLearnQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionLearnQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionLearnQuery>({ document: CosmosPageRefSectionLearnDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionLearn', 'query', variables);
    },
    CosmosPageRefSectionLogoList(variables: CosmosPageRefSectionLogoListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionLogoListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionLogoListQuery>({ document: CosmosPageRefSectionLogoListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionLogoList', 'query', variables);
    },
    CosmosPageRefSectionLogoMultiCard(variables: CosmosPageRefSectionLogoMultiCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionLogoMultiCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionLogoMultiCardQuery>({ document: CosmosPageRefSectionLogoMultiCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionLogoMultiCard', 'query', variables);
    },
    CosmosPageRefSectionNewsCard(variables: CosmosPageRefSectionNewsCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionNewsCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionNewsCardQuery>({ document: CosmosPageRefSectionNewsCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionNewsCard', 'query', variables);
    },
    CosmosPageRefSectionNewsMediaCard(variables: CosmosPageRefSectionNewsMediaCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionNewsMediaCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionNewsMediaCardQuery>({ document: CosmosPageRefSectionNewsMediaCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionNewsMediaCard', 'query', variables);
    },
    CosmosPageRefSectionLicensesCollapsed(variables: CosmosPageRefSectionLicensesCollapsedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionLicensesCollapsedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionLicensesCollapsedQuery>({ document: CosmosPageRefSectionLicensesCollapsedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionLicensesCollapsed', 'query', variables);
    },
    CosmosPageRefSectionRichText(variables: CosmosPageRefSectionRichTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionRichTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionRichTextQuery>({ document: CosmosPageRefSectionRichTextDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionRichText', 'query', variables);
    },
    CosmosPageRefSectionGeminiCard(variables: CosmosPageRefSectionGeminiCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionGeminiCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionGeminiCardQuery>({ document: CosmosPageRefSectionGeminiCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionGeminiCard', 'query', variables);
    },
    CosmosPageRefSectionHydrusColumnList(variables: CosmosPageRefSectionHydrusColumnListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionHydrusColumnListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionHydrusColumnListQuery>({ document: CosmosPageRefSectionHydrusColumnListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionHydrusColumnList', 'query', variables);
    },
    CosmosPageRefSectionDelphinusCardsGrid(variables: CosmosPageRefSectionDelphinusCardsGridQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionDelphinusCardsGridQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionDelphinusCardsGridQuery>({ document: CosmosPageRefSectionDelphinusCardsGridDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionDelphinusCardsGrid', 'query', variables);
    },
    CosmosPageRefSectionNewsletterSignup(variables: CosmosPageRefSectionNewsletterSignupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionNewsletterSignupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionNewsletterSignupQuery>({ document: CosmosPageRefSectionNewsletterSignupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionNewsletterSignup', 'query', variables);
    },
    CosmosPageRefSectionSimpleCta(variables: CosmosPageRefSectionSimpleCtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionSimpleCtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionSimpleCtaQuery>({ document: CosmosPageRefSectionSimpleCtaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionSimpleCta', 'query', variables);
    },
    CosmosPageRefSectionSlimContactCard(variables: CosmosPageRefSectionSlimContactCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionSlimContactCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionSlimContactCardQuery>({ document: CosmosPageRefSectionSlimContactCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionSlimContactCard', 'query', variables);
    },
    CosmosPageRefSectionSpeakerCard(variables: CosmosPageRefSectionSpeakerCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionSpeakerCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionSpeakerCardQuery>({ document: CosmosPageRefSectionSpeakerCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionSpeakerCard', 'query', variables);
    },
    CosmosPageRefSectionLatestNews(variables: CosmosPageRefSectionLatestNewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionLatestNewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionLatestNewsQuery>({ document: CosmosPageRefSectionLatestNewsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionLatestNews', 'query', variables);
    },
    CosmosPageRefSectionNumberCallout(variables: CosmosPageRefSectionNumberCalloutQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionNumberCalloutQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionNumberCalloutQuery>({ document: CosmosPageRefSectionNumberCalloutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionNumberCallout', 'query', variables);
    },
    CosmosPageRefSectionTabbedFullWidthAsset(variables: CosmosPageRefSectionTabbedFullWidthAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionTabbedFullWidthAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionTabbedFullWidthAssetQuery>({ document: CosmosPageRefSectionTabbedFullWidthAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionTabbedFullWidthAsset', 'query', variables);
    },
    CosmosPageRefSectionTabbedBlogCard(variables: CosmosPageRefSectionTabbedBlogCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionTabbedBlogCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionTabbedBlogCardQuery>({ document: CosmosPageRefSectionTabbedBlogCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionTabbedBlogCard', 'query', variables);
    },
    CosmosPageRefSectionTabbedContentImage(variables: CosmosPageRefSectionTabbedContentImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionTabbedContentImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionTabbedContentImageQuery>({ document: CosmosPageRefSectionTabbedContentImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionTabbedContentImage', 'query', variables);
    },
    CosmosPageRefSectionFaqSearch(variables: CosmosPageRefSectionFaqSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionFaqSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionFaqSearchQuery>({ document: CosmosPageRefSectionFaqSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionFaqSearch', 'query', variables);
    },
    CosmosPageRefSectionCkRichText(variables: CosmosPageRefSectionCkRichTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionCkRichTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionCkRichTextQuery>({ document: CosmosPageRefSectionCkRichTextDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionCkRichText', 'query', variables);
    },
    CosmosPageRefSectionAriesCards(variables: CosmosPageRefSectionAriesCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionAriesCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionAriesCardsQuery>({ document: CosmosPageRefSectionAriesCardsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionAriesCards', 'query', variables);
    },
    CosmosPageRefSectionContentSliderAsset(variables: CosmosPageRefSectionContentSliderAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionContentSliderAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionContentSliderAssetQuery>({ document: CosmosPageRefSectionContentSliderAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionContentSliderAsset', 'query', variables);
    },
    CosmosPageRefSectionQuote(variables: CosmosPageRefSectionQuoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionQuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionQuoteQuery>({ document: CosmosPageRefSectionQuoteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionQuote', 'query', variables);
    },
    CosmosPageRefSectionUtCard(variables: CosmosPageRefSectionUtCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionUtCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionUtCardQuery>({ document: CosmosPageRefSectionUtCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionUtCard', 'query', variables);
    },
    CosmosPageRefSectionResellersSearch(variables: CosmosPageRefSectionResellersSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionResellersSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionResellersSearchQuery>({ document: CosmosPageRefSectionResellersSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionResellersSearch', 'query', variables);
    },
    CosmosPageRefSectionPluginListTable(variables: CosmosPageRefSectionPluginListTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionPluginListTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionPluginListTableQuery>({ document: CosmosPageRefSectionPluginListTableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionPluginListTable', 'query', variables);
    },
    CosmosPageRefSectionDevelopersList(variables: CosmosPageRefSectionDevelopersListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionDevelopersListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionDevelopersListQuery>({ document: CosmosPageRefSectionDevelopersListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionDevelopersList', 'query', variables);
    },
    CosmosPageRefSectionOrionCards(variables: CosmosPageRefSectionOrionCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionOrionCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionOrionCardsQuery>({ document: CosmosPageRefSectionOrionCardsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSectionOrionCards', 'query', variables);
    },
    CosmosPageRefSection(variables: CosmosPageRefSectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRefSectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRefSectionQuery>({ document: CosmosPageRefSectionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRefSection', 'query', variables);
    },
    CosmosPageTemplates(variables: CosmosPageTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageTemplatesQuery>({ document: CosmosPageTemplatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageTemplates', 'query', variables);
    },
    WfRefApplicationOwners(variables?: WfRefApplicationOwnersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WfRefApplicationOwnersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WfRefApplicationOwnersQuery>({ document: WfRefApplicationOwnersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'WfRefApplicationOwners', 'query', variables);
    },
    WfRefTags(variables?: WfRefTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WfRefTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WfRefTagsQuery>({ document: WfRefTagsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'WfRefTags', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CommunityCardParent": [
      "CommunityResource"
    ],
    "CommunityResourceParent": [
      "CosmosSectionCommunity"
    ],
    "CosmosConfigBlogParent": [
      "CosmosFeedBlogCard",
      "CosmosPageBlogDetail"
    ],
    "CosmosConfigSectionParent": [
      "CosmosDetailServicePartner",
      "CosmosPageResearch",
      "CosmosSectionAccordionFeatureCard",
      "CosmosSectionAccordionTierCards",
      "CosmosSectionAriesCards",
      "CosmosSectionAsset",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionBlobTable",
      "CosmosSectionBlogCard",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionComplexCtaCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionCrux",
      "CosmosSectionDelphinusCardsGrid",
      "CosmosSectionDevelopersList",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable",
      "CosmosSectionEmbed",
      "CosmosSectionEventsTable",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionFeatureCard",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionGeminiCard",
      "CosmosSectionHydrusColumnList",
      "CosmosSectionLatestNews",
      "CosmosSectionLearn",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionNumberCallout",
      "CosmosSectionOrionCards",
      "CosmosSectionPluginListTable",
      "CosmosSectionQuote",
      "CosmosSectionResellersSearch",
      "CosmosSectionRichText",
      "CosmosSectionSlimContactCard",
      "CosmosSectionSpeakerCard",
      "CosmosSectionTabbedBlogCard",
      "CosmosSectionTabbedContentImage",
      "CosmosSectionUtCard"
    ],
    "CosmosConfigSectionheadingUnion": [
      "CosmosElementIconSectionHeading",
      "CosmosElementSectionHeading"
    ],
    "CosmosDetailServicePartnerParent": [
      "CosmosPageDirectory"
    ],
    "CosmosElementAccordionFeatureCardParent": [
      "CosmosSectionAccordionFeatureCard"
    ],
    "CosmosElementAccordionTierCardParent": [
      "CosmosSectionAccordionTierCards"
    ],
    "CosmosElementAccordionTierCarditemsUnion": [
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard"
    ],
    "CosmosElementAccordionTierCtaCardParent": [
      "CosmosElementAccordionTierCard"
    ],
    "CosmosElementAccordionTierCtaCardbuttonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementAccordionTierFeatureCardParent": [
      "CosmosElementAccordionTierCard"
    ],
    "CosmosElementAccordionTierFeatureCardbuttonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementAgreementDetailParent": [
      "CosmosPageAgreement"
    ],
    "CosmosElementAriesCardParent": [
      "CosmosSectionAriesCards"
    ],
    "CosmosElementAssetParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementAvatarParent": [
      "CosmosElementDelphinusCard",
      "CosmosElementUserProfile"
    ],
    "CosmosElementBlogCardParent": [
      "CosmosConfigBlog",
      "CosmosElementTabbedBlogCardsItem",
      "CosmosSectionBlogCard"
    ],
    "CosmosElementButtonListParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementButtonParent": [
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard",
      "CosmosElementAriesCard",
      "CosmosElementButtonList",
      "CosmosElementComplexCtaCard",
      "CosmosElementDownloadCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementIconSectionHeading",
      "CosmosElementLearnDocumentationCard",
      "CosmosElementLicenseCardCore",
      "CosmosElementLicenseTopCard",
      "CosmosElementNewsMediaCard",
      "CosmosElementSectionHeading",
      "CosmosElementTabbedBlogCardsItem",
      "CosmosElementTabbedContentImageItem",
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionOrionCards",
      "CosmosSectionRichText",
      "ElementLearnCategory"
    ],
    "CosmosElementCalloutCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementCheckListItemParent": [
      "CosmosElementLicenseTopCard"
    ],
    "CosmosElementCkEditorTextCollapsibleParent": [
      "CosmosPageLegalContent"
    ],
    "CosmosElementCkEditorTextParent": [
      "CosmosPageBlogDetail",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementCompareParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementComplexCtaCardParent": [
      "CosmosSectionComplexCtaCard"
    ],
    "CosmosElementCruxLinkParent": [
      "CosmosSectionCrux"
    ],
    "CosmosElementDelphinusCardParent": [
      "CosmosSectionDelphinusCardsGrid"
    ],
    "CosmosElementDocumentListItemParent": [
      "CosmosElementDocumentList"
    ],
    "CosmosElementDownloadButtonParent": [
      "CosmosElementDownloadCard"
    ],
    "CosmosElementDownloadCardParent": [
      "CosmosElementDownloadStep",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable"
    ],
    "CosmosElementDownloadCardctaUnion": [
      "CosmosElementButton",
      "CosmosElementDownloadButton",
      "CosmosElementIconButton",
      "CosmosElementLink",
      "CosmosElementRichText"
    ],
    "CosmosElementDownloadStepParent": [
      "CosmosSectionDownloadCard"
    ],
    "CosmosElementEdsIconLinkParent": [
      "CosmosElementIconLinkGroup"
    ],
    "CosmosElementEventsTableRowParent": [
      "CosmosSectionEventsTable"
    ],
    "CosmosElementFAQItemParent": [
      "CosmosElementFaqTab",
      "CosmosSectionFaq"
    ],
    "CosmosElementFaqTabParent": [
      "CosmosSectionFaqSearch"
    ],
    "CosmosElementFeatureCardParent": [
      "CosmosSectionFeatureCard"
    ],
    "CosmosElementGameDevFeatureCardParent": [
      "CosmosElementAccordionFeatureCard",
      "CosmosSectionGameDevFeatureCard"
    ],
    "CosmosElementGameDevFeatureCardmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementGeminiCardParent": [
      "CosmosPageSearch",
      "CosmosSectionGeminiCard"
    ],
    "CosmosElementGeminiCardmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementGeminiLinkParent": [
      "CosmosElementGeminiCard"
    ],
    "CosmosElementGithubGistParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementHydrusColumnParent": [
      "CosmosSectionHydrusColumnList"
    ],
    "CosmosElementHydrusLinkParent": [
      "CosmosElementHydrusColumn"
    ],
    "CosmosElementIconButtonParent": [
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard",
      "CosmosElementBlogCard",
      "CosmosElementCalloutCard",
      "CosmosElementDownloadCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementIconSectionHeading",
      "CosmosElementLicenseContactCard",
      "CosmosElementLicenseSeat",
      "CosmosElementNewsMediaCard",
      "CosmosElementPluginListItem",
      "CosmosElementSectionHeading",
      "CosmosElementTabbedFullWidthAssetItem",
      "CosmosElementUserProfile",
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow",
      "CosmosSectionContentLargeImage",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNumberCallout",
      "CosmosSectionOrionCards",
      "CosmosSectionSimpleCta"
    ],
    "CosmosElementIconLinkGroupParent": [
      "CosmosPageBlogDetail"
    ],
    "CosmosElementIconSectionHeadingParent": [
      "CosmosConfigSection"
    ],
    "CosmosElementIconSectionHeadingmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementImageTagParent": [
      "CosmosConfigBlog",
      "CosmosElementNewsCard"
    ],
    "CosmosElementIndustryParent": [
      "CosmosRefIndustryList"
    ],
    "CosmosElementInterviewParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementInterviewQuestionParent": [
      "CosmosElementInterview"
    ],
    "CosmosElementLearnDocumentationCardParent": [
      "ElementLearnCategory"
    ],
    "CosmosElementLearnImageCardParent": [
      "ElementLearnCategory"
    ],
    "CosmosElementLearnImageCardSourceParent": [
      "CosmosElementLearnImageCard"
    ],
    "CosmosElementLearnTabParent": [
      "CosmosSectionLearn"
    ],
    "CosmosElementLicenseCardCoreParent": [
      "CosmosElementLicenseCardCore",
      "CosmosElementLicenseMainCard"
    ],
    "CosmosElementLicenseCardTopParent": [
      "CosmosElementLicenseMainCard"
    ],
    "CosmosElementLicenseCollapsedCardParent": [
      "CosmosSectionLicensesCollapsed"
    ],
    "CosmosElementLicenseContactCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosSectionSlimContactCard"
    ],
    "CosmosElementLicenseMainCardParent": [
      "CosmosPageLicense"
    ],
    "CosmosElementLicenseSeatParent": [
      "CosmosElementLicenseMainCard",
      "CosmosElementLicenseSeat"
    ],
    "CosmosElementLicenseTopCardParent": [
      "CosmosPageLicense",
      "CosmosSectionLicensesCollapsed"
    ],
    "CosmosElementLinkParent": [
      "CommunityCard",
      "CosmosElementDownloadCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementLearnDocumentationCard",
      "CosmosSectionCrux",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoMultiCard"
    ],
    "CosmosElementLogoMultiCardParent": [
      "CosmosSectionLogoMultiCard"
    ],
    "CosmosElementLogoParent": [
      "CosmosSectionLogoList"
    ],
    "CosmosElementNewsCardParent": [
      "CosmosSectionNewsCard"
    ],
    "CosmosElementNewsMediaCardParent": [
      "CosmosSectionNewsMediaCard"
    ],
    "CosmosElementNewsMediaCardmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementNumberCalloutParent": [
      "CosmosSectionNumberCallout"
    ],
    "CosmosElementOrionCardParent": [
      "CosmosSectionOrionCards"
    ],
    "CosmosElementPluginDownloadDetailParent": [
      "CosmosElementPluginDownload",
      "CosmosElementPluginListItem"
    ],
    "CosmosElementPluginDownloadParent": [
      "CosmosPagePluginDetail"
    ],
    "CosmosElementPluginListItemParent": [
      "CosmosSectionPluginListTable"
    ],
    "CosmosElementQuoteParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosSectionQuote"
    ],
    "CosmosElementResearchCardParent": [
      "CosmosPageResearch"
    ],
    "CosmosElementResellerCardParent": [
      "CosmosSectionResellersSearch"
    ],
    "CosmosElementRichTextParent": [
      "CosmosElementDownloadCard",
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementSearchFilterParent": [
      "CosmosPageSearch"
    ],
    "CosmosElementSectionHeadingParent": [
      "CosmosConfigSection",
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementSectionHeadingmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementSpeakerCardParent": [
      "CosmosSectionSpeakerCard"
    ],
    "CosmosElementTabbedBlogCardsItemParent": [
      "CosmosSectionTabbedBlogCard"
    ],
    "CosmosElementTabbedContentImageItemParent": [
      "CosmosSectionTabbedContentImage"
    ],
    "CosmosElementTabbedFullWidthAssetItemParent": [
      "CosmosSectionTabbedFullWidthAsset"
    ],
    "CosmosElementTagParent": [
      "CosmosElementDelphinusCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementNewsCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionFeatureCard"
    ],
    "CosmosElementTitleAndDescParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementUserProfileParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementUtCardParent": [
      "CosmosSectionUtCard"
    ],
    "CosmosElementVideoEmbedParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosSectionEmbed"
    ],
    "CosmosHeroAlphaParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroAlphamodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosHeroArticleImageParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroArticleImagemodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosHeroBravoParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroBravomodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosHeroGlowParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroGlowmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosPageAgreementheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageBlogDetailarticleComponentsUnion": [
      "CosmosElementAsset",
      "CosmosElementButtonList",
      "CosmosElementCalloutCard",
      "CosmosElementCkEditorText",
      "CosmosElementCompare",
      "CosmosElementGithubGist",
      "CosmosElementIconLinkGroup",
      "CosmosElementInterview",
      "CosmosElementLicenseContactCard",
      "CosmosElementQuote",
      "CosmosElementRichText",
      "CosmosElementSectionHeading",
      "CosmosElementTitleAndDesc",
      "CosmosElementUserProfile",
      "CosmosElementVideoEmbed",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionContentLargeImage",
      "CosmosSectionDivider",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionSimpleCta"
    ],
    "CosmosPageBlogDetailheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageDirectoryheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageHeroAndSectionheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageLegalContentheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageLegalContentsectionsUnion": [
      "CosmosElementCkEditorText",
      "CosmosElementCkEditorTextCollapsible"
    ],
    "CosmosPagePluginDetailarticleComponentsUnion": [
      "CosmosElementAsset",
      "CosmosElementButtonList",
      "CosmosElementCalloutCard",
      "CosmosElementCkEditorText",
      "CosmosElementCompare",
      "CosmosElementGithubGist",
      "CosmosElementInterview",
      "CosmosElementLicenseContactCard",
      "CosmosElementQuote",
      "CosmosElementRichText",
      "CosmosElementSectionHeading",
      "CosmosElementTitleAndDesc",
      "CosmosElementUserProfile",
      "CosmosElementVideoEmbed",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionContentLargeImage",
      "CosmosSectionDivider",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsMediaCard"
    ],
    "CosmosPagePluginDetailheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageResearchheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosReferenceSectionsectionUnion": [
      "CosmosSectionAccordionFeatureCard",
      "CosmosSectionAccordionTierCards",
      "CosmosSectionAriesCards",
      "CosmosSectionAsset",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionBlobTable",
      "CosmosSectionBlogCard",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionComplexCtaCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionCrux",
      "CosmosSectionDelphinusCardsGrid",
      "CosmosSectionDevelopersList",
      "CosmosSectionDivider",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable",
      "CosmosSectionEmbed",
      "CosmosSectionEventsTable",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionFeatureCard",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionGeminiCard",
      "CosmosSectionHydrusColumnList",
      "CosmosSectionLatestNews",
      "CosmosSectionLearn",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionNewsletterSignup",
      "CosmosSectionNumberCallout",
      "CosmosSectionOrionCards",
      "CosmosSectionPluginListTable",
      "CosmosSectionQuote",
      "CosmosSectionResellersSearch",
      "CosmosSectionRichText",
      "CosmosSectionSimpleCta",
      "CosmosSectionSlimContactCard",
      "CosmosSectionSpeakerCard",
      "CosmosSectionTabbedBlogCard",
      "CosmosSectionTabbedContentImage",
      "CosmosSectionTabbedFullWidthAsset",
      "CosmosSectionUtCard"
    ],
    "CosmosSectionAccordionFeatureCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionAccordionTierCardsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionAriesCardsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionAssetCarouselParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionAssetGalleryParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionAssetParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionBlobTableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionBlogCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionCkRichTextParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionCommunityParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionComplexCtaCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionContentLargeImageParent": [
      "CosmosPageBlogDetail",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionContentLargeImagemodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionContentSliderAssetParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionCruxParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDelphinusCardsGridParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDevelopersListParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDividerParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionDownloadCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDownloadableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionEmbedParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionEventsTableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionFaqParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionFaqSearchParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionFaqSearchmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionFaqmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionFeatureCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionGameDevFeatureCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionGeminiCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionHydrusColumnListParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLatestNewsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLearnParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLicensesCollapsedParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLogoListParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionLogoMultiCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionLogoMultiCardbuttonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionNewsCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionNewsMediaCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionNewsletterSignupParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionNumberCalloutParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionOrionCardsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionOrionCardsmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionPluginListTableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionQuoteParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionResellersSearchParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionRichTextParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionSimpleCtaParent": [
      "CosmosPageBlogDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionSlimContactCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionSpeakerCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionTabbedBlogCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionTabbedContentImageParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionTabbedFullWidthAssetParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionUtCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSeoParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageResearch",
      "CosmosPageSearch"
    ],
    "ElementLearnCategoryParent": [
      "CosmosSectionLearn"
    ],
    "ElementLearnCategorycardsUnion": [
      "CosmosElementLearnDocumentationCard",
      "CosmosElementLearnImageCard"
    ],
    "Entity": [
      "Asset",
      "CommunityCard",
      "CommunityResource",
      "CosmosConfigBlog",
      "CosmosConfigSection",
      "CosmosDetailServicePartner",
      "CosmosElementAccordionFeatureCard",
      "CosmosElementAccordionTierCard",
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard",
      "CosmosElementAgreementDetail",
      "CosmosElementAriesCard",
      "CosmosElementAsset",
      "CosmosElementAvatar",
      "CosmosElementBlogCard",
      "CosmosElementButton",
      "CosmosElementButtonList",
      "CosmosElementCalloutCard",
      "CosmosElementCheckListItem",
      "CosmosElementCkEditorText",
      "CosmosElementCkEditorTextCollapsible",
      "CosmosElementCompare",
      "CosmosElementComplexCtaCard",
      "CosmosElementCruxLink",
      "CosmosElementDelphinusCard",
      "CosmosElementDocumentList",
      "CosmosElementDocumentListItem",
      "CosmosElementDownloadButton",
      "CosmosElementDownloadCard",
      "CosmosElementDownloadStep",
      "CosmosElementEdsIconLink",
      "CosmosElementEventsTableRow",
      "CosmosElementFAQItem",
      "CosmosElementFaqTab",
      "CosmosElementFeatureCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementGeminiLink",
      "CosmosElementGithubGist",
      "CosmosElementHydrusColumn",
      "CosmosElementHydrusLink",
      "CosmosElementIconButton",
      "CosmosElementIconLinkGroup",
      "CosmosElementIconSectionHeading",
      "CosmosElementImageTag",
      "CosmosElementIndustry",
      "CosmosElementInterview",
      "CosmosElementInterviewQuestion",
      "CosmosElementLearnDocumentationCard",
      "CosmosElementLearnImageCard",
      "CosmosElementLearnImageCardSource",
      "CosmosElementLearnTab",
      "CosmosElementLicenseCardCore",
      "CosmosElementLicenseCardTop",
      "CosmosElementLicenseCollapsedCard",
      "CosmosElementLicenseContactCard",
      "CosmosElementLicenseMainCard",
      "CosmosElementLicenseSeat",
      "CosmosElementLicenseTopCard",
      "CosmosElementLink",
      "CosmosElementLogo",
      "CosmosElementLogoMultiCard",
      "CosmosElementNewsCard",
      "CosmosElementNewsMediaCard",
      "CosmosElementNumberCallout",
      "CosmosElementOrionCard",
      "CosmosElementPluginDownload",
      "CosmosElementPluginDownloadDetail",
      "CosmosElementPluginListItem",
      "CosmosElementQuote",
      "CosmosElementResearchCard",
      "CosmosElementResellerCard",
      "CosmosElementRichText",
      "CosmosElementSearchFilter",
      "CosmosElementSectionHeading",
      "CosmosElementSpeakerCard",
      "CosmosElementTabbedBlogCardsItem",
      "CosmosElementTabbedContentImageItem",
      "CosmosElementTabbedFullWidthAssetItem",
      "CosmosElementTag",
      "CosmosElementTitleAndDesc",
      "CosmosElementUserProfile",
      "CosmosElementUtCard",
      "CosmosElementVideoEmbed",
      "CosmosFeedBlogCard",
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow",
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageRedirect",
      "CosmosPageResearch",
      "CosmosPageSearch",
      "CosmosRefIndustryList",
      "CosmosReferenceFAQItem",
      "CosmosReferenceSection",
      "CosmosRemoteLearn",
      "CosmosSectionAccordionFeatureCard",
      "CosmosSectionAccordionTierCards",
      "CosmosSectionAriesCards",
      "CosmosSectionAsset",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionBlobTable",
      "CosmosSectionBlogCard",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionComplexCtaCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionCrux",
      "CosmosSectionDelphinusCardsGrid",
      "CosmosSectionDevelopersList",
      "CosmosSectionDivider",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable",
      "CosmosSectionEmbed",
      "CosmosSectionEventsTable",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionFeatureCard",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionGeminiCard",
      "CosmosSectionHydrusColumnList",
      "CosmosSectionLatestNews",
      "CosmosSectionLearn",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionNewsletterSignup",
      "CosmosSectionNumberCallout",
      "CosmosSectionOrionCards",
      "CosmosSectionPluginListTable",
      "CosmosSectionQuote",
      "CosmosSectionResellersSearch",
      "CosmosSectionRichText",
      "CosmosSectionSimpleCta",
      "CosmosSectionSlimContactCard",
      "CosmosSectionSpeakerCard",
      "CosmosSectionTabbedBlogCard",
      "CosmosSectionTabbedContentImage",
      "CosmosSectionTabbedFullWidthAsset",
      "CosmosSectionUtCard",
      "CosmosSeo",
      "ElementLearnCategory",
      "RemoteLearn",
      "ScheduledOperation",
      "ScheduledRelease",
      "User",
      "WfRefApplicationOwner",
      "WfRefBlogCategory",
      "WfRefBlogTag"
    ],
    "Node": [
      "Asset",
      "CosmosFeedBlogCard",
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageRedirect",
      "CosmosPageResearch",
      "CosmosPageSearch",
      "CosmosRefIndustryList",
      "CosmosReferenceFAQItem",
      "CosmosReferenceSection",
      "CosmosRemoteLearn",
      "RemoteLearn",
      "ScheduledOperation",
      "ScheduledRelease",
      "User",
      "WfRefApplicationOwner",
      "WfRefBlogCategory",
      "WfRefBlogTag"
    ],
    "ScheduledOperationAffectedDocument": [
      "Asset",
      "CosmosFeedBlogCard",
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageRedirect",
      "CosmosPageResearch",
      "CosmosPageSearch",
      "CosmosRefIndustryList",
      "CosmosReferenceFAQItem",
      "CosmosReferenceSection",
      "CosmosRemoteLearn",
      "RemoteLearn",
      "WfRefApplicationOwner",
      "WfRefBlogCategory",
      "WfRefBlogTag"
    ]
  }
};
      export default result;
    